import React, { useEffect } from 'react';
import { violinSampler, pianoSampler } from './violinSampler';

const CSS = `
  *{box-sizing:border-box;margin:0;padding:0;}
  html,body,#oa-root{height:100%;background:#1560bd;}
  #oa-root{font-family:'Georgia',serif;color:#fff;user-select:none;overflow-y:auto;overflow-x:hidden;}
  .screen{display:none;flex-direction:column;align-items:center;padding:18px 14px;min-height:100vh;}
  .screen.active{display:flex;}
  .modal-overlay{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:100;align-items:center;justify-content:center;pointer-events:none;}
  .modal-overlay.active{pointer-events:all;}
  .modal-overlay.active{display:flex;}
  .modal-box{background:#1560bd;border:1px solid rgba(255,255,255,0.2);border-radius:24px;padding:24px 20px;width:90%;max-width:360px;display:flex;flex-direction:column;align-items:center;gap:12px;max-height:90vh;overflow-y:auto;}
  @keyframes floatAnim{0%,100%{transform:translateY(0)}50%{transform:translateY(-8px)}}
  @keyframes fingerPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.35)}}
  .finger-pulse{transform-box:fill-box;transform-origin:center;animation:fingerPulse 0.6s ease-in-out 3;}
  @keyframes noteFlash{0%,100%{opacity:1}40%,60%{opacity:0}}
  .note-flash{animation:noteFlash 0.25s ease-in-out 1;}
  @keyframes bowStroke{0%{transform:scaleX(0);opacity:1}85%{opacity:0.8}100%{transform:scaleX(1);opacity:0}}
  .bow-stroke{height:4px;border-radius:2px;width:100%;max-width:390px;transform:scaleX(0);transform-origin:left center;opacity:0;margin:4px auto 0;display:block;}
  @keyframes tunerPulse{0%,100%{transform:scale(1)}50%{transform:scale(1.05)}}
  .tuner-pulse{animation:tunerPulse 0.65s ease-in-out 5;}
  .ob-highlight{outline:2px solid rgba(255,217,61,0.7)!important;border-radius:12px!important;box-shadow:0 0 18px rgba(255,217,61,0.35)!important;transition:box-shadow 0.3s,outline 0.3s;}
  .home-sec-glow{box-shadow:0 0 20px rgba(255,217,61,0.5)!important;border-color:rgba(255,217,61,0.8)!important;transition:all 0.3s;}
  @keyframes goldPulse{0%,100%{border-color:rgba(255,217,61,0.4)}50%{border-color:rgba(255,217,61,1);box-shadow:0 0 20px rgba(255,217,61,0.5)}}
  @keyframes musicHintPulse{0%,100%{opacity:0.45}50%{opacity:0.8}}
  @keyframes wrongShake{0%,100%{transform:translateX(0)}25%{transform:translateX(-6px)}75%{transform:translateX(6px)}}
  @keyframes correctFlash{0%{background:rgba(74,222,128,0.15)}100%{background:rgba(255,255,255,0.05)}}
  @keyframes revealPop{0%{transform:scale(0.85);opacity:0}60%{transform:scale(1.04)}100%{transform:scale(1);opacity:1}}
  @keyframes pulseHint{0%,100%{box-shadow:0 0 0 0 rgba(20,184,166,0.4)}50%{box-shadow:0 0 0 8px rgba(20,184,166,0)}}
  @keyframes badgeBounce{0%,100%{transform:scale(1)}20%{transform:scale(1.35)}40%{transform:scale(0.92)}60%{transform:scale(1.18)}80%{transform:scale(0.97)}}
  @keyframes bravoFlash{0%{opacity:0;transform:scale(0.7)}50%{opacity:1;transform:scale(1.08)}100%{opacity:1;transform:scale(1)}}
  @keyframes lightningPulse{0%,100%{box-shadow:0 0 0 0 rgba(251,191,36,0.5)}50%{box-shadow:0 0 0 10px rgba(251,191,36,0)}}
  @keyframes timerUrgent{0%,100%{opacity:1}50%{opacity:0.4}}
  .float{animation:floatAnim 3s ease-in-out infinite;}
  /* ── ONBOARDING ── */
  .onboard-screen{position:fixed;top:0;left:0;width:100%;height:100%;background:#1560bd;z-index:1000;display:flex;flex-direction:column;align-items:center;justify-content:space-between;padding:40px 24px 32px;transition:opacity 0.4s;}
  .onboard-screen.hidden{opacity:0;pointer-events:none;}
  .onboard-skip{position:absolute;top:16px;right:20px;font-size:13px;color:rgba(255,255,255,0.4);cursor:pointer;padding:8px;font-family:Georgia,serif;}
  .onboard-content{display:flex;flex-direction:column;align-items:center;gap:20px;flex:1;justify-content:center;text-align:center;max-width:340px;}
  .onboard-emoji{font-size:100px;line-height:1;animation:floatAnim 2s ease-in-out infinite;filter:drop-shadow(0 0 20px rgba(255,255,255,0.3));}
  .onboard-emoji-grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;width:100%;}
  .onboard-emoji-cell{background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.25);border-radius:16px;padding:16px;display:flex;flex-direction:column;align-items:center;gap:8px;}
  .onboard-emoji-cell .oe-icon{font-size:40px;filter:drop-shadow(0 0 8px rgba(255,255,255,0.4));}
  .onboard-emoji-cell .oe-label{font-size:13px;font-weight:800;color:#fff;}
  .onboard-title{font-size:28px;font-weight:900;line-height:1.2;}
  .onboard-subtitle{font-size:16px;color:rgba(255,255,255,0.9);line-height:1.6;font-weight:500;}
  .onboard-dots{display:flex;gap:8px;justify-content:center;}
  .onboard-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.2);transition:all 0.3s;}
  .onboard-dot.active{background:#fff;width:24px;border-radius:4px;}
  .onboard-btn{width:100%;max-width:340px;padding:16px;border-radius:18px;font-size:17px;font-weight:900;cursor:pointer;font-family:Georgia,serif;border:none;transition:all 0.2s;letter-spacing:0.03em;}
  .onboard-btn-next{background:linear-gradient(135deg,#4ade80,#22d3ee);color:#000;}
  .onboard-btn-start{background:linear-gradient(135deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff);color:#000;font-size:18px;}

  /* ── SETTINGS MODAL ── */
  .settings-modal{background:#1560bd;border:1px solid rgba(255,255,255,0.2);border-radius:24px;padding:24px 20px;width:90%;max-width:360px;display:flex;flex-direction:column;gap:14px;max-height:90vh;overflow-y:auto;}
  .settings-row-item{display:flex;align-items:center;justify-content:space-between;padding:12px 0;border-bottom:1px solid rgba(255,255,255,0.06);}
  .settings-label{font-size:14px;font-weight:600;color:rgba(255,255,255,0.8);}
  .settings-sublabel{font-size:11px;color:rgba(255,255,255,0.35);margin-top:2px;}

  /* ── CHORD PLAY ── */
  .btn-chordplay{background:rgba(249,115,22,0.15);border:1px solid rgba(249,115,22,0.5);color:#f97316;}
  .cp-score-bar{width:100%;max-width:390px;height:6px;background:rgba(255,255,255,0.08);border-radius:3px;overflow:hidden;margin-bottom:4px;}
  .cp-score-fill{height:100%;border-radius:3px;transition:width 0.3s,background 0.3s;width:0%;}
  .cp-note-dots{display:flex;gap:8px;justify-content:center;flex-wrap:wrap;margin:8px 0;}
  .cp-result-box{width:100%;max-width:390px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:24px;padding:28px 20px;display:flex;flex-direction:column;align-items:center;gap:12px;text-align:center;}

  /* ── STANDALONE METRONOME ── */
  .metro-screen-wrap{width:100%;max-width:390px;display:flex;flex-direction:column;align-items:center;gap:16px;}
  .metro-beat-display{display:flex;gap:12px;justify-content:center;align-items:center;margin:8px 0;}
  .metro-beat-circle{border-radius:50%;transition:transform 0.05s,background 0.05s,box-shadow 0.05s;}
  .metro-beat-circle.beat1{width:64px;height:64px;background:rgba(255,107,107,0.15);border:2px solid rgba(255,107,107,0.3);}
  .metro-beat-circle.beat-other{width:44px;height:44px;background:rgba(255,255,255,0.06);border:2px solid rgba(255,255,255,0.12);}
  .metro-beat-circle.active.beat1{background:#ff6b6b;box-shadow:0 0 30px rgba(255,107,107,0.7);transform:scale(1.15);}
  .metro-beat-circle.active.beat-other{background:rgba(255,255,255,0.7);box-shadow:0 0 15px rgba(255,255,255,0.4);transform:scale(1.1);}
  .metro-bpm-big{font-size:80px;font-weight:900;color:#fff;line-height:1;text-align:center;text-shadow:0 0 30px rgba(255,255,255,0.2);}
  .metro-bpm-unit-big{font-size:14px;color:rgba(255,255,255,0.4);letter-spacing:0.2em;text-align:center;margin-top:-8px;}
  .metro-slider-big{width:100%;-webkit-appearance:none;appearance:none;height:10px;border-radius:5px;background:linear-gradient(90deg,#4ade80,#fbbf24,#fb923c,#f87171);outline:none;cursor:pointer;}
  .metro-slider-big::-webkit-slider-thumb{-webkit-appearance:none;width:26px;height:26px;border-radius:50%;background:#fff;cursor:pointer;border:3px solid #1560bd;box-shadow:0 0 10px rgba(255,255,255,0.5);}
  .metro-presets-big{display:flex;gap:8px;justify-content:center;flex-wrap:wrap;}
  .metro-preset-big{padding:8px 14px;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;font-family:Georgia,serif;border:1px solid;transition:all 0.15s;}
  .metro-start-btn{width:100%;padding:18px;border-radius:18px;font-size:18px;font-weight:900;cursor:pointer;font-family:Georgia,serif;border:none;transition:all 0.2s;letter-spacing:0.05em;}
  .metro-start-btn.playing{background:linear-gradient(135deg,#f87171,#fb923c);color:#fff;box-shadow:0 0 30px rgba(248,113,113,0.4);}
  .metro-start-btn.stopped{background:linear-gradient(135deg,#4ade80,#22d3ee);color:#000;box-shadow:0 0 30px rgba(74,222,128,0.3);}
  .metro-timesig-row{display:flex;gap:8px;justify-content:center;}
  .metro-timesig-btn{padding:8px 16px;border-radius:10px;font-size:13px;font-weight:700;cursor:pointer;font-family:Georgia,serif;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.15);color:rgba(255,255,255,0.5);transition:all 0.15s;}
  .metro-timesig-btn.selected{background:rgba(96,165,250,0.15);border-color:#60a5fa;color:#60a5fa;}
  .tap-tempo-btn{width:100%;padding:14px;border-radius:14px;background:rgba(199,125,255,0.12);border:2px solid rgba(199,125,255,0.4);color:#c77dff;font-size:15px;font-weight:800;cursor:pointer;font-family:Georgia,serif;transition:all 0.1s;}
  .tap-tempo-btn:active{transform:scale(0.96);background:rgba(199,125,255,0.25);}
  .metro-tuner-link{width:100%;padding:11px;border-radius:12px;background:rgba(255,217,61,0.08);border:1px solid rgba(255,217,61,0.3);color:#ffd93d;font-size:13px;font-weight:700;cursor:pointer;font-family:Georgia,serif;display:flex;align-items:center;justify-content:center;gap:8px;}
  /* ── PRACTICE MODES BUTTONS ── */
  .practice-modes{width:100%;max-width:360px;display:flex;flex-direction:column;gap:8px;margin-top:8px;}
  .practice-mode-btn{width:100%;display:flex;align-items:center;gap:12px;padding:13px 16px;border-radius:16px;cursor:pointer;font-family:Georgia,serif;font-size:14px;font-weight:700;transition:all 0.2s;border:none;}
  .practice-mode-btn .pm-icon{font-size:26px;width:36px;text-align:center;flex-shrink:0;filter:drop-shadow(0 0 6px currentColor) brightness(1.4);}
  .practice-mode-btn .pm-info{flex:1;text-align:left;}
  .practice-mode-btn .pm-title{font-size:14px;font-weight:800;}
  .practice-mode-btn .pm-sub{font-size:10px;opacity:0.7;margin-top:2px;}
  .practice-mode-btn .pm-arrow{font-size:18px;opacity:0.6;}
  .btn-flashcard{background:rgba(20,184,166,0.15);border:1px solid rgba(20,184,166,0.5);color:#2dd4bf;}
  .btn-flashplay{background:rgba(196,181,253,0.15);border:1px solid rgba(196,181,253,0.5);color:#c4b5fd;}
  .btn-scaleplay{background:rgba(251,191,36,0.15);border:1px solid rgba(251,191,36,0.5);color:#fbbf24;}

  /* ── RANGE SELECTOR ── */
  .range-modal-box{background:#1560bd;border:1px solid rgba(255,255,255,0.2);border-radius:24px;padding:20px 18px;width:90%;max-width:360px;display:flex;flex-direction:column;align-items:center;gap:10px;max-height:90vh;overflow-y:auto;}
  .range-section-title{font-size:11px;letter-spacing:0.12em;color:rgba(255,255,255,0.4);text-align:center;font-weight:700;}
  .range-preset-row{display:flex;gap:6px;flex-wrap:wrap;justify-content:center;width:100%;}
  .range-preset-btn{padding:7px 12px;border-radius:10px;font-size:12px;font-weight:700;cursor:pointer;font-family:Georgia,serif;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.6);transition:all 0.15s;}
  .range-preset-btn.selected{background:rgba(96,165,250,0.2);border-color:#60a5fa;color:#60a5fa;}
  .string-toggle-row{display:flex;gap:8px;justify-content:center;}
  .string-toggle-btn{width:52px;height:52px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;cursor:pointer;font-family:Georgia,serif;border:2px solid rgba(255,255,255,0.15);background:rgba(0,0,0,0.3);transition:all 0.15s;}
  .string-toggle-btn.selected{transform:scale(1.1);}
  .string-toggle-btn .st-letter{font-size:18px;font-weight:700;}
  .string-toggle-btn .st-freq{font-size:8px;opacity:0.5;margin-top:1px;}
  .accidental-toggle{display:flex;align-items:center;justify-content:space-between;width:100%;padding:10px 14px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:12px;}
  .acc-toggle-switch{width:36px;height:20px;border-radius:10px;background:rgba(255,255,255,0.1);position:relative;cursor:pointer;transition:background 0.2s;}
  .acc-toggle-switch.on{background:#a78bfa;}
  .acc-toggle-switch::after{content:'';position:absolute;width:16px;height:16px;border-radius:50%;background:#fff;top:2px;left:2px;transition:left 0.2s;}
  .acc-toggle-switch.on::after{left:18px;}
  .range-start-btn{width:100%;padding:13px;border-radius:14px;font-size:15px;font-weight:800;cursor:pointer;font-family:Georgia,serif;border:none;margin-top:4px;}

  /* ── FLASHCARD SCREEN ── */
  .fc-header{width:100%;max-width:390px;display:flex;align-items:center;margin-bottom:12px;gap:8px;}
  .fc-progress{font-size:12px;color:rgba(255,255,255,0.4);min-width:50px;text-align:right;}
  .fc-card{width:100%;max-width:390px;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.12);border-radius:24px;padding:20px;display:flex;flex-direction:column;align-items:center;gap:12px;margin-bottom:12px;min-height:280px;justify-content:center;}
  .fc-note-label{font-size:13px;color:rgba(255,255,255,0.35);letter-spacing:0.1em;}
  .fc-note-name{font-size:48px;font-weight:900;text-align:center;}
  .fc-reveal-btn{width:100%;max-width:390px;padding:14px;border-radius:14px;background:rgba(20,184,166,0.15);border:2px solid rgba(20,184,166,0.5);color:#2dd4bf;font-size:15px;font-weight:800;cursor:pointer;font-family:Georgia,serif;margin-bottom:8px;}
  .fc-nav-row{display:flex;gap:10px;width:100%;max-width:390px;}
  .fc-prev{flex:1;padding:12px;border-radius:12px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.15);color:rgba(255,255,255,0.5);font-size:13px;cursor:pointer;font-family:Georgia,serif;}
  .fc-next{flex:2;padding:12px;border-radius:12px;background:rgba(20,184,166,0.12);border:1px solid rgba(20,184,166,0.3);color:#2dd4bf;font-size:13px;font-weight:700;cursor:pointer;font-family:Georgia,serif;}

  /* ── SCALE PLAY SCREEN ── */
  .scale-selector{width:100%;max-width:390px;margin-bottom:10px;}
  .scale-grid{display:grid;grid-template-columns:1fr 1fr;gap:6px;}
  .scale-btn{padding:10px 8px;border-radius:12px;font-size:12px;font-weight:700;cursor:pointer;font-family:Georgia,serif;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.6);text-align:center;transition:all 0.15s;}
  .scale-btn.selected{background:rgba(251,191,36,0.15);border-color:#fbbf24;color:#fbbf24;}
  .scale-progress-dots{display:flex;gap:4px;justify-content:center;flex-wrap:wrap;margin-bottom:8px;}
  .scale-dot{width:10px;height:10px;border-radius:50%;background:rgba(255,255,255,0.15);transition:all 0.2s;}
  .scale-dot.done{background:#4ade80;}
  .scale-dot.current{background:#fbbf24;transform:scale(1.3);}
  .scale-dir-label{font-size:11px;color:rgba(255,255,255,0.4);text-align:center;letter-spacing:0.1em;margin-bottom:4px;}


  /* ── HOME TITLE ── */
  .home-title-wrap{display:flex;flex-direction:column;align-items:center;margin-bottom:6px;}
  @keyframes shimmer{
    0%{background-position:0% 50%;}
    50%{background-position:100% 50%;}
    100%{background-position:0% 50%;}
  }
  .home-title-top{
    font-size:30px;font-weight:900;letter-spacing:0.02em;line-height:1.1;
    background:linear-gradient(270deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff,#c77dff,#ff6b6b);
    background-size:400% 400%;
    -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
    animation:shimmer 4s ease infinite;
  }
  .home-title-game{font-size:42px;font-weight:900;letter-spacing:0.1em;color:#60a5fa;line-height:1;text-shadow:0 0 30px rgba(96,165,250,0.5),0 0 60px rgba(96,165,250,0.2);}
  .home-sub{font-size:11px;letter-spacing:0.25em;margin-bottom:14px;width:100%;text-align:center;font-weight:800;}
  .home-sub span:nth-child(1){color:#ff6b6b;}
  .home-sub span:nth-child(2){color:#ffd93d;}
  .home-sub span:nth-child(3){color:#6bcb77;}
  .home-sub span:nth-child(4){color:#4d96ff;}

.tuner-home-btn{width:100%;max-width:360px;display:flex;align-items:center;justify-content:center;gap:10px;padding:12px 18px;background:linear-gradient(135deg,rgba(255,107,107,0.15),rgba(255,217,61,0.15));border:1px solid rgba(255,217,61,0.4);border-radius:14px;cursor:pointer;font-family:Georgia,serif;font-size:13px;color:#ffd93d;font-weight:800;margin-bottom:12px;transition:all 0.2s;}
  .bpm-card{width:100%;max-width:360px;background:rgba(77,150,255,0.06);border:1px solid rgba(77,150,255,0.2);border-radius:18px;padding:14px 16px;margin-bottom:12px;}
  .bpm-title{font-size:11px;letter-spacing:0.12em;color:#4d96ff;margin-bottom:10px;text-align:center;font-weight:700;}
  .bpm-row{display:flex;align-items:center;gap:12px;}
  .bpm-display{font-size:40px;font-weight:900;color:#4d96ff;line-height:1;min-width:65px;text-shadow:0 0 20px rgba(77,150,255,0.4);}
  .bpm-unit{font-size:10px;color:#4d96ff;letter-spacing:0.15em;font-weight:700;}
  .bpm-slider-wrap{flex:1;}
  .bpm-slider{width:100%;-webkit-appearance:none;appearance:none;height:8px;border-radius:4px;background:linear-gradient(90deg,#4ade80,#fbbf24,#fb923c,#f87171);outline:none;cursor:pointer;}
  .bpm-slider::-webkit-slider-thumb{-webkit-appearance:none;width:22px;height:22px;border-radius:50%;background:#fff;cursor:pointer;border:3px solid #1560bd;box-shadow:0 0 8px rgba(255,255,255,0.4);}
  .bpm-presets{display:flex;gap:5px;justify-content:center;margin-top:8px;flex-wrap:wrap;}
  .bpm-preset{border-radius:8px;padding:4px 10px;font-size:11px;font-weight:700;cursor:pointer;font-family:Georgia,serif;border:1px solid;}
  .bpm-preset[data-bpm="40"]{background:rgba(74,222,128,0.12);border-color:rgba(74,222,128,0.4);color:#4ade80;}
  .bpm-preset[data-bpm="60"]{background:rgba(96,165,250,0.12);border-color:rgba(96,165,250,0.4);color:#60a5fa;}
  .bpm-preset[data-bpm="80"]{background:rgba(251,191,36,0.12);border-color:rgba(251,191,36,0.4);color:#fbbf24;}
  .bpm-preset[data-bpm="100"]{background:rgba(251,146,60,0.12);border-color:rgba(251,146,60,0.4);color:#fb923c;}
  .bpm-preset[data-bpm="120"]{background:rgba(248,113,113,0.12);border-color:rgba(248,113,113,0.4);color:#f87171;}
  .bpm-preset.active{filter:brightness(1.4);box-shadow:0 0 10px currentColor;}
  .settings-row{width:100%;max-width:360px;display:flex;gap:10px;margin-bottom:12px;}
  .setting-toggle:nth-child(1) .st-left{color:#6bcb77;}
  .setting-toggle:nth-child(2) .st-left{color:#c77dff;}
  .setting-toggle{flex:1;display:flex;align-items:center;justify-content:space-between;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.12);border-radius:14px;padding:11px 14px;cursor:pointer;transition:all 0.2s;}
  #toggle-metro{border-color:rgba(107,203,119,0.35);background:rgba(107,203,119,0.07);}
  #toggle-ambient{border-color:rgba(199,125,255,0.35);background:rgba(199,125,255,0.07);}
  .setting-toggle.on{border-color:rgba(74,222,128,0.4);background:rgba(74,222,128,0.06);}
  .st-left{display:flex;align-items:center;gap:7px;font-size:12px;font-weight:600;}
  .st-dot{width:8px;height:8px;border-radius:50%;background:rgba(255,255,255,0.2);transition:background 0.2s;}
  .setting-toggle.on .st-dot{background:#4ade80;box-shadow:0 0 6px #4ade80;}
  .st-status{font-size:10px;color:rgba(255,255,255,0.3);}
  .setting-toggle.on .st-status{color:rgba(74,222,128,0.7);}

  /* ── LEVEL CARDS ── */
  .level-card{background:rgba(255,255,255,0.07);border-radius:16px;padding:13px 15px;cursor:pointer;transition:all 0.2s ease;display:flex;align-items:center;gap:13px;margin-bottom:8px;width:100%;max-width:360px;border:1px solid rgba(255,255,255,0.1);position:relative;}
  .level-card:active{transform:scale(0.98);}
  .level-card *{pointer-events:none;}
  .level-card:active{background:rgba(255,255,255,0.13);}
  .level-icon{width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:20px;flex-shrink:0;}

  /* ── SPEED POPUP ── */
  .speed-popup-title{font-size:16px;font-weight:900;text-align:center;}
  .speed-popup-venue{font-size:11px;color:rgba(255,255,255,0.4);text-align:center;margin-top:-4px;}
  .speed-divider{width:100%;height:1px;background:rgba(255,255,255,0.08);}
  .speed-option{width:100%;display:flex;align-items:center;gap:14px;padding:16px 18px;border-radius:16px;cursor:pointer;border:1px solid rgba(255,255,255,0.1);background:rgba(255,255,255,0.06);transition:all 0.2s;}
  .speed-option:hover{background:rgba(255,255,255,0.09);transform:translateX(2px);}
  .speed-option.lightning-opt{border-color:rgba(251,191,36,0.4);background:rgba(251,191,36,0.06);animation:lightningPulse 2s ease-in-out infinite;}
  .speed-icon{font-size:22px;width:32px;text-align:center;flex-shrink:0;}
  .speed-info{flex:1;}
  .speed-name{font-size:17px;font-weight:800;
  .speed-desc{font-size:12px;color:#a78bfa;margin-top:3px;font-weight:600;}}
  .speed-time{font-size:11px;color:rgba(255,255,255,0.4);margin-top:1px;}
  .speed-cancel{width:100%;padding:11px;border-radius:12px;background:rgba(248,113,113,0.1);border:1px solid rgba(248,113,113,0.35);color:#f87171;font-size:13px;font-weight:700;cursor:pointer;font-family:Georgia,serif;}

  /* ── TUNER ── */
  .tuner-title{font-size:18px;font-weight:900;text-align:center;}
  .tuner-subtitle{font-size:13px;color:#fff;text-align:center;line-height:1.5;font-weight:600;}
  .tuner-strings{display:flex;gap:10px;justify-content:center;margin:4px 0;}
  .tuner-str{width:48px;height:48px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;border:2px solid rgba(255,255,255,0.12);background:rgba(0,0,0,0.25);transition:all 0.15s;}
  .tuner-str.active{transform:scale(1.15);}
  .tuner-str .ts-letter{font-size:18px;font-weight:700;}
  .tuner-str .ts-freq{font-size:8px;color:rgba(255,255,255,0.4);margin-top:1px;}
  .gauge-wrap{position:relative;width:300px;height:180px;margin:0 auto;}
  .gauge-svg{width:100%;height:100%;}
  .gauge-center-note{font-size:42px;font-weight:900;text-align:center;transition:color 0.1s,opacity 0.1s;letter-spacing:0.02em;margin-top:-8px;}
  .gauge-info{display:flex;justify-content:space-between;width:260px;font-size:11px;color:rgba(255,255,255,0.4);margin-top:2px;}
  .tuner-status{font-size:14px;font-weight:800;text-align:center;min-height:22px;transition:color 0.15s;letter-spacing:0.03em;}
  .tuner-close-btn{width:100%;padding:12px;border-radius:14px;background:rgba(74,222,128,0.15);border:1px solid rgba(74,222,128,0.4);color:#4ade80;font-size:14px;font-weight:700;cursor:pointer;font-family:Georgia,serif;margin-top:4px;}

  /* ── COUNTDOWN ── */
  .countdown-overlay{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.8);z-index:50;align-items:center;justify-content:center;flex-direction:column;gap:12px;}
  .countdown-overlay.active{display:flex;}
  .countdown-num{font-size:96px;font-weight:900;color:#fff;line-height:1;}
  .countdown-msg{font-size:16px;color:rgba(255,255,255,0.6);letter-spacing:0.05em;}

  /* ── CONFETTI / BANNERS ── */
  #oa-confetti-canvas{position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:200;display:none;}
  .bravo-banner{display:none;position:fixed;top:0;left:0;width:100%;z-index:201;justify-content:center;padding-top:60px;}
  .bravo-banner.active{display:flex;}
  .bravo-text{font-size:52px;font-weight:900;letter-spacing:0.05em;animation:bravoFlash 0.6s ease forwards;text-shadow:0 0 30px currentColor;}
  .lightning-banner{display:none;position:fixed;top:0;left:0;width:100%;z-index:50;background:linear-gradient(90deg,rgba(251,191,36,0.15),rgba(251,191,36,0.3),rgba(251,191,36,0.15));border-bottom:1px solid rgba(251,191,36,0.4);padding:8px;text-align:center;font-size:13px;font-weight:700;color:#fbbf24;letter-spacing:0.1em;}
  .lightning-banner.active{display:block;}

  /* ── AUDITION ── */
  .top-bar{width:100%;max-width:390px;display:flex;align-items:center;margin-bottom:10px;gap:8px;}
  .exit-btn{background:rgba(248,113,113,0.1);border:1px solid rgba(248,113,113,0.35);color:#f87171;border-radius:8px;padding:6px 11px;font-size:12px;font-weight:700;cursor:pointer;font-family:Georgia,serif;}
  .top-venue{flex:1;text-align:center;}
  .top-level-name{font-size:12px;letter-spacing:0.08em;}
  .top-venue-name{font-size:10px;color:rgba(255,255,255,0.35);margin-top:1px;}
  .speed-badge{display:inline-block;font-size:10px;padding:2px 8px;border-radius:10px;font-weight:700;margin-top:2px;}
  .note-counter{background:rgba(255,255,255,0.08);border-radius:8px;padding:4px 10px;font-size:12px;color:rgba(255,255,255,0.55);}
  .progress-track{width:100%;max-width:390px;height:4px;background:rgba(255,255,255,0.1);border-radius:2px;margin-bottom:10px;overflow:hidden;}
  .progress-fill{height:100%;border-radius:2px;transition:width 0.4s ease;}
  .level-timer-row{width:100%;max-width:390px;display:flex;align-items:center;gap:10px;margin-bottom:9px;}
  .level-timer-track{flex:1;height:8px;background:rgba(255,255,255,0.08);border-radius:4px;overflow:hidden;}
  .level-timer-fill{height:100%;border-radius:4px;transition:width 1s linear,background 0.3s ease;}
  .level-timer-fill.urgent{animation:timerUrgent 0.5s ease-in-out infinite;}
  .level-timer-num{font-size:20px;font-weight:900;min-width:36px;text-align:right;transition:color 0.2s;}
  .metro-bar{width:100%;max-width:390px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:12px;padding:8px 12px;margin-bottom:9px;display:flex;align-items:center;gap:10px;}
  .metro-label{font-size:9px;color:rgba(255,255,255,0.25);letter-spacing:0.1em;}
  .metro-beats{display:flex;gap:4px;flex:1;}
  .metro-dot{width:10px;height:10px;border-radius:50%;background:rgba(255,255,255,0.1);transition:background 0.05s,transform 0.05s;flex-shrink:0;}
  .metro-dot.beat1{width:12px;height:12px;}
  .metro-dot.active.beat1{background:#fff;transform:scale(1.3);}
  .metro-dot.active{background:rgba(255,255,255,0.6);transform:scale(1.15);}
  .metro-bpm-tag{font-size:11px;color:rgba(255,255,255,0.3);}
  .ready-zone{width:100%;max-width:390px;background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.1);border-radius:14px;padding:10px 15px;margin-bottom:9px;display:flex;align-items:center;gap:12px;}
  .countdown-ring{flex-shrink:0;position:relative;width:44px;height:44px;}
  .countdown-ring svg{position:absolute;top:0;left:0;transform:rotate(-90deg);}
  .ring-bg{fill:none;stroke:rgba(255,255,255,0.1);stroke-width:3;}
  .ring-fill{fill:none;stroke-width:3;stroke-linecap:round;}
  .ring-num{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);font-size:14px;font-weight:700;}
  .ready-info{flex:1;}
  .ready-title{font-size:13px;font-weight:700;margin-bottom:2px;}
  .ready-sub{font-size:11px;color:rgba(255,255,255,0.4);line-height:1.4;}
  .vol-meter{width:100%;max-width:390px;margin-bottom:9px;}
  .vol-label{display:flex;justify-content:space-between;font-size:10px;color:rgba(255,255,255,0.3);margin-bottom:3px;}
  .vol-track{height:5px;background:rgba(255,255,255,0.08);border-radius:3px;overflow:hidden;position:relative;}
  .vol-fill{height:100%;border-radius:3px;transition:width 0.05s ease,background 0.2s ease;}
  .vol-threshold{position:absolute;top:0;height:100%;width:2px;background:rgba(255,165,0,0.7);}
  .game-area{width:100%;max-width:390px;display:flex;gap:9px;margin-bottom:9px;align-items:flex-start;}
  .staff-card{flex:1;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:18px;padding:14px 12px;transition:border-color 0.3s ease;display:flex;flex-direction:column;align-items:center;}
  .staff-card.correct{border-color:rgba(74,222,128,0.5);animation:correctFlash 0.5s ease forwards;}
  .staff-card.wrong-string{border-color:rgba(251,146,60,0.5);animation:wrongShake 0.4s ease;}
  .staff-card.wrong-note{border-color:rgba(248,113,113,0.5);animation:wrongShake 0.4s ease;}
  .staff-card.timeout{border-color:rgba(248,113,113,0.7);}
  .judge-label{font-size:9px;color:rgba(255,255,255,0.3);letter-spacing:0.1em;margin-bottom:8px;text-align:center;}
  .note-display{font-size:32px;font-weight:900;transition:color 0.2s;margin:4px 0 2px;text-align:center;}
  .note-display.correct{color:#4ade80;}
  .note-display.wrong{color:#f87171;}
  .note-display.neutral{color:#fff;}
  .expected-str{font-size:10px;color:rgba(255,255,255,0.35);text-align:center;margin-bottom:6px;}
  .feedback-area{text-align:center;min-height:38px;}
  .feedback-main{font-size:13px;font-weight:700;transition:color 0.2s;}
  .feedback-sub{font-size:10px;color:rgba(255,255,255,0.7);margin-top:3px;line-height:1.45;}
  .hint-btn{width:100%;max-width:390px;margin-bottom:9px;display:flex;align-items:center;justify-content:center;gap:10px;padding:9px 18px;background:rgba(20,184,166,0.1);border:1px solid rgba(20,184,166,0.35);border-radius:14px;cursor:pointer;font-family:Georgia,serif;font-size:13px;color:rgba(153,246,228,0.9);font-weight:600;transition:all 0.2s ease;animation:pulseHint 2.5s ease-in-out infinite;}
  .emoji-badge{width:28px;height:28px;border-radius:50%;background:rgba(20,184,166,0.2);border:1px solid rgba(20,184,166,0.5);display:flex;align-items:center;justify-content:center;font-size:15px;flex-shrink:0;}
  .fingerboard-card{width:134px;flex-shrink:0;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:18px;padding:10px 8px;display:flex;flex-direction:column;align-items:center;transition:border-color 0.3s ease;}
  .fingerboard-card.showing{border-color:rgba(251,146,60,0.45);}
  .fingerboard-card.correct-mode{border-color:rgba(74,222,128,0.4);}
  .fingerboard-card.popped{animation:revealPop 0.35s cubic-bezier(0.34,1.56,0.64,1) forwards;}
  .fb-title{font-size:9px;letter-spacing:0.1em;margin-bottom:4px;text-align:center;}
  .fb-note-name{font-size:20px;font-weight:900;text-align:center;margin-bottom:1px;}
  .fb-string-name{font-size:10px;text-align:center;margin-bottom:4px;}
  .fb-finger-label{font-size:9px;text-align:center;margin-top:3px;line-height:1.4;}
  .hidden{display:none!important;}
  .strings-section{width:100%;max-width:390px;margin-bottom:9px;}
  .strings-label{font-size:10px;color:rgba(255,255,255,0.3);text-align:center;margin-bottom:7px;letter-spacing:0.1em;}
  .strings-row{display:flex;gap:7px;justify-content:center;}
  .string-circle{width:52px;height:52px;border-radius:50%;display:flex;flex-direction:column;align-items:center;justify-content:center;transition:all 0.12s ease;border:2px solid rgba(255,255,255,0.12);background:rgba(0,0,0,0.25);}
  .string-circle .str-letter{font-size:17px;font-weight:700;}
  .string-circle .str-label{font-size:9px;color:rgba(255,255,255,0.7);}
  .score-section{width:100%;max-width:390px;margin-bottom:9px;}
  .score-bar-labels{display:flex;justify-content:space-between;font-size:11px;color:rgba(255,255,255,0.4);margin-bottom:3px;}
  .score-track{height:5px;background:rgba(255,255,255,0.1);border-radius:3px;overflow:hidden;}
  .score-fill{height:100%;border-radius:3px;transition:width 0.4s ease,background 0.3s ease;}
  .score-stats{display:flex;justify-content:space-between;font-size:11px;color:rgba(255,255,255,0.35);margin-top:3px;}
  .controls-row{display:flex;gap:8px;width:100%;max-width:390px;}
  .mic-status{flex:1;background:rgba(255,255,255,0.05);border:1px solid rgba(255,255,255,0.1);border-radius:10px;padding:7px 11px;font-size:11px;display:flex;align-items:center;gap:6px;}
  .mic-dot{width:7px;height:7px;border-radius:50%;flex-shrink:0;}
  .demo-btn{background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.2);color:rgba(255,255,255,0.7);border-radius:10px;padding:7px 13px;font-size:12px;cursor:pointer;font-family:Georgia,serif;}

  /* ── GAMEOVER ── */
  .gameover-screen{display:none;flex-direction:column;align-items:center;padding:24px 18px;min-height:100vh;justify-content:center;}
  .gameover-screen.active{display:flex;}
  .go-icon{font-size:64px;margin-bottom:12px;}
  .go-title{font-size:28px;font-weight:900;color:#f87171;margin-bottom:6px;}
  .go-note{font-size:14px;color:rgba(255,255,255,0.5);margin-bottom:6px;}
  .go-tempo{font-size:13px;color:rgba(255,255,255,0.35);margin-bottom:18px;}
  .go-question{font-size:15px;font-weight:700;color:#fff;margin-bottom:14px;text-align:center;}
  .go-btns{display:flex;flex-direction:column;gap:10px;width:100%;max-width:320px;}
  .go-btn-lower{padding:13px;border-radius:14px;background:rgba(196,181,253,0.15);border:1px solid rgba(196,181,253,0.4);color:#c4b5fd;font-size:14px;font-weight:700;cursor:pointer;font-family:Georgia,serif;}
  .go-btn-same{padding:13px;border-radius:14px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.2);color:#fff;font-size:14px;font-weight:600;cursor:pointer;font-family:Georgia,serif;}
  .go-btn-home{padding:11px;border-radius:12px;background:transparent;border:1px solid rgba(255,255,255,0.1);color:rgba(255,255,255,0.35);font-size:13px;cursor:pointer;font-family:Georgia,serif;margin-top:4px;}

  /* ── RESULTS ── */
  .results-icon{font-size:64px;margin-bottom:8px;}
  .results-icon.celebrate{animation:badgeBounce 0.8s ease forwards;}
  .results-title{font-size:24px;font-weight:900;margin-bottom:4px;}
  .results-venue{color:rgba(255,255,255,0.4);font-size:12px;letter-spacing:0.1em;margin-bottom:16px;}
  .score-card{width:100%;max-width:360px;background:rgba(255,255,255,0.06);border-radius:20px;padding:22px;margin-bottom:14px;position:relative;overflow:hidden;}
  .score-card-glow{position:absolute;top:-40px;left:50%;transform:translateX(-50%);width:200px;height:200px;border-radius:50%;opacity:0;transition:opacity 0.5s;pointer-events:none;}
  .big-score{font-size:68px;font-weight:900;line-height:1;text-align:center;margin-bottom:4px;}
  .passing-label{text-align:center;font-size:12px;color:rgba(255,255,255,0.35);margin-bottom:18px;}
  .stats-grid{display:grid;grid-template-columns:1fr 1fr 1fr;gap:10px;}
  .stat-box{background:rgba(255,255,255,0.05);border-radius:12px;padding:10px 8px;text-align:center;}
  .stat-num{font-size:24px;font-weight:700;}
  .stat-label{font-size:10px;color:rgba(255,255,255,0.35);margin-top:2px;}
  .unlock-box{width:100%;max-width:360px;border-radius:16px;padding:13px 17px;margin-bottom:10px;display:flex;align-items:center;gap:12px;}
  .action-btns{display:flex;gap:10px;width:100%;max-width:360px;flex-wrap:wrap;margin-bottom:8px;}
  .retry-btn{flex:1;padding:12px;border-radius:12px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.2);color:#fff;font-size:14px;font-weight:600;cursor:pointer;font-family:Georgia,serif;}
  .next-btn{flex:1;padding:12px;border-radius:12px;border:none;color:#000;font-size:14px;font-weight:700;cursor:pointer;font-family:Georgia,serif;}
  .faster-btn{flex:1;padding:12px;border-radius:12px;background:rgba(196,181,253,0.15);border:1px solid rgba(196,181,253,0.4);color:#c4b5fd;font-size:14px;font-weight:600;cursor:pointer;font-family:Georgia,serif;}
  .lightning-btn{width:100%;max-width:360px;padding:14px;border-radius:14px;background:linear-gradient(135deg,rgba(251,191,36,0.2),rgba(245,158,11,0.15));border:2px solid rgba(251,191,36,0.6);color:#fbbf24;font-size:15px;font-weight:900;cursor:pointer;font-family:Georgia,serif;margin-bottom:8px;letter-spacing:0.05em;animation:lightningPulse 2s ease-in-out infinite;}
  .home-btn{width:100%;max-width:360px;padding:11px;border-radius:12px;background:transparent;border:1px solid rgba(255,255,255,0.12);color:rgba(255,255,255,0.4);font-size:13px;cursor:pointer;font-family:Georgia,serif;}
  .res-next-prompt{font-size:13px;color:rgba(255,255,255,0.5);text-align:center;margin-bottom:10px;}

  /* ── SONG LEARNING ── */
  .btn-songlearn{background:rgba(250,204,21,0.15);border:1px solid rgba(250,204,21,0.5);color:#facc15;}
  .song-list{width:100%;max-width:390px;display:flex;flex-direction:column;gap:8px;}
  .song-card{width:100%;display:flex;align-items:center;gap:12px;padding:13px 16px;border-radius:16px;cursor:pointer;font-family:Georgia,serif;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.06);transition:all 0.2s;}
  .song-card-icon{font-size:28px;width:36px;text-align:center;flex-shrink:0;}
  .song-card-info{flex:1;text-align:left;}
  .song-card-title{font-size:14px;font-weight:800;color:#fff;}
  .song-card-sub{font-size:10px;color:rgba(255,255,255,0.5);margin-top:2px;}
  .sl-mode-row{display:flex;gap:8px;width:100%;max-width:390px;margin-bottom:8px;}
  .sl-mode-btn{flex:1;padding:9px 6px;border-radius:12px;font-size:12px;font-weight:700;cursor:pointer;font-family:Georgia,serif;border:1px solid rgba(255,255,255,0.15);background:rgba(255,255,255,0.06);color:rgba(255,255,255,0.5);transition:all 0.15s;}
  .sl-mode-btn.active{background:rgba(250,204,21,0.2);border-color:#facc15;color:#facc15;}
  .sl-note-dots{display:flex;gap:4px;justify-content:center;flex-wrap:wrap;margin-bottom:8px;width:100%;max-width:390px;}
  .sl-dot{width:10px;height:10px;border-radius:50%;background:rgba(255,255,255,0.15);transition:all 0.2s;}
  .sl-dot.done{background:#4ade80;}
  .sl-dot.current{background:#facc15;transform:scale(1.3);}
  .home-song-library{width:100%;max-width:360px;margin-bottom:12px;}
  .home-song-row{display:flex;gap:8px;width:100%;}
  .home-song-pill{flex:1;padding:9px 6px;border-radius:12px;font-size:11px;font-weight:700;cursor:pointer;font-family:Georgia,serif;background:rgba(74,222,128,0.14);border:1px solid rgba(74,222,128,0.45);color:#4ade80;text-align:center;transition:all 0.15s;}

`;

const HTML = `
<canvas id="oa-confetti-canvas"></canvas>
<div class="bravo-banner" id="bravo-banner"><div class="bravo-text" id="bravo-text">BRAVO!</div></div>
<div class="lightning-banner" id="lightning-banner">⚡ LIGHTNING ROUND ⚡</div>

<!-- TUNER MODAL -->
<div class="modal-overlay" id="tuner-modal">
  <div class="modal-box">
    <div style="font-size:36px" class="float">🎻</div>
    <div class="tuner-title" id="tuner-modal-title">Let us tune up first!</div>
    <div class="tuner-subtitle"><span style="color:#fff;font-weight:600;">Play each string and watch the needle.<br>Green means you are in tune.</span></div>
    <div class="tuner-strings" id="tuner-strings"></div>
    <div class="gauge-wrap">
      <svg class="gauge-svg" viewBox="0 0 300 175" xmlns="http://www.w3.org/2000/svg">
        <!-- Clean single background track -->
        <path d="M 18 165 A 132 132 0 0 1 282 165" fill="none" stroke="rgba(255,255,255,0.08)" stroke-width="20" stroke-linecap="round"/>

        <!-- ACTIVE illuminated arc - updated by JS, drawn on top of clean track -->
        <path id="tuner-active-arc" d="M 150 13 A 132 132 0 0 1 182 13" fill="none" stroke="rgba(74,222,128,0.9)" stroke-width="20" stroke-linecap="round" opacity="0"/>

        <!-- Center tick mark -->
        <line x1="150" y1="12" x2="150" y2="30" stroke="rgba(255,255,255,0.6)" stroke-width="2.5"/>

        <!-- Side tick marks -->
        <line x1="83" y1="33" x2="91" y2="45" stroke="rgba(255,255,255,0.25)" stroke-width="1.5"/>
        <line x1="217" y1="33" x2="209" y2="45" stroke="rgba(255,255,255,0.25)" stroke-width="1.5"/>
        <line x1="52" y1="65" x2="62" y2="74" stroke="rgba(255,255,255,0.18)" stroke-width="1.5"/>
        <line x1="248" y1="65" x2="238" y2="74" stroke="rgba(255,255,255,0.18)" stroke-width="1.5"/>

        <!-- FLAT label - large, centered at left end of arc -->
        <text x="8" y="148" font-size="22" fill="rgba(248,113,113,0.8)" font-family="Georgia" font-style="italic" text-anchor="middle">b</text>
        <text x="8" y="168" font-size="9" fill="rgba(255,255,255,0.3)" font-family="Georgia" text-anchor="middle">FLAT</text>

        <!-- SHARP label - large, centered at right end of arc -->
        <text x="292" y="148" font-size="22" fill="rgba(248,113,113,0.8)" font-family="Georgia" text-anchor="middle">#</text>
        <text x="292" y="168" font-size="9" fill="rgba(255,255,255,0.3)" font-family="Georgia" text-anchor="middle">SHARP</text>

        <!-- Pointer needle - short stubby pointer from pivot -->
        <g id="gauge-needle" style="transform-origin:150px 165px;transform:rotate(0deg);transition:transform 0.1s ease-out;">
          <!-- Short pointer: tip at 80px above pivot, base width 16px -->
          <polygon points="150,85 142,158 158,158" fill="white" id="needle-poly" opacity="0.95"/>
          <!-- Pivot circle -->
          <circle cx="150" cy="165" r="10" fill="rgba(15,15,35,1)" stroke="white" stroke-width="2.5"/>
          <circle cx="150" cy="165" r="4" fill="white"/>
        </g>

        <!-- Large note name in center of arc -->
        <text id="tuner-center-note" x="150" y="138" font-size="44" font-weight="900" fill="rgba(255,255,255,0.25)" font-family="Georgia" text-anchor="middle">--</text>
      </svg>
    </div>
    <div class="gauge-info" style="justify-content:center;gap:20px;"><span id="gauge-target" style="font-size:12px;color:#fff;">Target: --</span><span id="gauge-detected" style="font-size:12px;color:#fff;">Detected: --</span></div>
    <div class="tuner-status" id="tuner-status" style="color:#fff;font-weight:600;">Play a string to begin tuning</div>
    <button class="tuner-close-btn" id="tuner-close-btn">Done - Start Playing</button>
  </div>
</div>

<!-- SPEED POPUP -->
<div class="modal-overlay" id="speed-modal">
  <div class="modal-box" style="gap:10px;">
    <div class="speed-popup-title" id="speed-popup-title">School Orchestra</div>
    <div class="speed-popup-venue" id="speed-popup-venue">Lincoln Middle School</div>
    <div class="speed-divider"></div>
    <div style="font-size:11px;color:rgba(255,255,255,0.4);text-align:center;letter-spacing:0.08em;">CHOOSE YOUR SPEED</div>
    <div id="speed-options-list" style="display:flex;flex-direction:column;gap:8px;width:100%;"></div>
    <button class="speed-cancel" id="speed-cancel">Cancel</button>
  </div>
</div>

<!-- locked-modal: kept for JS listener compatibility -->
<div class="modal-overlay" id="locked-modal">
  <div class="modal-box" style="gap:14px;max-width:320px;">
    <button class="speed-cancel" id="locked-close" style="margin-top:4px;">Close</button>
  </div>
</div>


<!-- COUNTDOWN -->
<div class="countdown-overlay" id="countdown-overlay">
  <div class="countdown-num" id="countdown-num">5</div>
  <div class="countdown-msg" id="countdown-msg">Pick up your violin...</div>
</div>

<!-- HOME -->
<div id="screen-home" class="screen active">
  <div style="width:100%;max-width:360px;display:flex;justify-content:flex-end;margin-bottom:-30px;">
    <button id="settings-btn" style="background:rgba(255,255,255,0.12);border:1px solid rgba(255,255,255,0.35);border-radius:10px;font-size:12px;font-weight:700;cursor:pointer;padding:6px 12px;color:#fff;font-family:Georgia,serif;display:flex;align-items:center;gap:4px;">⚙️ Settings</button>
  </div>
  <div class="float" style="font-size:48px;margin-bottom:6px;">🎻</div>
  <div class="home-title-wrap">
    <div class="home-title-top">Violin Audition</div>
    <div class="home-title-game">GAME</div>
  </div>
  <div class="home-sub" style="font-size:13px;letter-spacing:0.3em;font-weight:900;background:linear-gradient(90deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff,#c77dff);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:shimmer 6s ease infinite;background-size:300% 300%;">VIOLIN SIGHT READING TRAINER</div>

  <button class="tuner-home-btn" id="tuner-home-btn"><span style="font-size:18px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:14px;">Tune Your Violin</span><span style="font-size:18px;">🎻</span></button>
  <div id="music-hint" style="display:block;font-size:12px;color:rgba(255,255,255,0.8);text-align:center;padding:8px;font-weight:600;">🎵 Tap anywhere to start music</div>
  <!-- Hidden elements still needed for game logic -->
  <div style="display:none;">
    <div id="toggle-metro" class="setting-toggle on"><div class="st-status" id="metro-status">ON</div></div>
    <div id="toggle-ambient" class="setting-toggle"><div class="st-status" id="ambient-status">OFF</div></div>
    <input type="range" id="bpm-slider" min="30" max="160" value="60">
    <div id="bpm-display">60</div>
  </div>
  <div style="font-size:14px;font-weight:800;background:linear-gradient(90deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;letter-spacing:0.15em;text-align:center;margin-bottom:8px;">🎮 START GAME PLAY</div>
    <div style="width:100%;max-width:360px;background:rgba(0,0,0,0.2);border:1px solid rgba(96,165,250,0.45);border-radius:14px;padding:12px 16px;margin-bottom:12px;display:flex;align-items:flex-start;gap:10px;">
      <span style="font-size:20px;flex-shrink:0;">🎯</span>
      <div style="font-size:12px;color:rgba(255,255,255,0.9);line-height:1.55;font-weight:500;">Start at <strong style="color:#4ade80;">Beginner</strong> speed and work your way up. Perfect for beginners and a great review for all players.</div>
    </div>
    <div id="level-list"></div>
  <!-- V1.1 - restore this: Song Library section on home screen
  <div class="home-song-library" id="home-song-library">
    <div id="home-song-title" style="font-size:14px;letter-spacing:0.15em;color:#facc15;text-align:center;margin-bottom:8px;font-weight:800;">🎵 SONG LEARNING</div>
    <div class="home-song-row" id="home-song-row"></div>
    <div style="text-align:center;margin-top:6px;"><button id="btn-more-songs" style="background:transparent;border:none;color:rgba(255,255,255,0.35);font-size:11px;cursor:pointer;font-family:Georgia,serif;">View all songs →</button></div>
  </div>
  -->
  <!-- V1.0 stubs so getElementById calls don't crash -->
  <div id="home-song-library" style="display:none;"><div id="home-song-row"></div><button id="btn-more-songs" style="display:none;"></button></div>
  <div style="width:100%;max-width:360px;height:1px;background:rgba(255,255,255,0.15);margin:12px 0;"></div>
  <div id="home-practice-title" style="font-size:14px;letter-spacing:0.15em;color:#fff;text-align:center;margin-bottom:8px;font-weight:800;">PRACTICE MODES</div>
  <div class="practice-modes">
    <button class="practice-mode-btn btn-flashcard" id="btn-flashcard">
      <span class="pm-icon">🃏</span>
      <div class="pm-info"><div class="pm-title">Flashcards</div><div class="pm-sub">Tap to reveal — all ranges free</div></div>
      <span class="pm-arrow">›</span>
    </button>
    <!-- V1.1 - restore this: Flash Play button
    <button class="practice-mode-btn btn-flashplay" id="btn-flashplay">
      <span class="pm-icon" style="filter:drop-shadow(0 0 6px #c4b5fd) brightness(1.3);">🎵</span>
      <div class="pm-info"><div class="pm-title">Flash Play</div><div class="pm-sub">Play on violin — no timer, no pressure</div></div>
      <span class="pm-arrow">›</span>
    </button>
    -->
    <!-- V1.1 - restore this: Scale Play button
    <button class="practice-mode-btn btn-scaleplay" id="btn-scaleplay">
      <span class="pm-icon" style="filter:drop-shadow(0 0 6px #fbbf24) brightness(1.3);">🎼</span>
      <div class="pm-info"><div class="pm-title">Scale Play</div><div class="pm-sub">Practice scales ascending &amp; descending</div></div>
      <span class="pm-arrow">›</span>
    </button>
    -->
    <!-- V1.1 - restore this: Chord Play button
    <button class="practice-mode-btn btn-chordplay" id="btn-chordplay">
      <span class="pm-icon">🎸</span>
      <div class="pm-info"><div class="pm-title">Chord Play</div><div class="pm-sub">Double stops, triads, 7ths &amp; fiddle chords</div></div>
      <span class="pm-arrow">›</span>
    </button>
    -->
    <!-- V1.1 - restore this: Song Library button
    <button class="practice-mode-btn btn-songlearn" id="btn-songlearn">
      <span class="pm-icon" style="filter:drop-shadow(0 0 6px #facc15) brightness(1.3);">🎵</span>
      <div class="pm-info"><div class="pm-title">Song Library</div><div class="pm-sub">Listen free · learn songs note by note</div></div>
      <span class="pm-arrow">›</span>
    </button>
    -->
    <!-- V1.0 stubs so event-listener getElementById calls don't crash -->
    <button id="btn-flashplay" style="display:none;"></button>
    <button id="btn-scaleplay" style="display:none;"></button>
    <button id="btn-chordplay" style="display:none;"></button>
    <button id="btn-songlearn" style="display:none;"></button>
    <button class="practice-mode-btn" id="btn-standalone-metro" style="background:rgba(255,107,107,0.12);border:1px solid rgba(255,107,107,0.4);color:#ff6b6b;">
      <span class="pm-icon" style="filter:drop-shadow(0 0 6px #ff6b6b) brightness(1.3);">🥁</span>
      <div class="pm-info"><div class="pm-title">Metronome</div><div class="pm-sub">Standalone practice metronome with tap tempo</div></div>
      <span class="pm-arrow">›</span>
    </button>
  </div>
</div>

<!-- AUDITION -->
<div id="screen-audition" class="screen">
  <div class="top-bar">
    <button class="exit-btn" id="exit-btn">Exit</button>
    <div class="top-venue">
      <div class="top-level-name" id="aud-level-name"></div>
      <div class="top-venue-name" id="aud-venue"></div>
      <div><span class="speed-badge" id="speed-badge"></span></div>
    </div>
    <div class="note-counter" id="aud-counter">1/8</div>
  </div>
  <div class="progress-track"><div class="progress-fill" id="prog-fill"></div></div>
  <div class="level-timer-row">
    <div style="font-size:10px;color:rgba(255,255,255,0.3);letter-spacing:0.08em;white-space:nowrap;">TIME</div>
    <div class="level-timer-track"><div class="level-timer-fill" id="level-timer-fill" style="width:100%"></div></div>
    <div class="level-timer-num" id="level-timer-num">25</div>
  </div>
  <div class="metro-bar" id="metro-bar">
    <div class="metro-label">METRONOME</div>
    <div class="metro-beats" id="metro-beats"></div>
    <div class="metro-bpm-tag" id="metro-bpm-tag">60 BPM</div>
  </div>
  <div class="ready-zone">
    <div class="countdown-ring">
      <svg width="44" height="44" viewBox="0 0 44 44">
        <circle class="ring-bg" cx="22" cy="22" r="18"/>
        <circle class="ring-fill" id="ring-fill" cx="22" cy="22" r="18" stroke-dasharray="113" stroke-dashoffset="113" stroke="rgba(255,255,255,0.2)"/>
      </svg>
      <div class="ring-num" id="ring-num" style="color:rgba(255,255,255,0.3);">--</div>
    </div>
    <div class="ready-info">
      <div class="ready-title" id="ready-title" style="color:rgba(255,255,255,0.4);">Waiting for note...</div>
      <div class="ready-sub" id="ready-sub">Play a clear sustained note</div>
    </div>
  </div>
  <div class="vol-meter">
    <div class="vol-label"><span>Volume</span><span id="vol-pct">0%</span></div>
    <div class="vol-track"><div class="vol-fill" id="vol-fill" style="width:0%"></div><div class="vol-threshold" style="left:28%"></div></div>
  </div>
  <button class="hint-btn" id="hint-btn"><div class="emoji-badge">🎻</div>Show Fingerboard</button>
  <div class="game-area">
    <div class="staff-card" id="staff-card">
      <div class="judge-label" id="aud-judge"></div>
      <svg id="staff-svg" width="175" height="140" style="overflow:visible;display:block;"></svg>
      <div class="note-display neutral" id="note-display">--</div>
      <div class="expected-str" id="expected-str-label"></div>
      <div class="feedback-area">
        <div class="feedback-main" id="fb-main" style="color:rgba(255,255,255,0.4);">Play the note</div>
        <div class="feedback-sub" id="fb-sub"></div>
      </div>
    </div>
    <div id="game-bow-stroke" class="bow-stroke"></div>
    <div class="fingerboard-card hidden" id="fingerboard-card">
      <div class="fb-title" id="fb-card-title" style="color:rgba(255,255,255,0.35);">TARGET NOTE</div>
      <div class="fb-note-name" id="fb-note-name" style="color:#fff;">--</div>
      <div class="fb-string-name" id="fb-string-name" style="color:rgba(255,255,255,0.4);">--</div>
      <svg id="fingerboard-svg" width="112" height="215" style="overflow:visible;display:block;margin:0 auto;"></svg>
      <div class="fb-finger-label" id="fb-finger-label" style="color:rgba(255,255,255,0.4);"></div>
    </div>
  </div>
  <div class="strings-section">
    <div class="strings-label">STRINGS - LIVE DETECTION</div>
    <div class="strings-row" id="strings-row"></div>
  </div>
  <div class="score-section">
    <div class="score-bar-labels"><span id="score-pct">Score: 0%</span><span id="pass-label">Pass: 70%</span></div>
    <div class="score-track"><div class="score-fill" id="score-fill" style="width:0%"></div></div>
    <div class="score-stats"><span id="score-correct">0 correct / 0 missed</span><span id="streak-label"></span></div>
  </div>
  <div class="controls-row">
    <div class="mic-status"><div class="mic-dot" id="mic-dot" style="background:#fb923c"></div><span style="color:rgba(255,255,255,0.5)" id="mic-label">Tap to enable mic</span></div>
    <button class="demo-btn" id="demo-btn">Demo Play</button>
  </div>
</div>


<!-- RANGE SELECTOR MODAL -->
<div class="modal-overlay" id="range-modal">
  <div class="range-modal-box">
    <div style="font-size:13px;font-weight:900;text-align:center;" id="range-modal-title">Choose Note Range</div>
    <div class="range-section-title">BY LEVEL</div>
    <div class="range-preset-row" id="range-presets">
      <button class="range-preset-btn selected" data-preset="0">🏫 Beginner<br><span style="font-size:9px;opacity:0.6;">E4-E5 naturals</span></button>
      <button class="range-preset-btn" data-preset="1">🎭 Intermediate<br><span style="font-size:9px;opacity:0.6;">G3-G5 + sharps</span></button>
      <button class="range-preset-btn range-pro-btn" data-preset="2" style="display:none;">🎓 Advanced<br><span style="font-size:9px;opacity:0.6;">Full chromatic</span></button>
      <button class="range-preset-btn range-pro-btn" data-preset="3" style="display:none;">🏆 Elite<br><span style="font-size:9px;opacity:0.6;">All + high pos.</span></button>
      <button class="range-preset-btn range-pro-btn" data-preset="intervals" style="display:none;">🎼 Intervals<br><span style="font-size:9px;opacity:0.6;">3rds &amp; 5ths</span></button>
    </div>
    <div class="range-section-title" style="margin-top:4px;">BY STRING</div>
    <div class="string-toggle-row" id="string-toggles">
      <div class="string-toggle-btn selected" data-string="G" style="border-color:#c2692a;"><span class="st-letter" style="color:#c2692a;">G</span><span class="st-freq">196Hz</span></div>
      <div class="string-toggle-btn selected" data-string="D" style="border-color:#2E8B57;"><span class="st-letter" style="color:#2E8B57;">D</span><span class="st-freq">294Hz</span></div>
      <div class="string-toggle-btn selected" data-string="A" style="border-color:#4169E1;"><span class="st-letter" style="color:#4169E1;">A</span><span class="st-freq">440Hz</span></div>
      <div class="string-toggle-btn selected" data-string="E" style="border-color:#CC2200;"><span class="st-letter" style="color:#CC2200;">E</span><span class="st-freq">659Hz</span></div>
    </div>
    <div class="accidental-toggle">
      <span style="font-size:13px;color:rgba(255,255,255,0.7);font-weight:600;">Include sharps &amp; flats</span>
      <div class="acc-toggle-switch on" id="acc-toggle"></div>
    </div>
    <button class="range-start-btn" id="range-start-btn" style="background:rgba(20,184,166,0.2);border:2px solid #2dd4bf;color:#2dd4bf;">Start Flashcards →</button>
    <button class="speed-cancel" id="range-cancel">Cancel</button>
  </div>
</div>

<!-- SCALE SELECTOR MODAL -->
<div class="modal-overlay" id="scale-modal">
  <div class="range-modal-box">
    <div style="font-size:13px;font-weight:900;text-align:center;">Choose a Scale</div>
    <div class="scale-grid" id="scale-grid"></div>
    <div class="accidental-toggle" style="margin-top:4px;">
      <span style="font-size:13px;color:rgba(255,255,255,0.7);font-weight:600;">Direction</span>
      <div style="display:flex;gap:6px;">
        <button class="range-preset-btn selected" id="dir-asc">↑ Up</button>
        <button class="range-preset-btn selected" id="dir-desc">↓ Down</button>
      </div>
    </div>
    <button class="range-start-btn" id="scale-preview-btn" style="background:rgba(96,165,250,0.15);border:2px solid #60a5fa;color:#60a5fa;">👁 Show Scale</button>
    <button class="range-start-btn" id="scale-start-btn" style="background:rgba(251,191,36,0.15);border:2px solid #fbbf24;color:#fbbf24;">▶ Start Scale Play</button>
    <button class="speed-cancel" id="scale-cancel">Cancel</button>
  </div>
</div>

<!-- FLASHCARD SCREEN -->
<div id="screen-flashcard" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="fc-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#2dd4bf;">🃏 Flashcards</div>
    <div class="fc-progress" id="fc-progress">1 / 20</div>
  </div>
  <div class="fc-card" id="fc-card">
    <div class="fc-note-label">PLAY THIS NOTE</div>
    <svg id="fc-staff-svg" width="200" height="150" style="overflow:visible;display:block;"></svg>
    <div class="fc-note-name" id="fc-note-name" style="color:rgba(255,255,255,0.2);">?</div>
    <div id="fc-fingerboard-wrap" style="display:none;width:100%;display:flex;flex-direction:column;align-items:center;gap:6px;">
      <div style="font-size:11px;color:rgba(255,255,255,0.4);letter-spacing:0.1em;">FINGER POSITION</div>
      <svg id="fc-fingerboard-svg" width="112" height="215" style="overflow:visible;display:block;margin:0 auto;"></svg>
    </div>
  </div>
  <button class="fc-reveal-btn" id="fc-reveal-btn">👁 Reveal Finger Position</button>
  <div class="fc-nav-row">
    <button class="fc-prev" id="fc-prev-btn">← Previous</button>
    <button class="fc-next" id="fc-next-btn">Next Note →</button>
  </div>
  <button class="tuner-home-btn" style="max-width:390px;margin-top:8px;" id="fc-tune-btn"><span style="font-size:16px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:13px;">Tune Your Violin</span><span style="font-size:16px;">🎻</span></button>
</div>

<!-- FLASH PLAY SCREEN -->
<div id="screen-flashplay" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="fp-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#e0d4ff;">🎵 Flash Play</div>
    <div class="fc-progress" id="fp-progress">1 / 20</div>
  </div>
  <div class="fc-card" id="fp-card" style="border-color:rgba(167,139,250,0.2);">
    <div class="fc-note-label">PLAY THIS NOTE</div>
    <svg id="fp-staff-svg" width="200" height="150" style="overflow:visible;display:block;"></svg>
    <div class="fc-note-name" id="fp-note-name" style="color:rgba(255,255,255,0.2);">?</div>
    <div id="fp-feedback" style="font-size:14px;font-weight:700;min-height:22px;text-align:center;color:rgba(255,255,255,0.3);">Play the note on your violin</div>
  </div>
  <div id="fp-fingerboard-wrap" style="display:none;width:100%;max-width:390px;background:rgba(255,255,255,0.05);border:1px solid rgba(167,139,250,0.2);border-radius:18px;padding:10px;margin-bottom:8px;display:flex;flex-direction:column;align-items:center;gap:4px;">
    <div style="font-size:9px;color:rgba(255,255,255,0.3);letter-spacing:0.1em;">TRY THIS POSITION</div>
    <svg id="fp-fingerboard-svg" width="112" height="180" style="overflow:visible;display:block;margin:0 auto;"></svg>
  </div>
  <div class="vol-meter" style="max-width:390px;">
    <div class="vol-label"><span>Volume</span><span id="fp-vol-pct">0%</span></div>
    <div class="vol-track"><div class="vol-fill" id="fp-vol-fill" style="width:0%"></div><div class="vol-threshold" style="left:28%"></div></div>
  </div>
  <div class="controls-row" style="max-width:390px;">
    <div class="mic-status"><div class="mic-dot" id="fp-mic-dot" style="background:#fb923c"></div><span style="color:rgba(255,255,255,0.5)" id="fp-mic-label">Tap to enable mic</span></div>
    <button class="demo-btn" id="fp-demo-btn">Demo</button>
  </div>
  <button class="tuner-home-btn" style="max-width:390px;margin-top:4px;" id="fp-tune-btn"><span style="font-size:16px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:13px;">Tune Your Violin</span><span style="font-size:16px;">🎻</span></button>
</div>

<!-- SCALE PLAY SCREEN -->
<div id="screen-scaleplay" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="sp-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#fbbf24;" id="sp-scale-name">🎼 Scale Play</div>
    <div class="fc-progress" id="sp-progress">1 / 8</div>
  </div>
  <div class="scale-dir-label" id="sp-dir-label">ASCENDING ↑</div>
  <div class="scale-progress-dots" id="sp-dots"></div>
  <div class="fc-card" id="sp-card" style="border-color:rgba(251,191,36,0.2);min-height:240px;">
    <div class="fc-note-label">PLAY THIS NOTE</div>
    <svg id="sp-staff-svg" width="200" height="150" style="overflow:visible;display:block;"></svg>
    <div class="fc-note-name" id="sp-note-name" style="color:rgba(255,255,255,0.2);">?</div>
    <div id="sp-feedback" style="font-size:14px;font-weight:700;min-height:22px;text-align:center;color:rgba(255,255,255,0.3);">Play the note on your violin</div>
  </div>
  <div id="sp-fingerboard-wrap" style="display:none;width:100%;max-width:390px;background:rgba(255,255,255,0.05);border:1px solid rgba(251,191,36,0.2);border-radius:18px;padding:10px;margin-bottom:8px;display:flex;flex-direction:column;align-items:center;gap:4px;">
    <div style="font-size:9px;color:rgba(255,255,255,0.3);letter-spacing:0.1em;">FINGER POSITION</div>
    <svg id="sp-fingerboard-svg" width="112" height="180" style="overflow:visible;display:block;margin:0 auto;"></svg>
  </div>
  <div class="vol-meter" style="max-width:390px;">
    <div class="vol-label"><span>Volume</span><span id="sp-vol-pct">0%</span></div>
    <div class="vol-track"><div class="vol-fill" id="sp-vol-fill" style="width:0%"></div><div class="vol-threshold" style="left:28%"></div></div>
  </div>
  <div class="controls-row" style="max-width:390px;">
    <div class="mic-status"><div class="mic-dot" id="sp-mic-dot" style="background:#fb923c"></div><span style="color:rgba(255,255,255,0.5)" id="sp-mic-label">Tap to enable mic</span></div>
    <button class="demo-btn" id="sp-demo-btn">Demo</button>
  </div>
  <button class="tuner-home-btn" style="max-width:390px;margin-top:4px;" id="sp-tune-btn"><span style="font-size:16px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:13px;">Tune Your Violin</span><span style="font-size:16px;">🎻</span></button>
</div>


<!-- SCALE PREVIEW SCREEN -->
<div id="screen-scalepreview" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="scp-back-btn">← Back</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#fbbf24;" id="scp-scale-name">Scale Preview</div>
    <div style="width:40px;"></div>
  </div>
  <div style="font-size:11px;color:rgba(255,255,255,0.4);letter-spacing:0.1em;margin-bottom:8px;" id="scp-dir-label">ASCENDING ↑</div>
  <div style="width:100%;max-width:390px;background:rgba(255,255,255,0.05);border:1px solid rgba(251,191,36,0.15);border-radius:18px;padding:16px 10px 14px;overflow-x:auto;">
    <svg id="scp-staff-svg" width="360" height="180" style="overflow:visible;display:block;min-width:320px;"></svg>
  </div>
  <button id="scp-start-btn" style="width:100%;max-width:390px;padding:16px;border-radius:16px;background:linear-gradient(135deg,#fbbf24,#f59e0b);border:none;color:#000;font-size:16px;font-weight:900;cursor:pointer;font-family:Georgia,serif;margin-top:16px;">▶ Start Scale Play</button>
</div>

<!-- STANDALONE METRONOME SCREEN -->
<div id="screen-metronome" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="sm-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:14px;font-weight:800;color:#ff6b6b;">🥁 Metronome</div>
    <div style="width:40px;"></div>
  </div>
  <div class="metro-screen-wrap">
    <!-- Beat display -->
    <div class="metro-beat-display" id="sm-beat-display"></div>

    <!-- BPM big display -->
    <div>
      <div class="metro-bpm-big" id="sm-bpm-display">60</div>
      <div class="metro-bpm-unit-big">BPM</div>
    </div>

    <!-- Slider -->
    <input type="range" class="metro-slider-big" id="sm-slider" min="30" max="200" value="60">

    <!-- Presets -->
    <div class="metro-presets-big">
      <button class="metro-preset-big" data-bpm="40" style="background:rgba(74,222,128,0.12);border-color:rgba(74,222,128,0.4);color:#4ade80;">40</button>
      <button class="metro-preset-big" data-bpm="60" style="background:rgba(96,165,250,0.12);border-color:rgba(96,165,250,0.4);color:#60a5fa;">60</button>
      <button class="metro-preset-big" data-bpm="80" style="background:rgba(251,191,36,0.12);border-color:rgba(251,191,36,0.4);color:#fbbf24;">80</button>
      <button class="metro-preset-big" data-bpm="100" style="background:rgba(251,146,60,0.12);border-color:rgba(251,146,60,0.4);color:#fb923c;">100</button>
      <button class="metro-preset-big" data-bpm="120" style="background:rgba(248,113,113,0.12);border-color:rgba(248,113,113,0.4);color:#f87171;">120</button>
      <button class="metro-preset-big" data-bpm="160" style="background:rgba(248,113,113,0.18);border-color:rgba(248,113,113,0.6);color:#f87171;">160</button>
    </div>

    <!-- Time signature -->
    <div style="font-size:10px;color:rgba(255,255,255,0.35);letter-spacing:0.12em;text-align:center;">TIME SIGNATURE</div>
    <div class="metro-timesig-row">
      <button class="metro-timesig-btn selected" data-beats="4">4/4</button>
      <button class="metro-timesig-btn" data-beats="3">3/4</button>
      <button class="metro-timesig-btn" data-beats="6">6/8</button>
    </div>

    <!-- Tap Tempo -->
    <button class="tap-tempo-btn" id="sm-tap-btn">👆 Tap Tempo</button>

    <!-- Start / Stop -->
    <button class="metro-start-btn stopped" id="sm-start-btn">▶ Start</button>

    <!-- Tuner link -->
    <button class="metro-tuner-link" id="sm-tuner-link">
      <span>🎵</span><span>Tune Your Violin</span><span>🎻</span>
    </button>
  </div>
</div>


<!-- CHORD LEVEL SELECTOR MODAL -->
<div class="modal-overlay" id="chord-level-modal">
  <div class="range-modal-box">
    <div style="font-size:14px;font-weight:900;text-align:center;">🎸 Chord Play — Choose Level</div>
    <div style="font-size:11px;color:rgba(255,255,255,0.55);font-weight:700;width:100%;margin-bottom:2px;">KEY</div>
    <div id="chord-key-selector" style="display:flex;gap:6px;width:100%;justify-content:center;"></div>
    <button id="chord-preview-btn" style="width:100%;padding:10px;border-radius:12px;background:rgba(96,165,250,0.12);border:1px solid rgba(96,165,250,0.4);color:#60a5fa;font-size:13px;font-weight:800;cursor:pointer;font-family:Georgia,serif;">👁 Show Chords</button>
    <div style="display:grid;grid-template-columns:1fr 1fr;gap:8px;width:100%;" id="chord-level-grid"></div>
    <button class="speed-cancel" id="chord-level-cancel">Cancel</button>
  </div>
</div>

<!-- CHORD PLAY SCREEN -->
<div id="screen-chordplay" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="cp-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:800;" id="cp-level-name">🎸 Chord Play</div>
    <div style="font-size:10px;color:rgba(255,255,255,0.35);" id="cp-pass-label">Pass: 70%</div>
  </div>
  <!-- Score bar -->
  <div style="width:100%;max-width:390px;display:flex;justify-content:space-between;align-items:center;margin-bottom:4px;">
    <span style="font-size:11px;color:rgba(255,255,255,0.4);" id="cp-chord-counter">Chord 1/12</span>
    <span style="font-size:11px;font-weight:700;" id="cp-score-pct">Score: 0%</span>
  </div>
  <div class="cp-score-bar"><div class="cp-score-fill" id="cp-score-fill"></div></div>
  <!-- Chord name -->
  <div style="font-size:16px;font-weight:900;text-align:center;margin:6px 0;" id="cp-chord-name">G Major</div>
  <!-- Note dots -->
  <div class="cp-note-dots" id="cp-note-dots"></div>
  <!-- Staff card -->
  <div class="fc-card" id="cp-card" style="min-height:220px;padding:16px;">
    <svg id="cp-staff-svg" width="240" height="170" style="overflow:visible;display:block;"></svg>
    <div style="display:flex;align-items:center;gap:8px;margin-top:4px;">
      <span style="font-size:11px;color:rgba(255,255,255,0.35);">NOW PLAY:</span>
      <span style="font-size:22px;font-weight:900;" id="cp-current-note">G3</span>
      <span style="font-size:11px;color:rgba(255,255,255,0.35);" id="cp-note-counter">1/2</span>
    </div>
    <div style="font-size:13px;font-weight:700;min-height:20px;text-align:center;" id="cp-feedback">Play the note shown</div>
  </div>
  <!-- Fingerboard hint -->
  <div id="cp-fingerboard-wrap" style="display:none;width:100%;max-width:390px;background:rgba(255,255,255,0.04);border:1px solid rgba(249,115,22,0.2);border-radius:18px;padding:10px;margin-bottom:8px;display:flex;flex-direction:column;align-items:center;gap:4px;">
    <div style="font-size:9px;color:rgba(255,255,255,0.3);letter-spacing:0.1em;">FINGER POSITION</div>
    <svg id="cp-fingerboard-svg" width="112" height="180" style="overflow:visible;display:block;margin:0 auto;"></svg>
  </div>
  <!-- Volume meter -->
  <div class="vol-meter" style="max-width:390px;">
    <div class="vol-label"><span>Volume</span><span id="cp-vol-pct">0%</span></div>
    <div class="vol-track"><div class="vol-fill" id="cp-vol-fill" style="width:0%"></div><div class="vol-threshold" style="left:28%"></div></div>
  </div>
  <div class="controls-row" style="max-width:390px;">
    <div class="mic-status"><div class="mic-dot" id="cp-mic-dot" style="background:#fb923c"></div><span style="color:rgba(255,255,255,0.5)" id="cp-mic-label">Tap to enable mic</span></div>
    <button class="demo-btn" id="cp-demo-btn">Demo</button>
  </div>
  <button class="tuner-home-btn" style="max-width:390px;margin-top:4px;" id="cp-tune-btn"><span style="font-size:16px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:13px;">Tune Your Violin</span><span style="font-size:16px;">🎻</span></button>
</div>

<!-- CHORD RESULTS SCREEN -->
<div id="screen-chordresults" class="screen" style="justify-content:center;">
  <div class="cp-result-box">
    <div style="font-size:64px;" id="cp-result-icon">🎸</div>
    <div style="font-size:22px;font-weight:900;" id="cp-result-title">Level Cleared!</div>
    <div style="font-size:56px;font-weight:900;" id="cp-result-score">85%</div>
    <div style="font-size:13px;color:rgba(255,255,255,0.5);" id="cp-result-detail">10 correct / 2 missed</div>
    <button id="cp-next-level-btn" style="display:none;width:100%;padding:14px;border-radius:14px;border:none;font-size:15px;font-weight:800;cursor:pointer;font-family:Georgia,serif;color:#000;margin-top:4px;">Next Level →</button>
    <button id="cp-retry-btn" style="width:100%;padding:13px;border-radius:14px;background:rgba(255,255,255,0.08);border:1px solid rgba(255,255,255,0.15);color:#fff;font-size:14px;font-weight:700;cursor:pointer;font-family:Georgia,serif;">Try Again</button>
    <button id="cp-home-btn" style="width:100%;padding:12px;border-radius:14px;background:transparent;border:1px solid rgba(255,255,255,0.1);color:rgba(255,255,255,0.5);font-size:13px;cursor:pointer;font-family:Georgia,serif;">Home</button>
  </div>
</div>


<!-- CHORD PREVIEW SCREEN -->
<div id="screen-chordpreview" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="cpp-back-btn">← Back</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#f97316;" id="cpp-title">Chords in Key of G</div>
    <div style="width:40px;"></div>
  </div>
  <div id="cpp-chord-list" style="width:100%;max-width:390px;display:flex;flex-direction:column;gap:8px;overflow-y:auto;padding-bottom:20px;"></div>
</div>

<!-- ONBOARDING OVERLAY -->
<div id="onboarding" class="onboard-screen" style="display:flex">
  <span class="onboard-skip" id="onboard-skip">Skip</span>

  <!-- Screen 1 - Welcome -->
  <div class="onboard-content" id="ob-screen-1">
    <div class="onboard-emoji">🎻</div>
    <div>
      <div class="onboard-title" style="background:linear-gradient(270deg,#ff6b6b,#ffd93d,#6bcb77,#4d96ff,#c77dff,#ff6b6b);background-size:400% 400%;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;animation:shimmer 4s ease infinite;">Violin Audition</div>
      <div style="font-size:40px;filter:drop-shadow(0 0 12px rgba(255,255,255,0.8));margin:6px 0;">🎼</div>
      <div class="onboard-title" style="color:#fff;font-size:22px;margin-top:4px;">The Complete Violin Learning Experience</div>
    </div>
    <div class="onboard-subtitle">Learn to read music, practice note recognition, tune your violin — and audition for the orchestra!</div>
    <div id="ob1-tag" style="font-size:13px;color:#facc15;font-weight:700;text-align:center;letter-spacing:0.03em;opacity:0.9;">Perfect for Beginner through Advanced!</div>
    <div style="display:flex;flex-direction:column;gap:8px;width:100%;max-width:300px;margin-top:4px;">
      <div id="ob1-feat1" style="display:flex;align-items:center;gap:10px;background:rgba(255,255,255,0.1);border-radius:12px;padding:10px 14px;">
        <span style="font-size:22px;">🎮</span>
        <div><div style="font-size:13px;font-weight:800;color:#4ade80;">Audition Game</div><div style="font-size:11px;color:rgba(255,255,255,0.6);">Sight-read your way to Carnegie Hall</div></div>
      </div>
      <div id="ob1-feat2" style="display:flex;align-items:center;gap:10px;background:rgba(255,255,255,0.1);border-radius:12px;padding:10px 14px;">
        <span style="font-size:22px;">🎵</span>
        <div><div style="font-size:13px;font-weight:800;color:#fff;">Tuner &amp; Metronome</div><div style="font-size:11px;color:rgba(255,255,255,0.6);">Always in tune, always in time</div></div>
      </div>
    </div>
  </div>

  <!-- Screen 2 - How it works -->
  <div class="onboard-content" id="ob-screen-2" style="display:none;">
    <div class="onboard-emoji">🎤</div>
    <div id="ob2-title" class="onboard-title" style="color:#4ade80;">Play — We Listen!</div>
    <div id="ob2-sub1" class="onboard-subtitle">Just play your violin! The app uses your microphone to hear what note you played and tells you if you got it right.</div>
    <div style="font-size:40px;filter:drop-shadow(0 0 12px rgba(255,255,255,0.8));margin:4px 0;">🎵</div>
    <div id="ob2-sub2" class="onboard-subtitle">No buttons to press. Just play!</div>
  </div>

  <!-- Screen 3 - Features -->
  <div class="onboard-content" id="ob-screen-3" style="display:none;">
    <div style="font-size:22px;font-weight:900;color:#fff;margin-bottom:4px;">Everything You Need!</div>
    <div class="onboard-emoji-grid">
      <div id="ob3-c0" class="onboard-emoji-cell"><span class="oe-icon">🎮</span><span class="oe-label" style="color:#4ade80;">Audition Game</span></div>
      <div id="ob3-c1" class="onboard-emoji-cell"><span class="oe-icon">🃏</span><span class="oe-label" style="color:#2dd4bf;">Flashcards</span></div>
      <div id="ob3-c2" class="onboard-emoji-cell"><span class="oe-icon">🎵</span><span class="oe-label" style="color:#ffd93d;">Tuner</span></div>
      <div id="ob3-c3" class="onboard-emoji-cell"><span class="oe-icon">🥁</span><span class="oe-label" style="color:#ff6b6b;">Metronome</span></div>
    </div>
    <!-- V1.1 - restore this: Flash Play, Scale Play, Chord Play, Song Learn, Song Play cells
    <div id="ob3-c4" class="onboard-emoji-cell"><span class="oe-icon">🎵</span><span class="oe-label" style="color:#a78bfa;">Flash Play</span></div>
    <div id="ob3-c5" class="onboard-emoji-cell"><span class="oe-icon">🎼</span><span class="oe-label" style="color:#fbbf24;">Scale Play</span></div>
    <div id="ob3-c6" class="onboard-emoji-cell"><span class="oe-icon">🎸</span><span class="oe-label" style="color:#f97316;">Chord Play</span></div>
    <div style="width:100%;height:1px;background:rgba(255,255,255,0.15);margin:10px 0;"></div>
    <div style="font-size:16px;font-weight:900;color:#facc15;margin-bottom:6px;">2 Ways to Learn Songs!</div>
    <div class="onboard-emoji-grid">
      <div id="ob3-c7" class="onboard-emoji-cell" style="border-color:rgba(250,204,21,0.3);background:rgba(250,204,21,0.08);"><span class="oe-icon" style="filter:drop-shadow(0 0 8px rgba(250,204,21,0.6));">🎵</span><span class="oe-label" style="color:#facc15;">Song Learn</span></div>
      <div id="ob3-c8" class="onboard-emoji-cell" style="border-color:rgba(250,204,21,0.3);background:rgba(250,204,21,0.08);"><span class="oe-icon" style="filter:drop-shadow(0 0 8px rgba(250,204,21,0.6));">🎼</span><span class="oe-label" style="color:#facc15;">Song Play</span></div>
    </div>
    -->
  </div>

  <!-- Screen 4 - Tune up -->
  <div class="onboard-content" id="ob-screen-4" style="display:none;">
    <div class="onboard-emoji">🎵</div>
    <div id="ob4-title" class="onboard-title" style="color:#ffd93d;">Always Tune First!</div>
    <div id="ob4-sub" class="onboard-subtitle">Before you play, use our built-in tuner to make sure your violin is in tune.<br><br>A440 standard tuning — just play each string and watch the needle! 🎻</div>
    <div style="font-size:13px;color:rgba(255,255,255,0.8);text-align:center;font-weight:600;">You can replay this tour anytime from ⚙️ Settings</div>
  </div>

  <!-- Bottom controls -->
  <div style="width:100%;max-width:340px;display:flex;flex-direction:column;align-items:center;gap:16px;">
    <div class="onboard-dots">
      <div class="onboard-dot active" id="ob-dot-1"></div>
      <div class="onboard-dot" id="ob-dot-2"></div>
      <div class="onboard-dot" id="ob-dot-3"></div>
      <div class="onboard-dot" id="ob-dot-4"></div>
    </div>
    <button class="onboard-btn onboard-btn-next" id="ob-next-btn">Next →</button>
  </div>
</div>

<!-- SETTINGS MODAL -->
<div class="modal-overlay" id="settings-modal">
  <div class="settings-modal">
    <div style="font-size:16px;font-weight:900;text-align:center;color:#fff;">⚙️ Settings</div>

    <div class="settings-row-item">
      <div><div class="settings-label" style="color:#fff;font-size:15px;">🎵 Metronome</div><div class="settings-sublabel" style="color:rgba(255,255,255,0.7);">Play click track during audition</div></div>
      <div class="acc-toggle-switch on" id="settings-metro-toggle"></div>
    </div>

    <div class="settings-row-item">
      <div><div class="settings-label" style="color:#fff;font-size:15px;">🎵 Ambience</div><div class="settings-sublabel" style="color:rgba(255,255,255,0.7);">Background orchestra sounds</div></div>
      <div class="acc-toggle-switch" id="settings-ambient-toggle"></div>
    </div>

    <div class="settings-row-item" style="border:none;">
      <div><div class="settings-label" style="color:#fff;font-size:15px;">🎓 Take the Tour Again</div><div class="settings-sublabel" style="color:rgba(255,255,255,0.7);">Replay the welcome screens</div></div>
      <button style="padding:6px 14px;border-radius:10px;background:rgba(96,165,250,0.15);border:1px solid rgba(96,165,250,0.4);color:#60a5fa;font-size:12px;font-weight:700;cursor:pointer;font-family:Georgia,serif;" id="settings-tour-btn">Replay</button>
    </div>

    <div style="text-align:center;font-size:10px;color:rgba(255,255,255,0.2);padding-top:8px;">Violin Audition v1.0 • Made with ❤️ for violinists</div>

    <button class="speed-cancel" id="settings-close">Done</button>
  </div>
</div>

<!-- SONG SELECT SCREEN -->
<div id="screen-songselect" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="sl-exit-btn">Exit</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#facc15;">🎵 Song Library</div>
    <div style="width:50px;"></div>
  </div>
  <div style="font-size:13px;color:rgba(255,255,255,0.5);margin-bottom:16px;text-align:center;">Choose a song to practice</div>
  <div class="song-list" id="song-list"></div>
</div>

<!-- SONG LEARN SCREEN -->
<div id="screen-songlearn" class="screen">
  <div class="fc-header">
    <button class="exit-btn" id="sl-back-btn">← Back</button>
    <div style="flex:1;text-align:center;font-size:13px;font-weight:700;color:#facc15;" id="sl-song-title">Song</div>
    <div class="fc-progress" id="sl-progress">1 / 14</div>
  </div>
  <div class="sl-mode-row">
    <button class="sl-mode-btn active" id="sl-mode-listen" data-mode="listen">🎧 Listen</button>
    <button class="sl-mode-btn" id="sl-mode-songlearn" data-mode="songlearn">📖 Song Learn</button>
    <button class="sl-mode-btn" id="sl-mode-songplay" data-mode="songplay">🎭 Song Play</button>
  </div>
  <div id="sl-listen-controls" style="display:none;width:100%;max-width:390px;background:rgba(250,204,21,0.1);border:1px solid rgba(250,204,21,0.25);border-radius:14px;padding:12px 16px;margin-bottom:4px;">
    <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:8px;">
      <span style="font-size:12px;color:rgba(255,255,255,0.6);">Tempo</span>
      <span style="font-size:12px;color:#facc15;font-weight:700;" id="sl-listen-bpm-display">80 BPM</span>
    </div>
    <input type="range" id="sl-listen-bpm" min="40" max="160" value="80" style="width:100%;margin-bottom:10px;accent-color:#facc15;">
    <button id="sl-listen-play-btn" style="width:100%;padding:12px;border-radius:12px;background:linear-gradient(135deg,#facc15,#f59e0b);border:none;color:#000;font-size:15px;font-weight:900;cursor:pointer;font-family:Georgia,serif;">▶ Play Song</button>
  </div>
  <div id="sl-songplay-msg" style="display:none;"></div>
  <div class="sl-note-dots" id="sl-dots"></div>
  <div class="fc-card" id="sl-card" style="border-color:rgba(250,204,21,0.2);">
    <div class="fc-note-label">PLAY THIS NOTE</div>
    <svg id="sl-staff-svg" width="200" height="150" style="overflow:visible;display:block;"></svg>
    <div class="fc-note-name" id="sl-note-name" style="color:#facc15;">?</div>
    <div id="sl-feedback" style="font-size:14px;font-weight:700;min-height:22px;text-align:center;color:rgba(255,255,255,0.4);">Play the note on your violin</div>
  </div>
  <div id="bow-stroke-sl" class="bow-stroke"></div>
  <div class="vol-meter" style="max-width:390px;" id="sl-vol-meter-wrap">
    <div class="vol-label"><span>Volume</span><span id="sl-vol-pct">0%</span></div>
    <div class="vol-track"><div class="vol-fill" id="sl-vol-fill" style="width:0%"></div><div class="vol-threshold" style="left:28%"></div></div>
  </div>
  <div class="controls-row" style="max-width:390px;" id="sl-controls-row">
    <div class="mic-status"><div class="mic-dot" id="sl-mic-dot" style="background:#fb923c"></div><span style="color:rgba(255,255,255,0.5)" id="sl-mic-label">Tap to enable mic</span></div>
    <button class="demo-btn" id="sl-demo-btn">Demo</button>
  </div>
  <div id="sl-complete-box" style="display:none;width:100%;max-width:390px;background:rgba(74,222,128,0.1);border:1px solid rgba(74,222,128,0.3);border-radius:20px;padding:24px;text-align:center;">
    <div style="font-size:48px;margin-bottom:8px;">🎉</div>
    <div style="font-size:20px;font-weight:900;color:#4ade80;margin-bottom:6px;">Song Complete!</div>
    <div style="font-size:14px;color:rgba(255,255,255,0.6);margin-bottom:16px;" id="sl-complete-msg">Great job!</div>
    <button id="sl-replay-btn" style="width:100%;padding:13px;border-radius:14px;background:rgba(74,222,128,0.15);border:2px solid rgba(74,222,128,0.4);color:#4ade80;font-size:15px;font-weight:800;cursor:pointer;font-family:Georgia,serif;margin-bottom:8px;">↺ Play Again</button>
    <button id="sl-songs-btn" style="width:100%;padding:11px;border-radius:12px;background:transparent;border:1px solid rgba(255,255,255,0.15);color:rgba(255,255,255,0.5);font-size:13px;cursor:pointer;font-family:Georgia,serif;">Song List</button>
  </div>
  <button class="tuner-home-btn" style="max-width:390px;margin-top:4px;" id="sl-tune-btn"><span style="font-size:16px;">🎵</span><span style="background:linear-gradient(135deg,#ffd93d,#ff6b6b);-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;font-weight:800;font-size:13px;">Tune Your Violin</span><span style="font-size:16px;">🎻</span></button>
</div>

<!-- GAMEOVER -->
<div id="screen-gameover" class="gameover-screen">
  <div class="go-icon">⏱️</div>
  <div class="go-title">Time's Up!</div>
  <div class="go-note" id="go-note"></div>
  <div class="go-tempo" id="go-tempo"></div>
  <div class="go-question">What would you like to do?</div>
  <div class="go-btns">
    <button class="go-btn-lower" id="go-btn-lower">⬇ Lower Tempo <span id="go-lower-bpm"></span></button>
    <button class="go-btn-same" id="go-btn-same">↺ Keep Tempo and Retry</button>
    <button class="go-btn-home" id="go-btn-home2">← Back to Level Select</button>
  </div>
</div>

<!-- RESULTS -->
<div id="screen-results" class="screen">
  <div class="results-icon" id="res-icon">🏫</div>
  <div class="results-title" id="res-title">You Passed!</div>
  <div class="results-venue" id="res-venue"></div>
  <div class="score-card" id="res-card">
    <div class="score-card-glow" id="score-card-glow"></div>
    <div class="big-score" id="res-score">0%</div>
    <div class="passing-label" id="res-passing"></div>
    <div class="stats-grid">
      <div class="stat-box"><div class="stat-num" id="res-correct" style="color:#4ade80">0</div><div class="stat-label">Correct</div></div>
      <div class="stat-box"><div class="stat-num" id="res-missed" style="color:#f87171">0</div><div class="stat-label">Missed</div></div>
      <div class="stat-box"><div class="stat-num" id="res-total" style="color:#60a5fa">0</div><div class="stat-label">Total</div></div>
    </div>
  </div>
  <div class="unlock-box" id="unlock-box" style="display:none"></div>
  <div class="res-next-prompt" id="res-next-prompt"></div>
  <button class="lightning-btn" id="lightning-btn" style="display:none">⚡ Lightning Round - Can you beat the clock?</button>
  <div class="action-btns">
    <button class="retry-btn" id="retry-btn">Try Again</button>
    <button class="faster-btn" id="faster-btn" style="display:none">Change Speed</button>
    <button class="next-btn" id="next-btn" style="display:none">Next Level</button>
  </div>
  <button class="home-btn" id="home-btn">Level Select</button>
</div>
`;

const GAME_SCRIPT = `
(function() {

var sharedCtx = null;
function getCtx(){
  if(!sharedCtx) sharedCtx = new(window.AudioContext||window.webkitAudioContext)();
  if(sharedCtx.state==='suspended') sharedCtx.resume();
  return sharedCtx;
}


// ── SPEED TIERS ──────────────────────────────────────────
// [L1, L2, L3, L4] seconds
var SPEEDS = [
  {key:'beginner',  icon:'🐢', name:'Beginner',  times:[40,35,30,25], color:'#4ade80'},
  {key:'normal',label:'Intermediate',    icon:'🎵', name:'Intermediate',    times:[25,20,15,13], color:'#60a5fa'},
  {key:'advanced',  icon:'⚡', name:'Advanced',  times:[15,12,10,8],  color:'#f59e0b'},
  {key:'pro',       icon:'🔥', name:'Pro',       times:[10,8,6,5],    color:'#f87171'},
  {key:'lightning', icon:'⚡', name:'Lightning', times:[6,5,4,3],     color:'#fbbf24', lightning:true}
];

var currentSpeedKey = 'normal';
var currentSpeedIdx = 1; // index into SPEEDS array

// ── SONGS ─────────────────────────────────────────────────
var SONGS = [
  {id:'twinkle',title:'Twinkle Twinkle Little Star',artist:'Traditional',genre:'Folk',
    bpm:100, timeSig:{beats:4,noteValue:4}, key:'D', backingTrack:'/samples/backing-tracks/twinkle.mp3',
    notes:    ['D4','D4','A4','A4','B4','B4','A4','G4','G4','F#4','F#4','E4','E4','D4','A4','A4','G4','G4','F#4','F#4','E4','A4','A4','G4','G4','F#4','F#4','E4','D4','D4','A4','A4','B4','B4','A4','G4','G4','F#4','F#4','E4','E4','D4'],
    durations:[1,   1,   1,   1,   1,   1,   2,   1,   1,   1,    1,    1,   1,   2,   1,   1,   1,   1,   1,    1,    2,   1,   1,   1,   1,   1,    1,    2,   1,   1,   1,   1,   1,   1,   2,   1,   1,   1,    1,    1,   1,   2   ],
    measures:[
      {noteIndices:[0,1,2,3],      chord:'D', backing:['D2','A2','D3']},  // D D A A
      {noteIndices:[4,5,6],        chord:'G', backing:['G2','D3','G3']},  // B B A½
      {noteIndices:[7,8,9,10],     chord:'G', backing:['G2','D3','G3']},  // G G F# F#
      {noteIndices:[11,12,13],     chord:'A', backing:['A2','E3','A3']},  // E E D½
      {noteIndices:[14,15,16,17],  chord:'A', backing:['A2','E3','A3']},  // A A G G
      {noteIndices:[18,19,20],     chord:'D', backing:['D2','A2','D3']},  // F# F# E½
      {noteIndices:[21,22,23,24],  chord:'A', backing:['A2','E3','A3']},  // A A G G
      {noteIndices:[25,26,27],     chord:'D', backing:['D2','A2','D3']},  // F# F# E½
      {noteIndices:[28,29,30,31],  chord:'D', backing:['D2','A2','D3']},  // D D A A
      {noteIndices:[32,33,34],     chord:'G', backing:['G2','D3','G3']},  // B B A½
      {noteIndices:[35,36,37,38],  chord:'G', backing:['G2','D3','G3']},  // G G F# F#
      {noteIndices:[39,40,41],     chord:'A', backing:['A2','E3','A3']},  // E E D½
    ],
  },
  {id:'ode',title:'Ode to Joy',artist:'Beethoven',genre:'Classical',
    bpm:100, timeSig:{beats:4,noteValue:4}, key:'C', backingTrack:'/samples/backing-tracks/ode.mp3',
    notes:     ['E4','E4','F4','G4','G4','F4','E4','D4','C4','C4','D4','E4','E4','D4','D4',
                'E4','E4','F4','G4','G4','F4','E4','D4','C4','C4','D4','E4','D4','C4','C4',
                'D4','D4','E4','C4','D4','E4','F4','E4','C4','D4','E4','F4','E4','D4','C4','D4','G3',
                'E4','E4','F4','G4','G4','F4','E4','D4','C4','C4','D4','E4','D4','C4','C4'],
    durations: [1,1,1,1,1,1,1,1,1,1,1,1,1.5,0.5,2,
                1,1,1,1,1,1,1,1,1,1,1,1,1.5,0.5,2,
                1,1,1,1,1,0.5,0.5,1,1,1,0.5,0.5,1,1,1,1,2,
                1,1,1,1,1,1,1,1,1,1,1,1,1.5,0.5,2],
    measures:[
      // Phrase 1
      {noteIndices:[0,1,2,3],         chord:'C', backing:['C2','G2','C3']},  // E E F G
      {noteIndices:[4,5,6,7],         chord:'G', backing:['G2','D3','G3']},  // G F E D
      {noteIndices:[8,9,10,11],       chord:'C', backing:['C2','G2','C3']},  // C C D E
      {noteIndices:[12,13,14],        chord:'G', backing:['G2','D3','G3']},  // E. D D½
      // Phrase 2
      {noteIndices:[15,16,17,18],     chord:'C', backing:['C2','G2','C3']},  // E E F G
      {noteIndices:[19,20,21,22],     chord:'G', backing:['G2','D3','G3']},  // G F E D
      {noteIndices:[23,24,25,26],     chord:'C', backing:['C2','G2','C3']},  // C C D E
      {noteIndices:[27,28,29],        chord:'C', backing:['C2','G2','C3']},  // D. C C½
      // Phrase 3 (bridge)
      {noteIndices:[30,31,32,33],     chord:'C', backing:['C2','G2','C3']},  // D D E C
      {noteIndices:[34,35,36,37,38],  chord:'F', backing:['F2','C3','F3']},  // D E♪F♪ E C
      {noteIndices:[39,40,41,42,43],  chord:'G', backing:['G2','D3','G3']},  // D E♪F♪ E D
      {noteIndices:[44,45,46],        chord:'G', backing:['G2','D3','G3']},  // C D G3½
      // Phrase 4
      {noteIndices:[47,48,49,50],     chord:'C', backing:['C2','G2','C3']},  // E E F G
      {noteIndices:[51,52,53,54],     chord:'G', backing:['G2','D3','G3']},  // G F E D
      {noteIndices:[55,56,57,58],     chord:'C', backing:['C2','G2','C3']},  // C C D E
      {noteIndices:[59,60,61],        chord:'C', backing:['C2','G2','C3']},  // D. C C½
    ],
  },
  {id:'amazing',title:'Amazing Grace',artist:'Traditional',genre:'Folk',
    bpm:66, timeSig:{beats:3,noteValue:4}, key:'D',
    notes:     ['A3','D4','Fs4','Fs4','E4','D4','B3','A3',
                'A3','D4','Fs4','Fs4','E4','A4',
                'Fs4','A4','Fs4','Fs4','A3','B3','D4','A3',
                'A3','D4','Fs4','Fs4','E4','D4'],
    durations: [1,2,1,2,1,2,1,2,
                1,2,1,2,1,3,
                1,2,1,2,1,2,1,2,
                1,2,1,2,1,3],
    measures:[
      // Phrase 1
      {noteIndices:[0,1],    chord:'D', backing:['D2','A2','D3']},  // A3(1) D4(2) = 3b
      {noteIndices:[2,3],    chord:'D', backing:['D2','A2','D3']},  // Fs4(1) Fs4(2) = 3b
      {noteIndices:[4,5],    chord:'A', backing:['A2','E3','A3']},  // E4(1) D4(2) = 3b
      {noteIndices:[6,7],    chord:'A', backing:['A2','E3','A3']},  // B3(1) A3(2) = 3b
      // Phrase 2
      {noteIndices:[8,9],    chord:'D', backing:['D2','A2','D3']},  // A3(1) D4(2) = 3b
      {noteIndices:[10,11],  chord:'D', backing:['D2','A2','D3']},  // Fs4(1) Fs4(2) = 3b
      {noteIndices:[12,13],  chord:'A', backing:['A2','E3','A3']},  // E4(1) A4(3) = 4b (pickup+dotted half)
      // Phrase 3
      {noteIndices:[14,15],  chord:'D', backing:['D2','A2','D3']},  // Fs4(1) A4(2) = 3b
      {noteIndices:[16,17],  chord:'D', backing:['D2','A2','D3']},  // Fs4(1) Fs4(2) = 3b
      {noteIndices:[18,19],  chord:'G', backing:['G2','D3','G3']},  // A3(1) B3(2) = 3b
      {noteIndices:[20,21],  chord:'A', backing:['A2','E3','A3']},  // D4(1) A3(2) = 3b
      // Phrase 4
      {noteIndices:[22,23],  chord:'D', backing:['D2','A2','D3']},  // A3(1) D4(2) = 3b
      {noteIndices:[24,25],  chord:'D', backing:['D2','A2','D3']},  // Fs4(1) Fs4(2) = 3b
      {noteIndices:[26,27],  chord:'D', backing:['D2','A2','D3']},  // E4(1) D4(3) = 4b (pickup+dotted half)
    ],
  },
];
var currentSong=null,slNoteIdx=0,slMode='songlearn',slState='idle',slSustainCount=0,slSustainNote=null,slAnimFrame=null,slListenPlaying=false,slListenTimer=null,slListenBpm=80;
var slBackingTimer=null,slBackingBeat3Timer=null,slBackingMeasureIdx=0;
var slBackingAudioBuffer=null;      // decoded AudioBuffer, ready for zero-latency start
var slBackingSource=null;           // currently playing BufferSourceNode
var slBackingDecodePromise=null;    // pending fetch+decode promise, awaited before play
var isLightningRound = false;
var lightningUnlocked = [false,false,false,false];
var pendingLevelIdx = 0;

function getSpeed(){ return SPEEDS[currentSpeedIdx]; }
function getCurrentTime(){ return getSpeed().times[currentLevel]; }

// ── CELEBRATION ──────────────────────────────────────────
var TIER_DATA = [
  {min:100, banner:'PERFECT!',   color:'#fbbf24', noteList:[293.66,440,587.33,880]},
  {min:90,  banner:'EXCELLENT!', color:'#a78bfa', noteList:[329.63,440,587.33]},
  {min:80,  banner:'BRAVO!',     color:'#60a5fa', noteList:[293.66,440,587.33]},
  {min:70,  banner:'WELL DONE!', color:'#4ade80', noteList:[293.66,440]}
];
function getTier(pct){ return TIER_DATA.find(function(t){return pct>=t.min;})||null; }

function playCelebrationFanfare(noteList){
  var ctx=getCtx(),noteLen=0.22,gap=0.06;
  noteList.forEach(function(freq,i){
    var t=ctx.currentTime+i*(noteLen+gap);
    [freq,freq*2.01].forEach(function(f,oi){
      var osc=ctx.createOscillator(),gain=ctx.createGain(),lpf=ctx.createBiquadFilter();
      osc.type='sawtooth';osc.frequency.value=f;lpf.type='lowpass';lpf.frequency.value=2000;
      osc.connect(lpf);lpf.connect(gain);gain.connect(ctx.destination);
      var vol=oi===0?0.18:0.06;
      gain.gain.setValueAtTime(0,t);gain.gain.linearRampToValueAtTime(vol,t+0.04);
      var vib=ctx.createOscillator(),vibG=ctx.createGain();
      vib.frequency.value=5.5;vibG.gain.value=f*0.012;
      vib.connect(vibG);vibG.connect(osc.frequency);
      vib.start(t);vib.stop(t+noteLen+0.1);
      gain.gain.setValueAtTime(vol,t+noteLen-0.06);
      gain.gain.linearRampToValueAtTime(0,t+noteLen);
      osc.start(t);osc.stop(t+noteLen+0.05);
    });
  });
}

function playLightningFanfare(){
  var ctx=getCtx(),notes=[440,587.33,659.25,880,1174.66];
  notes.forEach(function(freq,i){
    var t=ctx.currentTime+i*0.12;
    var osc=ctx.createOscillator(),gain=ctx.createGain();
    osc.type='square';osc.frequency.value=freq;
    osc.connect(gain);gain.connect(ctx.destination);
    gain.gain.setValueAtTime(0,t);gain.gain.linearRampToValueAtTime(0.15,t+0.02);
    gain.gain.linearRampToValueAtTime(0,t+0.1);
    osc.start(t);osc.stop(t+0.12);
  });
}

function launchConfetti(color){
  var canvas=document.getElementById('oa-confetti-canvas');
  canvas.style.display='block';
  var ctx2=canvas.getContext('2d');
  canvas.width=window.innerWidth;canvas.height=window.innerHeight;
  var COLORS=[color,'#fff','#fbbf24','#c4b5fd','#4ade80','#60a5fa'];
  var pieces=[];
  for(var p=0;p<120;p++){
    pieces.push({x:Math.random()*canvas.width,y:-20-Math.random()*100,w:6+Math.random()*8,h:4+Math.random()*6,color:COLORS[Math.floor(Math.random()*COLORS.length)],vx:(Math.random()-0.5)*4,vy:3+Math.random()*5,rot:Math.random()*360,rotV:(Math.random()-0.5)*8,opacity:1});
  }
  var frame;
  function draw(){
    ctx2.clearRect(0,0,canvas.width,canvas.height);var alive=false;
    pieces.forEach(function(p){p.x+=p.vx;p.y+=p.vy;p.rot+=p.rotV;if(p.y>canvas.height*0.7)p.opacity-=0.02;if(p.opacity>0&&p.y<canvas.height+20)alive=true;ctx2.save();ctx2.globalAlpha=Math.max(0,p.opacity);ctx2.translate(p.x,p.y);ctx2.rotate(p.rot*Math.PI/180);ctx2.fillStyle=p.color;ctx2.fillRect(-p.w/2,-p.h/2,p.w,p.h);ctx2.restore();});
    if(alive)frame=requestAnimationFrame(draw);
    else{ctx2.clearRect(0,0,canvas.width,canvas.height);canvas.style.display='none';}
  }
  draw();
  setTimeout(function(){if(frame)cancelAnimationFrame(frame);ctx2.clearRect(0,0,canvas.width,canvas.height);canvas.style.display='none';},4000);
}

function showBowStroke(elId,color){
  var el=document.getElementById(elId);if(!el)return;
  console.log('[bowStroke]',elId,color);
  el.style.background=color||'#4ade80';
  el.style.boxShadow='0 0 10px '+(color||'#4ade80');
  el.style.animation='none';void el.offsetWidth;
  el.style.animation='bowStroke 0.5s ease-out forwards';
}

function showBravoBanner(text,color){
  var banner=document.getElementById('bravo-banner'),el=document.getElementById('bravo-text');
  el.textContent=text;el.style.color=color;el.style.textShadow='0 0 30px '+color;
  banner.classList.add('active');
  setTimeout(function(){banner.classList.remove('active');},2800);
}

function animateScore(targetPct,color){
  var el=document.getElementById('res-score'),glow=document.getElementById('score-card-glow');
  glow.style.background='radial-gradient(circle,'+color+'44 0%,transparent 70%)';glow.style.opacity='1';
  var current=0,step=targetPct/30;el.style.color=color;
  var iv=setInterval(function(){current=Math.min(current+step,targetPct);el.textContent=Math.round(current)+'%';if(current>=targetPct){clearInterval(iv);el.textContent=targetPct+'%';}},30);
}

function celebratePass(pct,wasLightning){
  if(wasLightning){
    playLightningFanfare();
    launchConfetti('#fbbf24');
    showBravoBanner('LIGHTNING CLEARED!','#fbbf24');
    animateScore(pct,'#fbbf24');
  } else {
    var tier=getTier(pct);if(!tier)return;
    playCelebrationFanfare(tier.noteList);
    setTimeout(function(){launchConfetti(tier.color);showBravoBanner(tier.banner,tier.color);document.getElementById('res-icon').classList.add('celebrate');},300);
    animateScore(pct,tier.color);
  }
}

// ── SPEED POPUP ──────────────────────────────────────────
document.getElementById('speed-cancel').addEventListener('click',function(){
  document.getElementById('speed-modal').classList.remove('active');
});
document.getElementById('locked-close').addEventListener('click',function(){
  document.getElementById('locked-modal').classList.remove('active');
});

function openSpeedPopup(levelIdx){
  pendingLevelIdx=levelIdx;
  var lvl=LEVELS[levelIdx];
  document.getElementById('speed-popup-title').textContent=lvl.badge+' '+lvl.title;
  document.getElementById('speed-popup-venue').textContent=lvl.venue;
  var list=document.getElementById('speed-options-list');
  list.innerHTML='';
  SPEEDS.forEach(function(spd,si){
    // Skip lightning if not unlocked for this level
    if(spd.lightning&&!lightningUnlocked[levelIdx])return;
    var div=document.createElement('div');
    div.className='speed-option'+(spd.lightning?' lightning-opt':'');
    var secs=spd.times[levelIdx];
    div.innerHTML='<div class="speed-icon">'+spd.icon+'</div><div class="speed-info"><div class="speed-name" style="color:'+spd.color+'">'+spd.name+'</div><div class="speed-time">'+secs+' seconds per note</div></div>';
    div.addEventListener('click',function(){
      document.getElementById('speed-modal').classList.remove('active');
      currentSpeedIdx=si;
      currentSpeedKey=spd.key;
      isLightningRound=!!spd.lightning;
      startAuditionCore(levelIdx);
    });
    list.appendChild(div);
  });
  document.getElementById('speed-modal').classList.add('active');
}

// ── SETTINGS ─────────────────────────────────────────────
var metroEnabled=true;
document.getElementById('toggle-metro').addEventListener('click',function(){
  metroEnabled=!metroEnabled;
  document.getElementById('toggle-metro').classList.toggle('on',metroEnabled);
  document.getElementById('metro-status').textContent=metroEnabled?'ON':'OFF';
  if(!metroEnabled)stopMetronome();
});
document.getElementById('toggle-ambient').addEventListener('click',function(){
  ambToggle();
  document.getElementById('toggle-ambient').classList.toggle('on',amb.on);
});

// ── AMBIENT ───────────────────────────────────────────────

var amb={on:false,src:null,gain:null,buf:null,fetching:false};
function ambStart(){
  if(!amb.on||amb.src||amb.fetching)return;
  var ctx=getCtx();
  if(ctx.state==='suspended')ctx.resume();
  if(amb.buf){
    amb.src=ctx.createBufferSource();
    amb.gain=ctx.createGain();
    amb.src.buffer=amb.buf;amb.src.loop=true;amb.gain.gain.value=0.15;
    amb.src.connect(amb.gain);amb.gain.connect(ctx.destination);amb.src.start(0);
    console.log('[AUDIO] ambStart: orchestra.wav started (cached)');
    var h=document.getElementById('music-hint');if(h)h.style.display='none';
    return;
  }
  amb.fetching=true;
  fetch('/orchestra.wav').then(function(r){return r.arrayBuffer();}).then(function(b){return ctx.decodeAudioData(b);}).then(function(d){
    amb.fetching=false;
    if(!amb.on)return;
    if(amb.src)return; // another start beat us, don't create a second source
    amb.buf=d;
    amb.src=ctx.createBufferSource();
    amb.gain=ctx.createGain();
    amb.src.buffer=d;amb.src.loop=true;amb.gain.gain.value=0.15;
    amb.src.connect(amb.gain);amb.gain.connect(ctx.destination);amb.src.start(0);
    console.log('[AUDIO] ambStart: orchestra.wav started (looping)');
    var h=document.getElementById('music-hint');if(h)h.style.display='none';
  }).catch(function(e){amb.fetching=false;console.warn('[AUDIO] ambStart error:',e);});
}
function ambStop(){
  if(amb.gain){try{var ctx=getCtx();amb.gain.gain.setValueAtTime(0,ctx.currentTime);}catch(e){}}
  if(amb.src){
    console.log('[AUDIO] ambStop: orchestra.wav stopped');
    try{amb.src.stop(0);}catch(e){console.warn('[AUDIO] ambStop stop error:',e);}
    try{amb.src.disconnect();}catch(e){}
    amb.src=null;
  }
  if(amb.gain){try{amb.gain.disconnect();}catch(e){}amb.gain=null;}
}
function ambToggle(){
  amb.on=!amb.on;
  try{localStorage.setItem('oa_ambient_off',amb.on?'0':'1');}catch(e){}
  if(amb.on){ambStart();}else{ambStop();}
  var tog=document.getElementById('settings-ambient-toggle');
  if(tog){tog.classList.toggle('on',amb.on);}
  var st=document.getElementById('ambient-status');
  if(st){st.textContent=amb.on?'ON':'OFF';}
}

// ── TUNER ────────────────────────────────────────────────
var OPEN_STRINGS_T={G:{freq:196.00,color:'#c2692a'},D:{freq:293.66,color:'#2E8B57'},A:{freq:440.00,color:'#4169E1'},E:{freq:659.25,color:'#CC2200'}};
var CHROM_FREQS=[{note:'G3',freq:196},{note:'G#3',freq:207.65},{note:'A3',freq:220},{note:'A#3',freq:233.08},{note:'B3',freq:246.94},{note:'C4',freq:261.63},{note:'C#4',freq:277.18},{note:'D4',freq:293.66},{note:'D#4',freq:311.13},{note:'E4',freq:329.63},{note:'F4',freq:349.23},{note:'F#4',freq:369.99},{note:'G4',freq:392},{note:'G#4',freq:415.30},{note:'A4',freq:440},{note:'A#4',freq:466.16},{note:'B4',freq:493.88},{note:'C5',freq:523.25},{note:'C#5',freq:554.37},{note:'D5',freq:587.33},{note:'D#5',freq:622.25},{note:'E5',freq:659.25},{note:'F5',freq:698.46},{note:'F#5',freq:739.99},{note:'G5',freq:783.99},{note:'G#5',freq:830.61},{note:'A5',freq:880},{note:'A#5',freq:932.33},{note:'B5',freq:987.77}];
var tunerActive=false,tunerAnalyser=null,tunerFrame=null;

function buildTunerStrings(){
  var row=document.getElementById('tuner-strings');row.innerHTML='';
  ['G','D','A','E'].forEach(function(s){
    var info=OPEN_STRINGS_T[s],div=document.createElement('div');
    div.className='tuner-str';div.id='tstr-'+s;
    div.innerHTML='<span class="ts-letter" style="color:'+info.color+'">'+s+'</span><span class="ts-freq">'+info.freq+'Hz</span>';
    row.appendChild(div);
  });
}
document.getElementById('tuner-home-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal-title').textContent='Tune Your Violin';
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});
document.getElementById('tuner-close-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal').classList.remove('active');
  stopTunerLoop();
  if(amb.on){ambStart();}
});
function startTunerLoop(){
  if(!tunerAnalyser&&analyser)tunerAnalyser=analyser;
  if(!tunerAnalyser)return;tunerActive=true;
  var buf=new Float32Array(tunerAnalyser.fftSize);

  // Smoothing + hold/decay state
  var freqBuf=[];       // [[freq, timestamp], ...]
  var displayClamp=0;   // smoothed needle position (-50..50)
  var signalTs=0;       // last frame with live signal
  var holdClamp=0;      // displayClamp saved when signal dropped
  var holdBest=null;    // nearest note at signal drop
  var holdFreq=0;       // smoothed freq at signal drop
  var prevActive=false;
  var HOLD_MS=2500, DECAY_MS=2000;

  function tunerColor(cents){
    var a=Math.abs(cents);
    if(a<=5) return{col:'#4ade80',zone:'In Tune!'};
    if(a<=10) return{col:'#86efac',zone:cents<0?'Slightly Flat':'Slightly Sharp'};
    if(a<=20) return{col:'#fbbf24',zone:cents<0?'Tune Up':'Tune Down'};
    if(a<=35) return{col:'#fb923c',zone:cents<0?'Too Flat':'Too Sharp'};
    return{col:'#f87171',zone:cents<0?'Very Flat':'Very Sharp'};
  }

  function setNeedle(clamp,best,freq,cents,faded){
    var cc=tunerColor(cents!==null?cents:clamp);
    var col=faded?'rgba(255,255,255,0.3)':cc.col;
    var deg=clamp/50*90;
    document.getElementById('gauge-needle').style.transform='rotate('+deg+'deg)';
    document.getElementById('needle-poly').style.fill=col;
    var cn=document.getElementById('tuner-center-note');
    if(cn){cn.textContent=best.note;cn.style.fill=col;}
    var cx=150,cy=165,r=132;
    function p2c(a){var rad=(a-90)*Math.PI/180;return{x:cx+r*Math.cos(rad),y:cy+r*Math.sin(rad)};}
    var s=p2c(0),e=p2c(deg),sw=deg>=0?1:0;
    var aa=document.getElementById('tuner-active-arc');
    aa.setAttribute('d','M '+s.x.toFixed(1)+' '+s.y.toFixed(1)+' A '+r+' '+r+' 0 0 '+sw+' '+e.x.toFixed(1)+' '+e.y.toFixed(1));
    aa.setAttribute('stroke',col);aa.setAttribute('opacity',faded?'0.4':'1');
    if(!faded){
      document.getElementById('gauge-target').textContent='Target: '+best.freq.toFixed(2)+' Hz';
      document.getElementById('gauge-detected').textContent='Detected: '+freq.toFixed(1)+' Hz';
      document.getElementById('tuner-status').textContent=cc.zone;
      document.getElementById('tuner-status').style.color=col;
    }
    ['G','D','A','E'].forEach(function(s){
      var el=document.getElementById('tstr-'+s);if(!el)return;
      var on=!faded&&freq>=OPEN_STRINGS_T[s].freq*0.9&&freq<=OPEN_STRINGS_T[s].freq*1.35;
      el.classList.toggle('active',on);el.style.background=on?OPEN_STRINGS_T[s].color+'33':'rgba(0,0,0,0.25)';
    });
  }

  function resetTuner(){
    displayClamp=0;holdClamp=0;holdBest=null;holdFreq=0;freqBuf=[];
    document.getElementById('gauge-needle').style.transform='rotate(0deg)';
    var cn=document.getElementById('tuner-center-note');if(cn){cn.textContent='--';cn.style.fill='rgba(255,255,255,0.25)';}
    var aa=document.getElementById('tuner-active-arc');if(aa){aa.setAttribute('opacity','0');}
    var np=document.getElementById('needle-poly');if(np){np.style.fill='rgba(255,255,255,0.5)';}
    document.getElementById('gauge-target').textContent='Target: --';
    document.getElementById('gauge-detected').textContent='Detected: --';
    document.getElementById('tuner-status').textContent='Play a string to begin tuning';
    document.getElementById('tuner-status').style.color='#fff';
    ['G','D','A','E'].forEach(function(s){var el=document.getElementById('tstr-'+s);if(el){el.classList.remove('active');el.style.background='rgba(0,0,0,0.25)';}});
  }

  function loop(){
    if(!tunerActive){tunerFrame=null;return;}
    tunerFrame=requestAnimationFrame(loop);
    tunerAnalyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var now=performance.now();
    var active=freq>100&&rms>0.01;

    if(active){
      if(!prevActive){freqBuf=[];} // clear stale history on new note
      prevActive=true;
      signalTs=now;
      // Smooth freq: exponential-weighted average over 180ms window
      freqBuf.push([freq,now]);
      while(freqBuf.length>1&&now-freqBuf[0][1]>180)freqBuf.shift();
      var ws=0,wt=0;
      freqBuf.forEach(function(e){var w=Math.exp(-(now-e[1])/80);ws+=e[0]*w;wt+=w;});
      var sf=wt>0?ws/wt:freq;
      // Find nearest note
      var best=null,minD=Infinity;
      CHROM_FREQS.forEach(function(n){var d=Math.abs(sf-n.freq);if(d<minD){minD=d;best=n;}});
      if(!best)return;
      var cents=1200*Math.log2(sf/best.freq);
      var target=Math.max(-50,Math.min(50,cents));
      displayClamp+=(target-displayClamp)*0.18; // lerp needle
      holdClamp=displayClamp;holdBest=best;holdFreq=sf;
      setNeedle(displayClamp,best,sf,Math.round(cents),false);
    } else {
      prevActive=false;
      var elapsed=now-signalTs;
      if(elapsed<HOLD_MS){
        // Hold — show last reading unchanged
        if(holdBest)setNeedle(displayClamp,holdBest,holdFreq,null,false);
      } else if(elapsed<HOLD_MS+DECAY_MS){
        // Decay — needle drifts to center, slightly faded
        var t=(elapsed-HOLD_MS)/DECAY_MS;
        displayClamp=holdClamp*(1-t);
        if(holdBest)setNeedle(displayClamp,holdBest,holdFreq,null,true);
      } else {
        if(holdBest)resetTuner(); // only fires once (holdBest becomes null)
      }
    }
  }
  loop();
}
function stopTunerLoop(){tunerActive=false;if(tunerFrame){cancelAnimationFrame(tunerFrame);tunerFrame=null;}}

// ── BPM ──────────────────────────────────────────────────
var playerBpm=60;
function updateBpm(val){
  playerBpm=parseInt(val);
  document.getElementById('bpm-display').textContent=playerBpm;
  document.getElementById('bpm-slider').value=playerBpm;
  document.querySelectorAll('.bpm-preset').forEach(function(b){b.classList.remove('active');});
  var a=document.querySelector('.bpm-preset[data-bpm="'+playerBpm+'"]');if(a)a.classList.add('active');
  var tag=document.getElementById('metro-bpm-tag');if(tag)tag.textContent=playerBpm+' BPM';
}
document.getElementById('bpm-slider').addEventListener('input',function(e){updateBpm(e.target.value);});
document.querySelectorAll('.bpm-preset').forEach(function(btn){btn.addEventListener('click',function(){updateBpm(btn.dataset.bpm);});});

// ── METRONOME ────────────────────────────────────────────
var metroInterval=null,metroBeat=0,METRO_DOTS=4;
function playClick(isHigh){
  var ctx=getCtx(),osc=ctx.createOscillator(),gain=ctx.createGain();
  osc.connect(gain);gain.connect(ctx.destination);
  osc.frequency.value=isHigh?1200:800;osc.type='sine';
  gain.gain.setValueAtTime(isHigh?0.4:0.25,ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.06);
  osc.start(ctx.currentTime);osc.stop(ctx.currentTime+0.07);
}
function buildMetroDots(){
  var row=document.getElementById('metro-beats');row.innerHTML='';
  for(var i=0;i<METRO_DOTS;i++){var d=document.createElement('div');d.className='metro-dot'+(i===0?' beat1':'');d.id='mdot-'+i;row.appendChild(d);}
}
function startMetronome(){
  if(!metroEnabled){document.getElementById('metro-bar').style.opacity='0.3';return;}
  document.getElementById('metro-bar').style.opacity='1';
  stopMetronome();metroBeat=0;buildMetroDots();
  var tag=document.getElementById('metro-bpm-tag');if(tag)tag.textContent=playerBpm+' BPM';
  console.log('[AUDIO] startMetronome: started at '+playerBpm+' BPM');
  fireMetroBeat();
  metroInterval=setInterval(function(){metroBeat=(metroBeat+1)%METRO_DOTS;fireMetroBeat();},(60/playerBpm)*1000);
}
function fireMetroBeat(){
  if(!metroEnabled)return;
  console.log('[AUDIO] metronome click beat='+metroBeat);
  playClick(metroBeat===0);
  for(var i=0;i<METRO_DOTS;i++){var d=document.getElementById('mdot-'+i);if(!d)continue;d.className='metro-dot'+(i===0?' beat1':'')+(i===metroBeat?' active':'');}
}
function stopMetronome(){if(metroInterval){console.log('[AUDIO] stopMetronome: stopped');clearInterval(metroInterval);metroInterval=null;}}

// ── LEVEL TIMER ──────────────────────────────────────────
var levelTimerInterval=null,levelTimeLeft=25,levelTimerTotal=25,halfwayRevealed=false;
function startLevelTimer(){
  stopLevelTimer();
  levelTimerTotal=getCurrentTime();levelTimeLeft=levelTimerTotal;halfwayRevealed=false;
  updateTimerDisplay();
  levelTimerInterval=setInterval(function(){
    levelTimeLeft--;updateTimerDisplay();
    if(!halfwayRevealed&&levelTimeLeft<=Math.floor(levelTimerTotal/2)){
      halfwayRevealed=true;
      if(!fbVisible&&!isLightningRound){revealFingerboard('halfway');var hEntry=noteQueue[noteIdx];renderFingerboard(getNote(hEntry),'neutral');}
    }
    if(levelTimeLeft<=0){stopLevelTimer();onTimeout();}
  },1000);
}
function stopLevelTimer(){if(levelTimerInterval){clearInterval(levelTimerInterval);levelTimerInterval=null;}}
function updateTimerDisplay(){
  var pct=levelTimeLeft/levelTimerTotal;
  var fill=document.getElementById('level-timer-fill'),num=document.getElementById('level-timer-num');
  var spd=getSpeed();
  fill.style.width=(pct*100)+'%';
  fill.classList.toggle('urgent',levelTimeLeft<=3);
  if(isLightningRound){
    fill.style.background='linear-gradient(90deg,#fbbf24,#f59e0b)';
    num.style.color='#fbbf24';
  } else {
    fill.style.background=pct>0.5?spd.color:pct>0.25?'#fb923c':'#f87171';
    num.style.color=levelTimeLeft<=3?'#f87171':levelTimeLeft<=5?'#fb923c':'#fff';
  }
  num.textContent=levelTimeLeft;
}

// ── COUNTDOWN ────────────────────────────────────────────
function startCountdown(onDone){
  var overlay=document.getElementById('countdown-overlay'),numEl=document.getElementById('countdown-num'),msgEl=document.getElementById('countdown-msg');
  overlay.classList.add('active');
  var n=5;
  var msgs=isLightningRound?['Lightning Round!','No hints this time!','Every second counts!','Maximum speed!','GO GO GO!']:['Pick up your violin...','Find your position...','Take a breath...','Watch for the note...','Here we go!'];
  numEl.textContent=n;msgEl.textContent=msgs[5-n];
  var tick=setInterval(function(){
    n--;if(n<=0){clearInterval(tick);overlay.classList.remove('active');onDone();}
    else{numEl.textContent=n;msgEl.textContent=msgs[5-n];playClick(true);}
  },1000);
}

// ── TIMEOUT ──────────────────────────────────────────────
function onTimeout(){
  if(feedbackTimer)clearTimeout(feedbackTimer);stopMetronome();dState='cooldown';
  var target=noteQueue[noteIdx]||'?';
  document.getElementById('staff-card').className='staff-card timeout';
  document.getElementById('note-display').className='note-display wrong';
  setFb("Time's up!",'The note was '+target,'#f87171');
  setTimeout(function(){
    document.getElementById('go-note').textContent='Missed: '+target;
    document.getElementById('go-tempo').textContent='Tempo: '+playerBpm+' BPM';
    document.getElementById('go-lower-bpm').textContent='('+Math.max(30,playerBpm-10)+' BPM)';
    showScreen('gameover');
  },700);
}
document.getElementById('go-btn-lower').addEventListener('click',function(){playerBpm=Math.max(30,playerBpm-10);updateBpm(playerBpm);startAuditionCore(currentLevel);});
document.getElementById('go-btn-same').addEventListener('click',function(){startAuditionCore(currentLevel);});
document.getElementById('go-btn-home2').addEventListener('click',goHome);

// ── FINGERBOARD ──────────────────────────────────────────
var fbVisible=false,fbPinnedByUser=false;
document.getElementById('hint-btn').addEventListener('click',function(){
  if(isLightningRound)return;fbPinnedByUser=true;revealFingerboard('manual');
});
function revealFingerboard(reason){
  if(fbVisible||isLightningRound)return;fbVisible=true;
  var card=document.getElementById('fingerboard-card'),btn=document.getElementById('hint-btn');
  card.classList.remove('hidden');card.classList.add('popped');btn.classList.add('hidden');
  if(reason==='manual'||reason==='halfway'){var t=noteQueue[noteIdx];if(t)renderFingerboard(t,'neutral');}
}
function hideFingerboard(){
  fbVisible=false;fbPinnedByUser=false;
  var card=document.getElementById('fingerboard-card'),btn=document.getElementById('hint-btn');
  card.classList.add('hidden');card.classList.remove('popped','showing','correct-mode');btn.classList.remove('hidden');
}

// ── DATA ─────────────────────────────────────────────────
var NOTE_TO_SLOT={G3:{string:'G',slot:0},'G#3':{string:'G',slot:1},A3:{string:'G',slot:2},'A#3':{string:'G',slot:3},B3:{string:'G',slot:4},C4:{string:'G',slot:5},'C#4':{string:'G',slot:6},D4:{string:'D',slot:0},'D#4':{string:'D',slot:1},E4:{string:'D',slot:2},F4:{string:'D',slot:3},'F#4':{string:'D',slot:4},G4:{string:'D',slot:5},'G#4':{string:'D',slot:6},A4:{string:'A',slot:0},'A#4':{string:'A',slot:1},B4:{string:'A',slot:2},C5:{string:'A',slot:3},'C#5':{string:'A',slot:4},D5:{string:'A',slot:5},'D#5':{string:'A',slot:6},E5:{string:'E',slot:0},F5:{string:'E',slot:1},'F#5':{string:'E',slot:2},G5:{string:'E',slot:3},'G#5':{string:'E',slot:4},A5:{string:'E',slot:5},'A#5':{string:'E',slot:6},B5:{string:'E',slot:7},C6:{string:'E',slot:7},D6:{string:'E',slot:7},E6:{string:'E',slot:7}};
var CHROMATIC_STRINGS={G:['G3','G#3','A3','A#3','B3','C4','C#4','D4'],D:['D4','D#4','E4','F4','F#4','G4','G#4','A4'],A:['A4','A#4','B4','C5','C#5','D5','D#5','E5'],E:['E5','F5','F#5','G5','G#5','A5','A#5','B5']};
var VIOLIN_STRINGS={G:{name:'G string',color:'#c2692a',range:[180,289]},D:{name:'D string',color:'#2E8B57',range:[290,435]},A:{name:'A string',color:'#4169E1',range:[436,648]},E:{name:'E string',color:'#CC2200',range:[650,1400]}};
var NOTE_FINGER_LABEL={G3:'Open G string',A3:'1st finger G',B3:'2nd finger G',C4:'3rd finger G',D4:'Open D string',E4:'1st finger D',F4:'Low 2nd D',G4:'3rd finger D',A4:'Open A string',B4:'1st finger A',C5:'Low 2nd A',D5:'3rd finger A',E5:'Open E string',F5:'Low 1st E',G5:'2nd finger E',A5:'3rd finger E',B5:'4th finger E',C6:'High 4th E',D6:'Ext 4th E',E6:'High pos E'};
var NOTE_FINGER_NUM={G3:'O',A3:'1',B3:'2',C4:'3',D4:'O',E4:'1',F4:'2',G4:'3',A4:'O',B4:'1',C5:'2',D5:'3',E5:'O',F5:'1',G5:'2',A5:'3',B5:'4',C6:'4',D6:'4',E6:'4'};
var NOTE_FREQ={
  G3:196.00,'G#3':207.65,A3:220.00,'A#3':233.08,B3:246.94,
  C4:261.63,'C#4':277.18,D4:293.66,'D#4':311.13,E4:329.63,F4:349.23,'F#4':369.99,
  G4:392.00,'G#4':415.30,A4:440.00,'A#4':466.16,B4:493.88,
  C5:523.25,'C#5':554.37,D5:587.33,'D#5':622.25,E5:659.25,F5:698.46,'F#5':739.99,
  G5:783.99,'G#5':830.61,A5:880.00,'A#5':932.33,B5:987.77,
  C6:1046.5,D6:1174.66,E6:1318.51
};
var STEPS_ABOVE_E4={
  G3:-5,'G#3':-4.5,A3:-4,'A#3':-3.5,B3:-3,
  C4:-2,'C#4':-1.5,D4:-1,'D#4':-0.5,E4:0,F4:0.5,'F#4':1,
  G4:1.5,'G#4':2,A4:2.5,'A#4':3,B4:3.5,  // using half-steps for display offset actually use whole steps
  C5:5,'C#5':5.5,D5:6,'D#5':6.5,E5:7,F5:7.5,'F#5':8,
  G5:9,'G#5':9.5,A5:10,'A#5':10.5,B5:11,
  C6:12,D6:13,E6:14
};
// For staff rendering, accidentals share the same line/space as their natural
// We display them on the natural note's position with an accidental symbol
var NOTE_ACCIDENTAL={
  'G#3':'#','A#3':'b','C#4':'#','D#4':'#','F#4':'#',
  'G#4':'#','A#4':'b','C#5':'#','D#5':'#','F#5':'#',
  'G#5':'#','A#5':'b','C#6':'#','D#6':'#'
};
var NOTE_NATURAL_STEP={
  'G#3':-5,'A#3':-4,'C#4':-2,'D#4':-1,'F#4':1,
  'G#4':2,'A#4':3,'C#5':5,'D#5':6,'F#5':8,
  'G#5':9,'A#5':10
};
var STRING_ORDER=['G','D','A','E'];
var ALL_NATURAL_NOTES=['G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5','A5','B5','C6','D6','E6'];
var LEVELS=[
  {
    id:1,title:'School Orchestra',subtitle:'Beginner',venue:'Lincoln Middle School',
    judge:'Mr. Thompson',badge:'🏫',color:'#4ade80',
    mode:'notes',
    notes:['E4','F4','G4','A4','B4','C5','D5','E5'],
    totalNotes:8,passing:70,
    description:'Natural notes only'
  },
  {
    id:2,title:'Youth Symphony',subtitle:'Intermediate',venue:'City Arts Center',
    judge:'Ms. Chen',badge:'🎭',color:'#60a5fa',
    mode:'notes',
    notes:['G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5',
           'G#3','A#3','C#4','D#4','F#4','G#4','A#4','C#5','D#5','F#5'],
    totalNotes:10,passing:75,
    description:'Naturals + sharps & flats'
  },
  {
    id:3,title:'Conservatory',subtitle:'Advanced',venue:'Royal Academy Hall',
    judge:'Maestro Volkov',badge:'🎓',color:'#f59e0b',
    mode:'intervals',
    intervals:[
      ['G3','D4','5th'],['A3','E4','5th'],['B3','F#4','5th'],
      ['C4','G4','5th'],['D4','A4','5th'],['E4','B4','5th'],
      ['F4','C5','5th'],['G4','D5','5th'],['A4','E5','5th'],
      ['G3','B3','3rd'],['A3','C#4','3rd'],['C4','E4','3rd'],
      ['D4','F#4','3rd'],['E4','G#4','3rd'],['G4','B4','3rd'],
      ['A4','C#5','3rd'],['D5','F#5','3rd']
    ],
    totalNotes:12,passing:80,
    description:'Two-note intervals'
  },
  {
    id:4,title:'Carnegie Hall',subtitle:'Elite',venue:'Carnegie Hall, New York',
    judge:'Maestro Bernstein',badge:'🏆',color:'#a78bfa',
    mode:'scales',
    scales:[
      {name:'G Major',    asc:['G3','A3','B3','C4','D4','E4','F#4','G4'], desc:['G4','F#4','E4','D4','C4','B3','A3','G3']},
      {name:'D Major',    asc:['D4','E4','F#4','G4','A4','B4','C#5','D5'],desc:['D5','C#5','B4','A4','G4','F#4','E4','D4']},
      {name:'A Major',    asc:['A3','B3','C#4','D4','E4','F#4','G#4','A4'],desc:['A4','G#4','F#4','E4','D4','C#4','B3','A3']},
      {name:'E Major',    asc:['E4','F#4','G#4','A4','B4','C#5','D#5','E5'],desc:['E5','D#5','C#5','B4','A4','G#4','F#4','E4']},
      {name:'G Mel. Minor',asc:['G3','A3','A#3','C4','D4','E4','F#4','G4'],desc:['G4','F4','D#4','D4','C4','A#3','A3','G3']},
      {name:'D Mel. Minor',asc:['D4','E4','F4','G4','A4','B4','C#5','D5'], desc:['D5','C5','A#4','A4','G4','F4','E4','D4']},
      {name:'A Mel. Minor',asc:['A3','B3','C4','D4','E4','F#4','G#4','A4'],desc:['A4','G4','F4','E4','D4','C4','B3','A3']},
      {name:'E Mel. Minor',asc:['E4','F#4','G4','A4','B4','C#5','D#5','E5'],desc:['E5','D5','C5','B4','A4','G4','F#4','E4']}
    ],
    totalNotes:16,passing:85,
    description:'Major & melodic minor scales'
  }
];
function getExpectedString(n){return NOTE_TO_SLOT[n]?NOTE_TO_SLOT[n].string:null;}

// ── RENDERERS ────────────────────────────────────────────
function renderFingerboard(note,mode){
  var svg=document.getElementById('fingerboard-svg');
  var lookup=NOTE_TO_SLOT[note];if(!lookup){svg.innerHTML='';return;}
  var targetStr=lookup.string,targetSlot=lookup.slot,strInfo=VIOLIN_STRINGS[targetStr];
  var neckL=20,neckR=92,nutY=24,numSlots=7,slotH=24,neckH=numSlots*slotH;
  var strX=STRING_ORDER.map(function(_,i){return neckL+(neckR-neckL)*(i/3);});
  function slotCY(slot){return slot===0?nutY-15:nutY+(slot-1)*slotH+slotH/2;}
  var dotColor=mode==='correct'?'#4ade80':(mode==='wrong'||mode==='wrong-string')?'#fb923c':'#4ade80';
  var html='';
  html+='<rect x="'+neckL+'" y="'+nutY+'" width="'+(neckR-neckL)+'" height="'+neckH+'" rx="2" fill="rgba(90,55,25,0.35)" stroke="rgba(120,75,35,0.5)" stroke-width="1"/>';
  html+='<rect x="'+(neckL-2)+'" y="'+(nutY-5)+'" width="'+(neckR-neckL+4)+'" height="6" rx="2" fill="rgba(255,255,255,0.85)"/>';
  var chromStr=CHROMATIC_STRINGS[targetStr]||[];
  for(var s=1;s<=numSlots;s++){
    var cy=slotCY(s),noteName=chromStr[s]||'',isNatural=noteName&&noteName.indexOf('#')===-1;
    html+='<line x1="'+(neckL-8)+'" y1="'+cy+'" x2="'+neckL+'" y2="'+cy+'" stroke="'+(isNatural?'rgba(255,255,255,0.5)':'rgba(255,255,255,0.15)')+'" stroke-width="'+(isNatural?1.2:0.7)+'"/>';
    if(isNatural)html+='<text x="'+(neckL-10)+'" y="'+(cy+3)+'" font-size="7" fill="rgba(255,255,255,0.38)" text-anchor="end">'+noteName+'</text>';
  }
  [[2,'1'],[4,'2'],[5,'3'],[7,'4']].forEach(function(arr){
    var lineY=nutY+arr[0]*slotH;
    html+='<line x1="'+neckL+'" y1="'+lineY+'" x2="'+neckR+'" y2="'+lineY+'" stroke="rgba(255,255,255,0.2)" stroke-width="1"/>';
    html+='<text x="'+(neckR+6)+'" y="'+(lineY+4)+'" font-size="8" fill="rgba(255,255,255,0.25)">'+arr[1]+'</text>';
  });
  var strThick=[2.8,2.1,1.5,1.0];
  STRING_ORDER.forEach(function(s,i){
    var sx=strX[i],isTarget=s===targetStr,sc=isTarget?VIOLIN_STRINGS[s].color:'rgba(200,185,150,0.2)',tw=isTarget?strThick[i]+0.9:strThick[i];
    html+='<line x1="'+sx+'" y1="'+nutY+'" x2="'+sx+'" y2="'+(nutY+neckH+8)+'" stroke="'+sc+'" stroke-width="'+tw+'"/>';
    if(isTarget&&targetSlot===0)html+='<line x1="'+sx+'" y1="'+(nutY-22)+'" x2="'+sx+'" y2="'+nutY+'" stroke="'+sc+'" stroke-width="'+tw+'" stroke-dasharray="3,2"/>';
    html+='<text x="'+sx+'" y="'+(nutY+neckH+20)+'" font-size="9" fill="'+(isTarget?VIOLIN_STRINGS[s].color:'rgba(255,255,255,0.18)')+'" text-anchor="middle" font-weight="'+(isTarget?'bold':'normal')+'">'+s+'</text>';
  });
  var si=STRING_ORDER.indexOf(targetStr),sx=strX[si],dy=slotCY(targetSlot),fingerNum=NOTE_FINGER_NUM[note]||'?';
  var isPulse=(mode==='wrong'||mode==='wrong-string');
  if(targetSlot===0){
    html+='<circle cx="'+sx+'" cy="'+dy+'" r="9" fill="none" stroke="'+dotColor+'" stroke-width="2.5"></circle>';
    html+='<text x="'+sx+'" y="'+(dy+4)+'" font-size="11" fill="'+dotColor+'" text-anchor="middle" font-weight="bold">O</text>';
  }else{
    html+='<circle cx="'+sx+'" cy="'+dy+'" r="11" fill="'+dotColor+'"></circle>';
    html+='<text x="'+sx+'" y="'+(dy+4)+'" font-size="13" fill="#000" text-anchor="middle" font-weight="bold">'+fingerNum+'</text>';
  }
  svg.innerHTML=html;
  if(isPulse){var circles=svg.querySelectorAll('circle');var lc=circles[circles.length-1];if(lc){lc.classList.remove('finger-pulse');void lc.offsetWidth;lc.classList.add('finger-pulse');}}
  var card=document.getElementById('fingerboard-card');
  var labelColor=mode==='wrong'||mode==='wrong-string'?'#fb923c':mode==='correct'?'#4ade80':'#fff';
  if(mode==='wrong'||mode==='wrong-string'){card.className='fingerboard-card showing';document.getElementById('fb-card-title').textContent='PLAY THIS INSTEAD';document.getElementById('fb-card-title').style.color='#fb923c';document.getElementById('fb-finger-label').style.color='rgba(255,165,0,0.75)';}
  else if(mode==='correct'){card.className='fingerboard-card correct-mode';document.getElementById('fb-card-title').textContent='WELL DONE!';document.getElementById('fb-card-title').style.color='#4ade80';document.getElementById('fb-finger-label').style.color='rgba(74,222,128,0.65)';}
  else{card.className='fingerboard-card';document.getElementById('fb-card-title').textContent='TARGET NOTE';document.getElementById('fb-card-title').style.color='rgba(255,255,255,0.35)';document.getElementById('fb-finger-label').style.color='rgba(255,255,255,0.4)';}
  document.getElementById('fb-note-name').textContent=note||'--';document.getElementById('fb-note-name').style.color=labelColor;
  document.getElementById('fb-string-name').textContent=strInfo?strInfo.name:'--';document.getElementById('fb-string-name').style.color=strInfo?strInfo.color:'rgba(255,255,255,0.4)';
  document.getElementById('fb-finger-label').textContent=NOTE_FINGER_LABEL[note]||'';
}

function renderStaff(note,state){
  var svg=document.getElementById('staff-svg');
  var svgW=175,LS=12,halfStep=LS/2,staffBottomY=105,noteX=130,html='';
  for(var i=0;i<5;i++)html+='<line x1="10" y1="'+(staffBottomY-i*LS)+'" x2="'+(svgW-5)+'" y2="'+(staffBottomY-i*LS)+'" stroke="rgba(255,255,255,0.38)" stroke-width="1.4"/>';
  html+='<text x="10" y="'+(staffBottomY+22)+'" font-size="58" fill="rgba(255,255,255,0.72)" font-family="serif">\uD834\uDD1E</text>';
  // For accidentals, use the natural note's step position + render accidental symbol
  var displayNote=note;
  var accidentalSymbol='';
  if(note&&NOTE_ACCIDENTAL&&NOTE_ACCIDENTAL[note]){
    accidentalSymbol=NOTE_ACCIDENTAL[note]==='#'?'\u266F':'\u266D';
    // Use natural step for positioning
    displayNote=note; // keep for freq lookup, use NOTE_NATURAL_STEP for y position
  }
  if(note&&(STEPS_ABOVE_E4[note]!==undefined||NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined)){
    var rawSteps=STEPS_ABOVE_E4[note]!==undefined?STEPS_ABOVE_E4[note]:(NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined?NOTE_NATURAL_STEP[note]:0);
    var steps=Math.round(rawSteps); // round to nearest whole step for staff line
    var ny=staffBottomY-steps*halfStep,col=state==='correct'?'#4ade80':state==='wrong'?'#f87171':'#fff';
    if(steps<0){for(var s=-2;s>=steps;s-=2)html+='<line x1="'+(noteX-13)+'" y1="'+(staffBottomY-s*halfStep)+'" x2="'+(noteX+13)+'" y2="'+(staffBottomY-s*halfStep)+'" stroke="'+col+'" stroke-width="1.4" opacity="0.8"/>';}
    if(steps>8){for(var s2=10;s2<=steps;s2+=2)html+='<line x1="'+(noteX-13)+'" y1="'+(staffBottomY-s2*halfStep)+'" x2="'+(noteX+13)+'" y2="'+(staffBottomY-s2*halfStep)+'" stroke="'+col+'" stroke-width="1.4" opacity="0.8"/>';}
    if(state==='correct')html+='<ellipse cx="'+noteX+'" cy="'+ny+'" rx="15" ry="10" fill="rgba(74,222,128,0.15)" transform="rotate(-15,'+noteX+','+ny+')"/>';
    html+='<ellipse cx="'+noteX+'" cy="'+ny+'" rx="8" ry="5.8" fill="'+col+'" transform="rotate(-15,'+noteX+','+ny+')"/>';
    html+=steps<=4?'<line x1="'+(noteX+7)+'" y1="'+ny+'" x2="'+(noteX+7)+'" y2="'+(ny-30)+'" stroke="'+col+'" stroke-width="1.4"/>':'<line x1="'+(noteX-7)+'" y1="'+ny+'" x2="'+(noteX-7)+'" y2="'+(ny+30)+'" stroke="'+col+'" stroke-width="1.4"/>';
    // Render accidental symbol to the left of the note head
    if(accidentalSymbol){
      html+='<text x="'+(noteX-18)+'" y="'+(ny+6)+'" font-size="16" fill="'+col+'" font-family="serif">'+accidentalSymbol+'</text>';
    }
  }
  svg.innerHTML=html;
}

// ── MIC & PITCH ──────────────────────────────────────────
// iOS Safari needs lower thresholds - mic input is processed differently
var IS_IOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
var RMS_THRESHOLD = IS_IOS ? 0.010 : 0.015;  // more sensitive
var SUSTAIN_FRAMES = IS_IOS ? 5 : 8;  // faster detection
var COOLDOWN_MS = 500;
var NOTE_TOL = IS_IOS ? 25 : 22;  // more forgiving
var currentLevel=0,unlockedLevels=[0],noteQueue=[],noteIdx=0,correct=0,total=0,streak=0;
var analyser=null,micStream=null,animFrame=null,micGranted=false;
var feedbackTimer=null,cooldownTimer=null;
var dState='idle',sustainCount=0,sustainNote=null,sustainStr=null;

function detectPitch(buf,sr){
  var SIZE=buf.length,MAX=Math.floor(SIZE/2),rms=0;
  for(var i=0;i<SIZE;i++)rms+=buf[i]*buf[i];rms=Math.sqrt(rms/SIZE);
  if(rms<RMS_THRESHOLD)return{freq:-1,rms:rms};
  // Reliable autocorrelation - search violin range G3(196) to E6(1318)
  var minOff=Math.floor(sr/1400);
  var maxOff=Math.floor(sr/150);
  var best=-1,bestCorr=0.75,lastCorr=1;  // violin needs lower threshold
  for(var off=minOff;off<maxOff;off++){
    var c=0;
    for(var j=0;j<MAX;j++) c+=Math.abs(buf[j]-buf[j+off]);
    c=1-c/MAX;
    if(c>bestCorr&&c>lastCorr){bestCorr=c;best=off;}
    lastCorr=c;
  }
  return{freq:best!==-1?sr/best:-1,rms:rms};
}
function freqToNote(freq){
  if(!freq||freq<150)return null;var best=null,minD=Infinity;
  Object.keys(NOTE_FREQ).forEach(function(n){var d=Math.abs(freq-NOTE_FREQ[n]);if(d<minD){minD=d;best=n;}});
  return minD<NOTE_TOL?best:null;
}
function detectString(freq){
  if(!freq)return null;var keys=Object.keys(VIOLIN_STRINGS);
  for(var i=0;i<keys.length;i++){var s=VIOLIN_STRINGS[keys[i]];if(freq>=s.range[0]&&freq<=s.range[1])return keys[i];}return null;
}
function startMic(){
  if(micGranted)return Promise.resolve();
  // iOS requires specific audio constraints for best pitch detection
  var constraints = IS_IOS ? {
    audio: {
      echoCancellation: false,
      noiseSuppression: false,
      autoGainControl: false,
      sampleRate: 44100
    }
  } : {audio: true};
  return navigator.mediaDevices.getUserMedia(constraints).then(function(stream){
    micStream=stream;var ctx=getCtx();
    // iOS needs larger fftSize for better low-frequency detection
    analyser=ctx.createAnalyser();
    analyser.fftSize = IS_IOS ? 8192 : 4096;
    analyser.smoothingTimeConstant = 0.0;
    ctx.createMediaStreamSource(stream).connect(analyser);
    micGranted=true;tunerAnalyser=analyser;
    document.getElementById('mic-dot').style.background='#4ade80';
    document.getElementById('mic-label').textContent='Listening...';
  }).catch(function(e){
    document.getElementById('mic-dot').style.background='#f87171';
    document.getElementById('mic-label').textContent='Mic denied';
    console.log('Mic error:', e);
  });
}
function startGameLoop(){
  if(!analyser)return;if(animFrame)cancelAnimationFrame(animFrame);
  var buf=new Float32Array(analyser.fftSize);
  function loop(){
    animFrame=requestAnimationFrame(loop);
    analyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var vp=Math.min(100,Math.round(rms*800));
    document.getElementById('vol-fill').style.width=vp+'%';
    document.getElementById('vol-fill').style.background=rms>=RMS_THRESHOLD?'#4ade80':'#60a5fa';
    document.getElementById('vol-pct').textContent=vp+'%';
    // Debug: log freq and rms every 30 frames
    if(typeof window._dbgFrame==='undefined')window._dbgFrame=0;
    window._dbgFrame++;
    if(window._dbgFrame%30===0&&rms>0.005){
      console.log('RMS:'+rms.toFixed(4)+' FREQ:'+freq.toFixed(1)+' STATE:'+dState+' SUSTAIN:'+sustainCount);
    }
    if(dState==='cooldown'){updateReady('cooldown','ok','Note registered - get ready','#4ade80');updateRing(113,'#4ade80');updateStringDisplay(null);return;}
    if(freq<0||rms<RMS_THRESHOLD){if(dState==='detecting'){sustainCount=0;sustainNote=null;sustainStr=null;dState='idle';}updateReady('idle','--','Play a clear sustained note','rgba(255,255,255,0.3)');updateRing(0,'rgba(255,255,255,0.2)');updateStringDisplay(null);return;}
    var note=freqToNote(freq),str=detectString(freq);
    updateStringDisplay(str);
    if(!note){sustainCount=0;dState='idle';return;}
    if(dState==='idle'){dState='detecting';sustainNote=note;sustainStr=str;sustainCount=1;}
    else if(dState==='detecting'){
      var nf=NOTE_FREQ[note]||0,sf=NOTE_FREQ[sustainNote]||0;
      if(Math.abs(nf-sf)<NOTE_TOL*2){sustainCount++;if(str)sustainStr=str;}else{sustainNote=note;sustainStr=str;sustainCount=1;}
      var prog=Math.min(113,Math.round((sustainCount/SUSTAIN_FRAMES)*113));
      updateReady('detecting',Math.round((sustainCount/SUSTAIN_FRAMES)*100)+'%','Sustaining '+sustainNote+'...','#f59e0b');
      updateRing(prog,'#f59e0b');
      if(sustainCount>=SUSTAIN_FRAMES){dState='locked';evaluateNote(sustainNote,sustainStr);enterCooldown();}
    }
  }
  loop();
}
function enterCooldown(){dState='cooldown';sustainCount=0;sustainNote=null;sustainStr=null;updateRing(113,'#4ade80');if(cooldownTimer)clearTimeout(cooldownTimer);cooldownTimer=setTimeout(function(){if(dState==='cooldown'){dState='idle';updateReady('idle','--','Play the next note','rgba(255,255,255,0.3)');updateRing(0,'rgba(255,255,255,0.2)');}},COOLDOWN_MS);}
function updateReady(s,num,sub,col){var t={idle:'Waiting for note...',detecting:'Hold it steady...',cooldown:'Registered!',locked:'...'};document.getElementById('ring-num').textContent=num;document.getElementById('ring-num').style.color=col;document.getElementById('ready-title').textContent=t[s]||'';document.getElementById('ready-title').style.color=col;document.getElementById('ready-sub').textContent=sub;}
function updateRing(off,col){document.getElementById('ring-fill').style.strokeDashoffset=113-off;document.getElementById('ring-fill').style.stroke=col;}

function evaluateNote(played,playedStr){
  var entry=noteQueue[noteIdx];if(!entry)return;var target=getNote(entry);
  var expStr=getExpectedString(target);
  if(feedbackTimer)clearTimeout(feedbackTimer);stopLevelTimer();total++;
  var card=document.getElementById('staff-card');card.className='staff-card';void card.offsetWidth;
  if(played===target){
    correct++;streak++;card.className='staff-card correct';
    document.getElementById('note-display').className='note-display correct';
    setFb('Perfect!','','#4ade80');renderStaff(target,'correct');
    if(fbVisible)renderFingerboard(target,'correct');
    showBowStroke('game-bow-stroke',LEVELS[currentLevel]?LEVELS[currentLevel].color:'#4ade80');
    updateScore();feedbackTimer=setTimeout(function(){advanceNote();},600);  // snappy advance on correct
  }else if(playedStr&&expStr&&playedStr!==expStr){
    streak=0;card.className='staff-card wrong-string';
    document.getElementById('note-display').className='note-display wrong';
    setFb('Wrong string!',isLightningRound?'No hints in Lightning Round!':'Try again - same note','#fb923c');renderStaff(target,'wrong');
    if(!isLightningRound){revealFingerboard('auto');renderFingerboard(target,'wrong-string');}
    updateScore();
    // Stay on same note - let timer run, don't auto-advance on wrong
    feedbackTimer=setTimeout(function(){
      // Reset visual feedback but keep same note
      card.className='staff-card';
      document.getElementById('note-display').className='note-display neutral';
      setFb('Try again!','Play the note shown above','#f59e0b');
      renderStaff(target,'neutral');
      dState='idle';
    },1200);
  }else{
    streak=0;card.className='staff-card wrong-note';
    document.getElementById('note-display').className='note-display wrong';
    setFb('That was '+(played||'?'),isLightningRound?'No hints in Lightning Round!':'Try again - same note','#f87171');renderStaff(target,'wrong');
    if(!isLightningRound){revealFingerboard('auto');renderFingerboard(target,'wrong');}
    updateScore();
    // Stay on same note - let timer run, don't auto-advance on wrong
    feedbackTimer=setTimeout(function(){
      // Reset visual feedback but keep same note
      card.className='staff-card';
      document.getElementById('note-display').className='note-display neutral';
      setFb('Try again!','Play the note shown above','#f59e0b');
      renderStaff(target,'neutral');
      dState='idle';
    },1200);
  }
}
function advanceNote(){
  noteIdx++;
  if(noteIdx>=noteQueue.length){showResults();return;}
  // For intervals, don't hide fingerboard between root and second note
  var entry=noteQueue[noteIdx];
  var prevEntry=noteQueue[noteIdx-1];
  var sameInterval=entry&&prevEntry&&entry.intervalCtx&&prevEntry.intervalCtx&&
    entry.intervalCtx.root===prevEntry.intervalCtx.root&&entry.position===1;
  if(!sameInterval)hideFingerboard();
  renderNote();resetFeedback();startLevelTimer();
}
function setFb(main,sub,col){document.getElementById('fb-main').textContent=main;document.getElementById('fb-main').style.color=col;document.getElementById('fb-sub').textContent=sub;}
function resetFeedback(){document.getElementById('staff-card').className='staff-card';document.getElementById('fb-main').textContent='Play the note';document.getElementById('fb-main').style.color='rgba(255,255,255,0.4)';document.getElementById('fb-sub').textContent='';document.getElementById('note-display').className='note-display neutral';var entry=noteQueue[noteIdx];var t=getNote(entry);if(t){renderStaff(t,'neutral');if(fbVisible)renderFingerboard(t,'neutral');}}
function updateStringDisplay(activeStr){var entry=noteQueue[noteIdx],target=getNote(entry),expStr=target?getExpectedString(target):null;document.querySelectorAll('.string-circle').forEach(function(el){var s=el.dataset.string,info=VIOLIN_STRINGS[s],isA=s===activeStr,isE=s===expStr;el.style.background=isA?info.color:'rgba(0,0,0,0.25)';el.style.borderColor=isE?info.color:'rgba(255,255,255,0.12)';el.style.transform=isA?'scale(1.12)':'scale(1)';el.style.boxShadow=isA?'0 0 16px '+info.color+'66':'none';el.querySelector('.str-letter').style.color=isA?'#fff':info.color;});}
function renderNote(){
  var entry=noteQueue[noteIdx],t=getNote(entry),lvl=LEVELS[currentLevel],spd=getSpeed();
  document.getElementById('note-display').textContent=t||'--';document.getElementById('note-display').className='note-display neutral';
  var expStr=getExpectedString(t),strInfo=expStr?VIOLIN_STRINGS[expStr]:null;
  var ctx=getContextLabel(entry);
  document.getElementById('expected-str-label').textContent=ctx||(strInfo?'Play on: '+strInfo.name:'');
  renderStaff(t,'neutral');if(fbVisible)renderFingerboard(t,'neutral');
  document.getElementById('aud-counter').textContent=(noteIdx+1)+'/'+noteQueue.length;
  document.getElementById('prog-fill').style.width=(noteIdx/noteQueue.length)*100+'%';
  document.getElementById('prog-fill').style.background=isLightningRound?'#fbbf24':lvl.color;
  document.querySelectorAll('.string-circle').forEach(function(el){var s=el.dataset.string;el.style.borderColor=s===expStr?VIOLIN_STRINGS[s].color:'rgba(255,255,255,0.12)';});
}
function updateScore(){
  var lvl=LEVELS[currentLevel],pct=total>0?Math.round((correct/total)*100):0,spd=getSpeed();
  document.getElementById('score-pct').textContent='Score: '+pct+'%';
  var fc=pct>=lvl.passing?'#4ade80':pct>lvl.passing*0.65?'#fb923c':'#f87171';
  document.getElementById('score-fill').style.width=pct+'%';
  document.getElementById('score-fill').style.background=isLightningRound?'#fbbf24':fc;
  document.getElementById('score-correct').textContent=correct+' correct / '+(total-correct)+' missed';
  document.getElementById('streak-label').textContent=streak>1?'🔥 '+streak+' streak':'';
}

document.getElementById('demo-btn').addEventListener('click',function(){
  var entry=noteQueue[noteIdx];var t=getNote(entry);if(!t)return;
  var lvl=LEVELS[currentLevel],expStr=getExpectedString(t),roll=Math.random();
  if(roll>0.45){evaluateNote(t,expStr);}
  else if(roll>0.25){var ws=STRING_ORDER.filter(function(s){return s!==expStr;});evaluateNote(t,ws[Math.floor(Math.random()*ws.length)]);}
  else{
    // For wrong note demo pick a nearby note from the level's full note pool
    var allNotes=[];
    if(lvl.mode==='notes') allNotes=lvl.notes;
    else if(lvl.mode==='intervals') lvl.intervals.forEach(function(pair){allNotes.push(pair[0]);allNotes.push(pair[1]);});
    else if(lvl.mode==='scales') lvl.scales.forEach(function(s){allNotes=allNotes.concat(s.asc);});
    var cands=allNotes.filter(function(n){return n!==t;});
    var wrong=cands.length>0?cands[Math.floor(Math.random()*cands.length)]:t;
    evaluateNote(wrong,expStr);
  }
  enterCooldown();
});

function showScreen(id){document.querySelectorAll('.screen,.gameover-screen').forEach(function(s){s.classList.remove('active');});var el=document.getElementById('screen-'+id);if(el)el.classList.add('active');}
function generateQueue(lvl){
  if(lvl.mode==='notes'){
    var all=lvl.notes.slice(),q=[];
    while(q.length<lvl.totalNotes)q=q.concat(all.slice().sort(function(){return Math.random()-0.5;}));
    return q.slice(0,lvl.totalNotes);
  }
  if(lvl.mode==='intervals'){
    // Each entry is a pair [root, interval] - we expand to individual notes
    // but track them as pairs for display purposes
    var pairs=lvl.intervals.slice().sort(function(){return Math.random()-0.5;});
    var q=[];
    pairs.forEach(function(pair){
      q.push({type:'interval',root:pair[0],second:pair[1],label:pair[2],current:0});
    });
    // Flatten to individual notes but keep interval context
    var flat=[];
    q.slice(0,Math.ceil(lvl.totalNotes/2)).forEach(function(pair){
      flat.push({note:pair.root,   intervalCtx:pair,position:0});
      flat.push({note:pair.second, intervalCtx:pair,position:1});
    });
    return flat.slice(0,lvl.totalNotes);
  }
  if(lvl.mode==='scales'){
    // Pick a random scale, play it ascending then descending
    var scale=lvl.scales[Math.floor(Math.random()*lvl.scales.length)];
    var flat=[];
    scale.asc.forEach(function(n,i){flat.push({note:n,scaleCtx:{name:scale.name,dir:'ascending',pos:i,total:scale.asc.length}});});
    scale.desc.forEach(function(n,i){flat.push({note:n,scaleCtx:{name:scale.name,dir:'descending',pos:i,total:scale.desc.length}});});
    return flat;
  }
  return [];
}

// Helper: get just the note string from a queue entry
function getNote(entry){
  if(typeof entry === 'string') return entry;
  if(entry && entry.note) return entry.note;
  return null;
}

// Helper: get scale/interval context label
function getContextLabel(entry){
  if(!entry||typeof entry==='string') return '';
  if(entry.scaleCtx) return entry.scaleCtx.name+' - '+entry.scaleCtx.dir+' ('+( entry.scaleCtx.pos+1)+'/'+entry.scaleCtx.total+')';
  if(entry.intervalCtx) return entry.intervalCtx.label+': '+entry.intervalCtx.root+' → '+entry.intervalCtx.second;
  return '';
}

function startAuditionCore(i){
  ambStop();
  currentLevel=i;var lvl=LEVELS[i],spd=getSpeed();
  noteQueue=generateQueue(lvl);noteIdx=0;correct=0;total=0;streak=0;
  dState='idle';sustainCount=0;sustainNote=null;sustainStr=null;hideFingerboard();

  // Lightning banner
  if(isLightningRound){
    document.getElementById('lightning-banner').classList.add('active');
  } else {
    document.getElementById('lightning-banner').classList.remove('active');
  }

  // Header
  var label=isLightningRound?'⚡ '+lvl.title:lvl.badge+' '+lvl.title;
  document.getElementById('aud-level-name').textContent=label;
  document.getElementById('aud-level-name').style.color=isLightningRound?'#fbbf24':lvl.color;
  document.getElementById('aud-venue').textContent=isLightningRound?'Lightning Round':lvl.venue;
  document.getElementById('aud-judge').textContent='JUDGE: '+lvl.judge;
  document.getElementById('pass-label').textContent='Pass: '+lvl.passing+'%';

  // Speed badge
  var badge=document.getElementById('speed-badge');
  badge.textContent=spd.icon+' '+spd.name;
  badge.style.background=spd.color+'22';
  badge.style.color=spd.color;
  badge.style.border='1px solid '+spd.color+'44';

  document.getElementById('metro-bar').style.display=metroEnabled?'flex':'none';
  document.getElementById('hint-btn').style.display=isLightningRound?'none':'flex';
  showScreen('audition');

  function go(){renderNote();resetFeedback();updateScore();updateStringDisplay(null);startMetronome();ambStop();startLevelTimer();}
  if(!micGranted){startMic().then(function(){startGameLoop();startCountdown(go);});}
  else{startGameLoop();startCountdown(go);}
}

var _gestureListenerAdded=false;
function ensureGestureListener(){
  if(_gestureListenerAdded)return;
  _gestureListenerAdded=true;
  function onFirstGesture(){
    var savedOff=false;
    try{savedOff=localStorage.getItem('oa_ambient_off')==='1';}catch(e){}
    if(!savedOff){
      amb.on=true;
      var tog=document.getElementById('settings-ambient-toggle');if(tog)tog.classList.add('on');
      var st=document.getElementById('ambient-status');if(st)st.textContent='ON';
      ambStart();
    }
    document.removeEventListener('click',onFirstGesture);
    document.removeEventListener('touchstart',onFirstGesture);
  }
  document.addEventListener('click',onFirstGesture);
  document.addEventListener('touchstart',onFirstGesture);
}
function goHome(){
  ambStop();
  isLightningRound=false;
  document.getElementById('lightning-banner').classList.remove('active');
  stopMetronome();stopLevelTimer();dState='cooldown';
  if(feedbackTimer)clearTimeout(feedbackTimer);if(cooldownTimer)clearTimeout(cooldownTimer);
  if(animFrame){cancelAnimationFrame(animFrame);animFrame=null;}
  buildHomeScreen();showScreen('home');
  if(amb.on){ambStart();}
  ensureGestureListener();
}

function showResults(){
  stopMetronome();stopLevelTimer();
  var lvl=LEVELS[currentLevel],spd=getSpeed();
  var fs=total>0?Math.round((correct/total)*100):0,passed=fs>=lvl.passing;
  var wasLightning=isLightningRound;
  isLightningRound=false;
  document.getElementById('lightning-banner').classList.remove('active');

  // Unlock next level only on a real pass (not Lightning) at Beginner speed or higher
  if(passed&&!wasLightning&&currentLevel+1<LEVELS.length&&unlockedLevels.indexOf(currentLevel+1)===-1)unlockedLevels.push(currentLevel+1);
  if(fs===100&&!wasLightning) lightningUnlocked[currentLevel]=true;

  var iconEl=document.getElementById('res-icon');
  iconEl.textContent=passed?(wasLightning?'⚡':lvl.badge):'😓';
  iconEl.className='results-icon';void iconEl.offsetWidth;
  document.getElementById('res-title').textContent=passed?(wasLightning?'Lightning Cleared!':'You Passed!'):'Keep Practicing';
  document.getElementById('res-title').style.color=passed?(wasLightning?'#fbbf24':'#4ade80'):'#f87171';
  document.getElementById('res-venue').textContent=(wasLightning?'Lightning Round - ':spd.icon+' '+spd.name+' - ')+lvl.title;
  document.getElementById('res-score').textContent='0%';
  document.getElementById('res-passing').textContent='Passing score: '+lvl.passing+'%';
  document.getElementById('res-card').style.borderColor=passed?(wasLightning?'rgba(251,191,36,0.4)':'rgba(74,222,128,0.3)'):'rgba(248,113,113,0.3)';
  document.getElementById('res-correct').textContent=correct;
  document.getElementById('res-missed').textContent=total-correct;
  document.getElementById('res-total').textContent=total;

  var nL=currentLevel+1<LEVELS.length?LEVELS[currentLevel+1]:null;
  var ub=document.getElementById('unlock-box'),nb=document.getElementById('next-btn'),fb=document.getElementById('faster-btn'),lb=document.getElementById('lightning-btn');
  var prompt=document.getElementById('res-next-prompt');
  lb.style.display='none';nb.style.display='none';fb.style.display='none';ub.style.display='none';

  if(passed&&!wasLightning){
    fb.style.display='block';
    if(fs===100){
      lb.style.display='block';
      prompt.textContent='PERFECT! You unlocked Lightning Round for this level!';
    } else {
      prompt.textContent='Great job! Change speed or move on.';
    }
    if(nL){
      ub.style.display='flex';ub.style.background=nL.color+'11';ub.style.border='1px solid '+nL.color+'33';
      ub.innerHTML='<div style="font-size:26px">🔓</div><div><div style="font-size:13px;font-weight:700;color:'+nL.color+'">'+nL.badge+' Unlocked: '+nL.title+'</div><div style="font-size:11px;color:rgba(255,255,255,0.4);margin-top:2px">'+nL.subtitle+' - '+nL.venue+'</div></div>';
      nb.style.display='block';nb.style.background=nL.color;
    }
    // Show lightning button if already unlocked but didn't score 100 this time
    if(lightningUnlocked[currentLevel]&&fs!==100) lb.style.display='block';
  } else if(passed&&wasLightning){
    fb.style.display='block';
    prompt.textContent='Amazing! Try again or head to the next level!';
    if(nL){nb.style.display='block';nb.style.background=nL.color;}
  } else {
    prompt.textContent='Keep practicing - you can do it!';
    fb.style.display='block';
    animateScore(fs,'#f87171');
  }

  showScreen('results');
  if(passed)setTimeout(function(){iconEl.classList.add('celebrate');celebratePass(fs,wasLightning);},200);
}

document.getElementById('lightning-btn').addEventListener('click',function(){
  isLightningRound=true;currentSpeedIdx=4;currentSpeedKey='lightning';
  startAuditionCore(currentLevel);
});
document.getElementById('retry-btn').addEventListener('click',function(){startAuditionCore(currentLevel);});
document.getElementById('faster-btn').addEventListener('click',function(){openSpeedPopup(currentLevel);});
document.getElementById('next-btn').addEventListener('click',function(){openSpeedPopup(currentLevel+1);});
document.getElementById('home-btn').addEventListener('click',goHome);
document.getElementById('exit-btn').addEventListener('click',goHome);

function buildHomeScreen(){
  var list=document.getElementById('level-list');list.innerHTML='';
  buildSongLibraryHome();
  LEVELS.forEach(function(lvl,i){
    if(i>=2) return; // V1.1 - restore this: show Conservatory (i=2) and Carnegie Hall (i=3)
    var isPremium=false;
    var u=isPremium?false:(unlockedLevels.indexOf(0)!==-1);
    var hasLightning=!isPremium&&lightningUnlocked[i];
    var card=document.createElement('div');
    card.className='level-card'+(isPremium?' locked':'');
    var speedInfo=SPEEDS[1].times[i]+'s Intermediate';
    if(hasLightning) speedInfo+=' | ⚡ '+SPEEDS[4].times[i]+'s Lightning';
    var modeDesc=lvl.description||'';
    var iconContent=lvl.badge;
    var iconBg=isPremium?'rgba(255,255,255,0.04)':lvl.color+'33';
    var iconBorder=isPremium?'rgba(255,255,255,0.1)':lvl.color;
    var titleColor=isPremium?'rgba(255,255,255,0.75)':lvl.color;
    var subColor=isPremium?'rgba(255,255,255,0.55)':'rgba(255,255,255,0.7)';
    card.innerHTML=
      '<div class="level-icon" style="background:'+iconBg+';border:2px solid '+iconBorder+'">'+iconContent+'</div>'+
      '<div style="flex:1">'+
        '<div style="font-weight:800;font-size:15px;color:'+titleColor+';">'+lvl.title+'</div>'+
        '<div style="font-size:11px;color:'+subColor+';margin-top:2px">'+lvl.subtitle+' — '+modeDesc+'</div>'+
        '<div style="font-size:10px;color:rgba(255,255,255,0.3);margin-top:2px">'+lvl.totalNotes+' notes | '+speedInfo+'</div>'+
      '</div>'+
      (isPremium?'<div style="font-size:18px;opacity:0.4;">›</div>':'<div style="font-size:22px;color:'+lvl.color+'">›</div>');
    if(!isPremium){
      card.style.boxShadow='inset 3px 0 0 '+lvl.color;
      card.style.border='1px solid rgba(255,255,255,0.1)';
    }
    card.style.position='relative';
    card.style.cursor='pointer';
    (function(idx){
      card.addEventListener('click',function(){openSpeedPopup(idx);});
    })(i);
    list.appendChild(card);
  });
}

function buildStringCircles(){
  var row=document.getElementById('strings-row');row.innerHTML='';
  ['G','D','A','E'].forEach(function(s){
    var info=VIOLIN_STRINGS[s],div=document.createElement('div');
    div.className='string-circle';div.dataset.string=s;
    div.innerHTML='<span class="str-letter" style="color:'+info.color+'">'+s+'</span><span class="str-label">STR</span>';
    row.appendChild(div);
  });
}

buildTunerStrings();
buildHomeScreen();
buildStringCircles();
ensureGestureListener();

// Home section glow cycle — cycles every 6 seconds
(function startHomeSectionGlow(){
  var ids=['tuner-home-btn','home-song-title','home-practice-title'];
  var idx=0;
  function cycle(){
    ids.forEach(function(id){var el=document.getElementById(id);if(el)el.classList.remove('home-sec-glow');});
    var el=document.getElementById(ids[idx%ids.length]);
    if(el)el.classList.add('home-sec-glow');
    setTimeout(function(){var el2=document.getElementById(ids[idx%ids.length]);if(el2)el2.classList.remove('home-sec-glow');},1000);
    idx++;
  }
  cycle();
  setInterval(cycle,6000);
})();

// ── ONBOARDING ───────────────────────────────────────────────────────────────
var obCurrentScreen = 1;
var obTotal = 4;
var tunerPulsed = false;

// Ode to Joy melody — first phrase, loops as onboarding background ambience
// Notes and durations match phrase 1 of the corrected 62-note song data (bpm 80)
var odeTimer=null,odeIdx=0,odePlaying=false;
var ODE_NOTES=     ['E4','E4','F4','G4','G4','F4','E4','D4','C4','C4','D4','E4','E4', 'D4', 'D4'];
var ODE_DURATIONS= [  1,   1,   1,   1,   1,   1,   1,   1,   1,   1,   1,   1, 1.5,  0.5,   2];
var ODE_MS_PER_BEAT=750; // 80 BPM
function playOdeStep(){
  if(!odePlaying)return;
  var noteName=ODE_NOTES[odeIdx];
  var dur=ODE_DURATIONS[odeIdx]||1;
  console.log('[AUDIO] playOdeStep: note='+noteName+' dur='+dur+' idx='+odeIdx);
  odeIdx=(odeIdx+1)%ODE_NOTES.length;
  try{
    violinSampler.playNote(noteName,{volume:0.15});
  }catch(e){}
  odeTimer=setTimeout(playOdeStep,Math.round(dur*ODE_MS_PER_BEAT));
}
function startOdeToJoy(){
  if(odePlaying)return;
  console.log('[AUDIO] startOdeToJoy: started');
  odePlaying=true;odeIdx=0;
  violinSampler.resume();
  violinSampler.preload([...new Set(ODE_NOTES)]);
  playOdeStep();
}
function stopOdeToJoy(){console.log('[AUDIO] stopOdeToJoy: stopped (odePlaying was '+odePlaying+')');odePlaying=false;if(odeTimer){clearTimeout(odeTimer);odeTimer=null;}}

// Rotating onboarding highlights
var obHighlightInterval=null,obHighlightIdx=0;
var OB_TARGETS={
  1:['ob1-tag','ob1-feat1','ob1-feat2'],
  2:['ob2-title','ob2-sub1','ob2-sub2'],
  3:['ob3-c0','ob3-c1','ob3-c2','ob3-c3','ob3-c4','ob3-c5','ob3-c6','ob3-c7'],
  4:['ob4-title','ob4-sub']
};
function stopObHighlights(){
  if(obHighlightInterval)clearInterval(obHighlightInterval);
  obHighlightInterval=null;
  for(var k in OB_TARGETS)OB_TARGETS[k].forEach(function(id){var el=document.getElementById(id);if(el)el.classList.remove('ob-highlight');});
}
function startObHighlights(screenNum){
  stopObHighlights();
  var targets=OB_TARGETS[screenNum];
  if(!targets||!targets.length)return;
  obHighlightIdx=0;
  function next(){
    targets.forEach(function(id){var el=document.getElementById(id);if(el)el.classList.remove('ob-highlight');});
    var el=document.getElementById(targets[obHighlightIdx%targets.length]);
    if(el)el.classList.add('ob-highlight');
    obHighlightIdx++;
  }
  next();
  obHighlightInterval=setInterval(next,2000);
}

function showObScreen(n) {
  for(var i=1;i<=obTotal;i++){
    var s=document.getElementById('ob-screen-'+i);
    if(s) s.style.display = i===n ? 'flex' : 'none';
    var d=document.getElementById('ob-dot-'+i);
    if(d) d.className = 'onboard-dot' + (i===n?' active':'');
  }
  var btn = document.getElementById('ob-next-btn');
  if(n===obTotal){
    btn.textContent = "Let's Go Play! 🎻";
    btn.className = 'onboard-btn onboard-btn-start';
  } else {
    btn.textContent = 'Next →';
    btn.className = 'onboard-btn onboard-btn-next';
  }
  obCurrentScreen = n;
  startObHighlights(n);
}

function closeOnboarding(){
  stopOdeToJoy();
  stopObHighlights();
  var ob = document.getElementById('onboarding');
  ob.style.opacity = '0';
  setTimeout(function(){ ob.style.display = 'none'; }, 400);
  try { localStorage.setItem('oa_onboarded','1'); } catch(e){}
  // Tune button pulse on first visit
  if(!tunerPulsed){
    tunerPulsed=true;
    setTimeout(function(){
      var btn=document.getElementById('tuner-home-btn');
      if(btn){btn.classList.remove('tuner-pulse');void btn.offsetWidth;btn.classList.add('tuner-pulse');}
    },700);
  }
}

document.getElementById('ob-next-btn').addEventListener('click', function(){
  startOdeToJoy();
  if(obCurrentScreen < obTotal){
    showObScreen(obCurrentScreen + 1);
  } else {
    closeOnboarding();
  }
});

document.getElementById('onboard-skip').addEventListener('click', function(){
  closeOnboarding();
});

// Swipe support for onboarding
var obTouchStartX = 0;
document.getElementById('onboarding').addEventListener('touchstart', function(e){
  obTouchStartX = e.touches[0].clientX;
});
document.getElementById('onboarding').addEventListener('touchend', function(e){
  var dx = e.changedTouches[0].clientX - obTouchStartX;
  if(dx < -50 && obCurrentScreen < obTotal) showObScreen(obCurrentScreen + 1);
  if(dx > 50 && obCurrentScreen > 1) showObScreen(obCurrentScreen - 1);
});

// Check if first launch
var _obShowing = false;
try {
  if(!localStorage.getItem('oa_onboarded')){
    document.getElementById('onboarding').style.display = 'flex';
    _obShowing = true;
  } else {
    document.getElementById('onboarding').style.display = 'none';
  }
} catch(e) {
  document.getElementById('onboarding').style.display = 'flex';
  _obShowing = true;
}
// Start screen-1 highlights immediately if onboarding is visible (no tap needed)
if(_obShowing){ startObHighlights(1); }

// Sync ambient toggle visual — respect saved preference
(function(){
  var savedOff=false;
  try{savedOff=localStorage.getItem('oa_ambient_off')==='1';}catch(e){}
  if(savedOff){amb.on=false;}
  var sat=document.getElementById('settings-ambient-toggle');if(sat)sat.classList.toggle('on',amb.on);
  var ats=document.getElementById('ambient-status');if(ats)ats.textContent=amb.on?'ON':'OFF';
})();

// ── SETTINGS ─────────────────────────────────────────────────────────────────
document.getElementById('settings-btn').addEventListener('click', function(){
  document.getElementById('settings-modal').classList.add('active');
});

document.getElementById('settings-close').addEventListener('click', function(){
  document.getElementById('settings-modal').classList.remove('active');
});

document.getElementById('settings-tour-btn').addEventListener('click', function(){
  document.getElementById('settings-modal').classList.remove('active');
  showObScreen(1);
  var ob = document.getElementById('onboarding');
  ob.style.display = 'flex';
  ob.style.opacity = '1';
});

// Settings toggles sync with game toggles
document.getElementById('settings-metro-toggle').addEventListener('click', function(){
  this.classList.toggle('on');
  var isOn = this.classList.contains('on');
  metroEnabled = isOn;
  document.getElementById('metro-status').textContent = isOn ? 'ON' : 'OFF';
  var gameToggle = document.getElementById('toggle-metro');
  if(gameToggle) gameToggle.classList.toggle('on', isOn);
});

document.getElementById('settings-ambient-toggle').addEventListener('click',ambToggle);


// ── CHORD PLAY MODE ──────────────────────────────────────────────────────────

var CHORD_LEVELS_DATA=[
  {level:1,name:'Double Stops',description:'5ths, 3rds — first position',passing:70,color:'#f97316',chords:[
    {name:'G5',label:'G Perfect 5th',notes:['G3','D4'],key:'G'},
    {name:'D5',label:'D Perfect 5th',notes:['D4','A4'],key:'D'},
    {name:'A5',label:'A Perfect 5th',notes:['A4','E5'],key:'A'},
    {name:'G Maj3',label:'G Major 3rd',notes:['G3','B3'],key:'G'},
    {name:'A Maj3',label:'A Major 3rd',notes:['A3','C#4'],key:'A'},
    {name:'C Maj3',label:'C Major 3rd',notes:['C4','E4'],key:'C'},
    {name:'D Maj3',label:'D Major 3rd',notes:['D4','F#4'],key:'D'},
    {name:'G Min3',label:'G Minor 3rd',notes:['G3','A#3'],key:'G'},
    {name:'A Min3',label:'A Minor 3rd',notes:['A3','C4'],key:'A'},
    {name:'D Min3',label:'D Minor 3rd',notes:['D4','F4'],key:'D'},
    {name:'G Oct',label:'G Octave',notes:['G3','G4'],key:'G'},
    {name:'D Oct',label:'D Octave',notes:['D4','D5'],key:'D'}
  ]},
  {level:2,name:'Triads',description:'Major & minor triads',passing:75,color:'#a78bfa',chords:[
    {name:'G Maj',label:'G Major',notes:['G3','B3','D4'],key:'G'},
    {name:'D Maj',label:'D Major',notes:['D4','F#4','A4'],key:'D'},
    {name:'A Maj',label:'A Major',notes:['A3','C#4','E4'],key:'A'},
    {name:'E Maj',label:'E Major',notes:['E4','G#4','B4'],key:'E'},
    {name:'C Maj',label:'C Major',notes:['C4','E4','G4'],key:'C'},
    {name:'G Min',label:'G Minor',notes:['G3','A#3','D4'],key:'G'},
    {name:'D Min',label:'D Minor',notes:['D4','F4','A4'],key:'D'},
    {name:'A Min',label:'A Minor',notes:['A3','C4','E4'],key:'A'},
    {name:'E Min',label:'E Minor',notes:['E4','G4','B4'],key:'E'},
    {name:'B Min',label:'B Minor',notes:['B3','D4','F#4'],key:'D'}
  ]},
  {level:3,name:'7th Chords',description:'Dom7, Maj7, Min7',passing:80,color:'#60a5fa',chords:[
    {name:'G7',label:'G Dominant 7th',notes:['G3','B3','D4','F4'],key:'G'},
    {name:'D7',label:'D Dominant 7th',notes:['D4','F#4','A4','C5'],key:'D'},
    {name:'A7',label:'A Dominant 7th',notes:['A3','C#4','E4','G4'],key:'A'},
    {name:'E7',label:'E Dominant 7th',notes:['E4','G#4','B4','D5'],key:'E'},
    {name:'GMaj7',label:'G Major 7th',notes:['G3','B3','D4','F#4'],key:'G'},
    {name:'DMaj7',label:'D Major 7th',notes:['D4','F#4','A4','C#5'],key:'D'},
    {name:'AMaj7',label:'A Major 7th',notes:['A3','C#4','E4','G#4'],key:'A'},
    {name:'Gm7',label:'G Minor 7th',notes:['G3','A#3','D4','F4'],key:'G'},
    {name:'Dm7',label:'D Minor 7th',notes:['D4','F4','A4','C5'],key:'D'},
    {name:'Am7',label:'A Minor 7th',notes:['A3','C4','E4','G4'],key:'A'},
    {name:'Em7',label:'E Minor 7th',notes:['E4','G4','B4','D5'],key:'E'}
  ]},
  {level:4,name:'Fiddle Chords',description:'Blues 7ths & advanced voicings',passing:85,color:'#4ade80',chords:[
    {name:'G Blues',label:'G Blues 7th',notes:['G3','B3','D4','F4'],key:'G'},
    {name:'D Blues',label:'D Blues 7th',notes:['D4','F#4','A4','C5'],key:'D'},
    {name:'A Blues',label:'A Blues 7th',notes:['A3','C#4','E4','G4'],key:'A'},
    {name:'E Blues',label:'E Blues 7th',notes:['E4','G#4','B4','D5'],key:'E'},
    {name:'G9',label:'G Dominant 9th',notes:['G3','B3','D4','F4','A4'],key:'G'},
    {name:'D9',label:'D Dominant 9th',notes:['D4','F#4','A4','C5','E5'],key:'D'},
    {name:'Gdim7',label:'G Diminished 7th',notes:['G3','A#3','C#4','E4'],key:'G'},
    {name:'Daug',label:'D Augmented',notes:['D4','F#4','A#4'],key:'D'},
    {name:'G6',label:'G Major 6th',notes:['G3','B3','D4','E4'],key:'G'},
    {name:'D6',label:'D Major 6th',notes:['D4','F#4','A4','B4'],key:'D'},
    {name:'Bm7b5',label:'B Half-Dim 7th',notes:['B3','D4','F4','A4'],key:'D'}
  ]}
];

var cpCurrentLevel=0;
var cpChordQueue=[];
var cpChordIdx=0;
var cpNoteIdx=0;
var cpCorrect=0;
var cpTotal=0;
var cpState='idle';
var cpSustainCount=0;
var cpSustainNote=null;
var cpAnimFrame=null;
var cpSelectedKey='G';

// ── CHORD LEVEL SELECTOR ─────────────────────────────────────────────────────
function buildChordLevelSelector(){
  var modal=document.getElementById('chord-level-modal');
  // Build key selector buttons
  var ks=document.getElementById('chord-key-selector');ks.innerHTML='';
  ['G','D','A','E','C'].forEach(function(k){
    var kbtn=document.createElement('button');
    kbtn.style.cssText='flex:1;padding:8px 4px;border-radius:10px;font-size:14px;font-weight:800;cursor:pointer;font-family:Georgia,serif;border:1px solid;transition:all 0.15s;'+(k===cpSelectedKey?'background:rgba(96,165,250,0.2);border-color:#60a5fa;color:#60a5fa;':'background:rgba(255,255,255,0.06);border-color:rgba(255,255,255,0.15);color:rgba(255,255,255,0.5);');
    kbtn.textContent=k;
    kbtn.addEventListener('click',function(){cpSelectedKey=k;buildChordLevelSelector();});
    ks.appendChild(kbtn);
  });
  // Build level cards filtered by key
  var grid=document.getElementById('chord-level-grid');grid.innerHTML='';
  CHORD_LEVELS_DATA.forEach(function(lvl,i){
    var filtered=lvl.chords.filter(function(c){return c.key===cpSelectedKey;});
    var btn=document.createElement('div');
    btn.style.cssText='padding:14px;border-radius:14px;cursor:pointer;border:1px solid '+lvl.color+'44;background:'+lvl.color+'11;text-align:center;'+(filtered.length===0?'opacity:0.35;pointer-events:none;':'');
    btn.innerHTML='<div style="font-size:22px;margin-bottom:4px;">'+(i===0?'🎸':i===1?'🎵':i===2?'🎷':'🤠')+'</div>'+
      '<div style="font-size:14px;font-weight:800;color:'+lvl.color+'">Level '+lvl.level+'</div>'+
      '<div style="font-size:12px;font-weight:700;color:rgba(255,255,255,0.8);margin-top:2px;">'+lvl.name+'</div>'+
      '<div style="font-size:10px;color:rgba(255,255,255,0.4);margin-top:2px;">'+lvl.description+'</div>'+
      '<div style="font-size:10px;color:'+lvl.color+';margin-top:4px;">'+filtered.length+' chords · Pass '+lvl.passing+'%</div>';
    if(filtered.length>0){
      btn.addEventListener('click',function(){
        modal.classList.remove('active');
        cpCurrentLevel=i;
        startChordPlay(i,cpSelectedKey);
      });
    }
    grid.appendChild(btn);
  });
}


document.getElementById('chord-level-cancel').addEventListener('click',function(){
  document.getElementById('chord-level-modal').classList.remove('active');
});
document.getElementById('chord-preview-btn').addEventListener('click',function(){
  document.getElementById('chord-level-modal').classList.remove('active');
  renderChordPreview(cpSelectedKey);
  showScreen('chordpreview');
});
document.getElementById('cpp-back-btn').addEventListener('click',function(){
  showScreen('home');
  buildChordLevelSelector();
  document.getElementById('chord-level-modal').classList.add('active');
});
function drawChordOnSvg(svgEl,notes,color){
  if(!svgEl)return;
  var W=170,LS=11,halfStep=LS/2,botY=98,html='';
  for(var i=0;i<5;i++)html+='<line x1="8" y1="'+(botY-i*LS)+'" x2="'+(W-4)+'" y2="'+(botY-i*LS)+'" stroke="rgba(255,255,255,0.3)" stroke-width="1.2"/>';
  html+='<text x="6" y="'+(botY+20)+'" font-size="50" fill="rgba(255,255,255,0.55)" font-family="serif">\uD834\uDD1E</text>';
  var xpos=[72,90,108,126,144];
  notes.forEach(function(note,idx){
    var rawSteps=STEPS_ABOVE_E4[note]!==undefined?STEPS_ABOVE_E4[note]:(NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined?NOTE_NATURAL_STEP[note]:0);
    var steps=Math.round(rawSteps);
    var nx=xpos[idx]||108;
    var ny=botY-steps*halfStep;
    var accSym=NOTE_ACCIDENTAL&&NOTE_ACCIDENTAL[note]?(NOTE_ACCIDENTAL[note]==='#'?'\u266F':'\u266D'):'';
    if(steps<0){for(var s=-2;s>=steps;s-=2)html+='<line x1="'+(nx-11)+'" y1="'+(botY-s*halfStep)+'" x2="'+(nx+11)+'" y2="'+(botY-s*halfStep)+'" stroke="'+color+'" stroke-width="1.1" opacity="0.7"/>';}
    if(steps>8){for(var s2=10;s2<=steps;s2+=2)html+='<line x1="'+(nx-11)+'" y1="'+(botY-s2*halfStep)+'" x2="'+(nx+11)+'" y2="'+(botY-s2*halfStep)+'" stroke="'+color+'" stroke-width="1.1" opacity="0.7"/>';}
    if(accSym)html+='<text x="'+(nx-13)+'" y="'+(ny+4)+'" font-size="12" fill="'+color+'" font-family="serif">'+accSym+'</text>';
    html+='<ellipse cx="'+nx+'" cy="'+ny+'" rx="7" ry="5" fill="'+color+'" transform="rotate(-15,'+nx+','+ny+')"/>';
    if(steps<=4)html+='<line x1="'+(nx+6)+'" y1="'+ny+'" x2="'+(nx+6)+'" y2="'+(ny-25)+'" stroke="'+color+'" stroke-width="1.3"/>';
    else html+='<line x1="'+(nx-6)+'" y1="'+ny+'" x2="'+(nx-6)+'" y2="'+(ny+25)+'" stroke="'+color+'" stroke-width="1.3"/>';
    html+='<text x="'+nx+'" y="'+(botY+18)+'" font-size="8" fill="'+color+'" text-anchor="middle">'+note.replace('#','\u266F')+'</text>';
  });
  svgEl.innerHTML=html;
}
function renderChordPreview(key){
  document.getElementById('cpp-title').textContent='Chords in Key of '+key;
  var list=document.getElementById('cpp-chord-list');list.innerHTML='';
  CHORD_LEVELS_DATA.forEach(function(lvl){
    var chords=lvl.chords.filter(function(c){return c.key===key;});
    if(!chords.length)return;
    var hdr=document.createElement('div');
    hdr.style.cssText='font-size:10px;letter-spacing:0.12em;color:'+lvl.color+';font-weight:800;margin:10px 0 6px 2px;';
    hdr.textContent=lvl.name.toUpperCase();
    list.appendChild(hdr);
    var grid=document.createElement('div');
    grid.style.cssText='display:grid;grid-template-columns:1fr 1fr;gap:8px;margin-bottom:6px;';
    chords.forEach(function(c){
      var card=document.createElement('div');
      card.style.cssText='background:rgba(255,255,255,0.04);border:1px solid '+lvl.color+'33;border-radius:12px;padding:6px 4px 4px;display:flex;flex-direction:column;align-items:center;overflow:hidden;';
      var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');
      svg.setAttribute('width','170');svg.setAttribute('height','126');
      svg.style.cssText='overflow:visible;display:block;max-width:100%;';
      drawChordOnSvg(svg,c.notes,lvl.color);
      card.appendChild(svg);
      var lbl=document.createElement('div');
      lbl.style.cssText='font-size:10px;font-weight:800;color:'+lvl.color+';text-align:center;margin-top:2px;padding:0 4px;line-height:1.3;';
      lbl.textContent=c.label;
      card.appendChild(lbl);
      grid.appendChild(card);
    });
    list.appendChild(grid);
  });
}
document.getElementById('cp-exit-btn').addEventListener('click',function(){
  if(cpAnimFrame){cancelAnimationFrame(cpAnimFrame);cpAnimFrame=null;}
  document.getElementById('chord-level-modal').classList.remove('active');
  goHome();
});

// ── CHORD PLAY CORE ──────────────────────────────────────────────────────────
function startChordPlay(levelIdx,keyFilter){
  ambStop();
  var lvl=CHORD_LEVELS_DATA[levelIdx];
  var pool=keyFilter?lvl.chords.filter(function(c){return c.key===keyFilter;}):lvl.chords;
  if(!pool.length)pool=lvl.chords;
  cpChordQueue=pool.slice().sort(function(){return Math.random()-0.5;});
  cpChordIdx=0;cpNoteIdx=0;cpCorrect=0;cpTotal=0;cpState='idle';cpSustainCount=0;
  document.getElementById('cp-level-name').textContent='🎸 '+lvl.name;
  document.getElementById('cp-level-name').style.color=lvl.color;
  document.getElementById('cp-pass-label').textContent='Pass: '+lvl.passing+'%';
  showScreen('chordplay');
  renderChordPlay();
  if(!micGranted){startMic().then(function(){startChordPlayLoop();});}
  else{startChordPlayLoop();}
}

function renderChordPlay(){
  if(cpChordIdx>=cpChordQueue.length){showChordResults();return;}
  var chord=cpChordQueue[cpChordIdx];
  var lvl=CHORD_LEVELS_DATA[cpCurrentLevel];
  var note=chord.notes[cpNoteIdx];

  // Update header
  document.getElementById('cp-chord-name').textContent=chord.label;
  document.getElementById('cp-chord-name').style.color=lvl.color;
  document.getElementById('cp-note-counter').textContent=(cpNoteIdx+1)+'/'+chord.notes.length;
  document.getElementById('cp-chord-counter').textContent='Chord '+(cpChordIdx+1)+'/'+cpChordQueue.length;

  // Draw ALL chord notes on staff (dimmed) with current note highlighted
  renderChordOnStaff(chord.notes, cpNoteIdx, lvl.color);

  // Note to play
  document.getElementById('cp-current-note').textContent=note;
  document.getElementById('cp-current-note').style.color=lvl.color;
  document.getElementById('cp-feedback').textContent='Play: '+note;
  document.getElementById('cp-feedback').style.color='rgba(255,255,255,0.5)';
  document.getElementById('cp-card').style.borderColor=lvl.color+'44';
  document.getElementById('cp-fingerboard-wrap').style.display='none';

  // Score
  updateChordScore();

  // Build chord note dots
  buildChordNoteDots(chord.notes, cpNoteIdx, lvl.color);
}

function buildChordNoteDots(notes, currentIdx, color){
  var dots=document.getElementById('cp-note-dots');dots.innerHTML='';
  notes.forEach(function(n,i){
    var d=document.createElement('div');
    d.style.cssText='width:32px;height:32px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;border:2px solid;transition:all 0.2s;';
    if(i<currentIdx){d.style.background=color+'33';d.style.borderColor=color;d.style.color=color;d.textContent='✓';}
    else if(i===currentIdx){d.style.background=color+'22';d.style.borderColor=color;d.style.color=color;d.style.transform='scale(1.2)';d.textContent=n.replace(/[0-9]/g,'');}
    else{d.style.background='rgba(255,255,255,0.05)';d.style.borderColor='rgba(255,255,255,0.15)';d.style.color='rgba(255,255,255,0.3)';d.textContent=n.replace(/[0-9]/g,'');}
    dots.appendChild(d);
  });
}

function renderChordOnStaff(notes, activeIdx, color){
  var svg=document.getElementById('cp-staff-svg');
  var svgW=240,LS=12,halfStep=LS/2,staffBottomY=115,html='';
  // Draw staff lines
  for(var i=0;i<5;i++)html+='<line x1="10" y1="'+(staffBottomY-i*LS)+'" x2="'+(svgW-10)+'" y2="'+(staffBottomY-i*LS)+'" stroke="rgba(255,255,255,0.38)" stroke-width="1.4"/>';
  // Treble clef
  html+='<text x="10" y="'+(staffBottomY+22)+'" font-size="58" fill="rgba(255,255,255,0.72)" font-family="serif">\uD834\uDD1E</text>';

  // Space notes across staff
  var noteXPositions=[90,115,140,165,190];
  notes.forEach(function(note,idx){
    if(!STEPS_ABOVE_E4[note]&&!(NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]))return;
    var rawSteps=STEPS_ABOVE_E4[note]!==undefined?STEPS_ABOVE_E4[note]:(NOTE_NATURAL_STEP[note]||0);
    var steps=Math.round(rawSteps);
    var nx=noteXPositions[idx]||140;
    var ny=staffBottomY-steps*halfStep;
    var isActive=idx===activeIdx;
    var col=isActive?color:(idx<activeIdx?color+'88':'rgba(255,255,255,0.25)');
    var accSym=NOTE_ACCIDENTAL&&NOTE_ACCIDENTAL[note]?(NOTE_ACCIDENTAL[note]==='#'?'\u266F':'\u266D'):'';

    // Ledger lines
    if(steps<0){for(var s=-2;s>=steps;s-=2)html+='<line x1="'+(nx-13)+'" y1="'+(staffBottomY-s*halfStep)+'" x2="'+(nx+13)+'" y2="'+(staffBottomY-s*halfStep)+'" stroke="'+col+'" stroke-width="1.2" opacity="0.6"/>';}
    if(steps>8){for(var s2=10;s2<=steps;s2+=2)html+='<line x1="'+(nx-13)+'" y1="'+(staffBottomY-s2*halfStep)+'" x2="'+(nx+13)+'" y2="'+(staffBottomY-s2*halfStep)+'" stroke="'+col+'" stroke-width="1.2" opacity="0.6"/>';}

    // Highlight active note
    if(isActive)html+='<ellipse cx="'+nx+'" cy="'+ny+'" rx="13" ry="9" fill="'+color+'22" transform="rotate(-15,'+nx+','+ny+')"/>';

    // Note head
    html+='<ellipse cx="'+nx+'" cy="'+ny+'" rx="8" ry="5.8" fill="'+col+'" transform="rotate(-15,'+nx+','+ny+')"/>';
    html+=steps<=4?'<line x1="'+(nx+7)+'" y1="'+ny+'" x2="'+(nx+7)+'" y2="'+(ny-28)+'" stroke="'+col+'" stroke-width="1.4"/>':'<line x1="'+(nx-7)+'" y1="'+ny+'" x2="'+(nx-7)+'" y2="'+(ny+28)+'" stroke="'+col+'" stroke-width="1.4"/>';
    if(accSym)html+='<text x="'+(nx-17)+'" y="'+(ny+5)+'" font-size="14" fill="'+col+'" font-family="serif">'+accSym+'</text>';

    // Note name below
    html+='<text x="'+nx+'" y="'+(staffBottomY+35)+'" font-size="9" fill="'+col+'" text-anchor="middle" font-weight="'+(isActive?'bold':'normal')+'">'+note+'</text>';
  });
  svg.innerHTML=html;
}

function updateChordScore(){
  var lvl=CHORD_LEVELS_DATA[cpCurrentLevel];
  var pct=cpTotal>0?Math.round((cpCorrect/cpTotal)*100):0;
  document.getElementById('cp-score-pct').textContent='Score: '+pct+'%';
  var fc=pct>=lvl.passing?'#4ade80':pct>50?'#fb923c':'#f87171';
  document.getElementById('cp-score-fill').style.width=pct+'%';
  document.getElementById('cp-score-fill').style.background=fc;
}

function startChordPlayLoop(){
  if(cpAnimFrame)cancelAnimationFrame(cpAnimFrame);
  if(!analyser)return;
  var buf=new Float32Array(analyser.fftSize);
  function loop(){
    cpAnimFrame=requestAnimationFrame(loop);
    if(document.getElementById('screen-chordplay').className.indexOf('active')===-1){cancelAnimationFrame(cpAnimFrame);cpAnimFrame=null;return;}
    analyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var vp=Math.min(100,Math.round(rms*800));
    document.getElementById('cp-vol-fill').style.width=vp+'%';
    document.getElementById('cp-vol-fill').style.background=rms>=RMS_THRESHOLD?CHORD_LEVELS_DATA[cpCurrentLevel].color:'#60a5fa';
    document.getElementById('cp-vol-pct').textContent=vp+'%';
    if(cpState==='cooldown')return;
    if(freq<0||rms<RMS_THRESHOLD){cpSustainCount=0;cpState='idle';return;}
    var note=freqToNote(freq);
    if(!note){cpSustainCount=0;cpState='idle';return;}
    if(cpState==='idle'){cpState='detecting';cpSustainNote=note;cpSustainCount=1;}
    else if(cpState==='detecting'){
      var nf=NOTE_FREQ[note]||0,sf=NOTE_FREQ[cpSustainNote]||0;
      if(Math.abs(nf-sf)<NOTE_TOL*2){cpSustainCount++;}else{cpSustainNote=note;cpSustainCount=1;}
      if(cpSustainCount>=SUSTAIN_FRAMES){
        cpState='cooldown';
        var chord=cpChordQueue[cpChordIdx];
        var target=chord.notes[cpNoteIdx];
        var lvl=CHORD_LEVELS_DATA[cpCurrentLevel];
        cpTotal++;
        if(cpSustainNote===target){
          cpCorrect++;
          document.getElementById('cp-feedback').textContent='✓ '+target+'!';
          document.getElementById('cp-feedback').style.color='#4ade80';
          document.getElementById('cp-card').style.borderColor='rgba(74,222,128,0.5)';
          updateChordScore();
          setTimeout(function(){
            cpNoteIdx++;
            if(cpNoteIdx>=chord.notes.length){
              // Chord complete!
              cpChordIdx++;cpNoteIdx=0;
            }
            cpSustainCount=0;cpState='idle';
            renderChordPlay();
          },500);
        } else {
          document.getElementById('cp-feedback').textContent='That was '+cpSustainNote+' — need '+target;
          document.getElementById('cp-feedback').style.color='#f87171';
          document.getElementById('cp-card').style.borderColor='rgba(248,113,113,0.4)';
          document.getElementById('cp-fingerboard-wrap').style.display='flex';
          renderFingerboardOnSvg('cp-fingerboard-svg',target,'wrong');
          updateChordScore();
          setTimeout(function(){
            cpSustainCount=0;cpState='idle';
            document.getElementById('cp-card').style.borderColor=lvl.color+'44';
            document.getElementById('cp-feedback').textContent='Play: '+target;
            document.getElementById('cp-feedback').style.color='rgba(255,255,255,0.5)';
          },1500);
        }
        setTimeout(function(){if(cpState==='cooldown')cpState='idle';},COOLDOWN_MS);
      }
    }
  }
  loop();
}

document.getElementById('cp-demo-btn').addEventListener('click',function(){
  if(cpChordIdx>=cpChordQueue.length)return;
  var chord=cpChordQueue[cpChordIdx];
  var target=chord.notes[cpNoteIdx];
  cpCorrect++;cpTotal++;
  document.getElementById('cp-feedback').textContent='✓ '+target+'!';
  document.getElementById('cp-feedback').style.color='#4ade80';
  updateChordScore();
  setTimeout(function(){
    cpNoteIdx++;
    if(cpNoteIdx>=chord.notes.length){cpChordIdx++;cpNoteIdx=0;}
    cpSustainCount=0;cpState='idle';
    renderChordPlay();
  },400);
});

function showChordResults(){
  var lvl=CHORD_LEVELS_DATA[cpCurrentLevel];
  var pct=cpTotal>0?Math.round((cpCorrect/cpTotal)*100):0;
  var passed=pct>=lvl.passing;
  if(cpAnimFrame){cancelAnimationFrame(cpAnimFrame);cpAnimFrame=null;}

  document.getElementById('cp-result-icon').textContent=passed?'🎸':'😓';
  document.getElementById('cp-result-title').textContent=passed?'Level Cleared!':'Keep Practicing!';
  document.getElementById('cp-result-title').style.color=passed?lvl.color:'#f87171';
  document.getElementById('cp-result-score').textContent=pct+'%';
  document.getElementById('cp-result-score').style.color=passed?lvl.color:'#f87171';
  document.getElementById('cp-result-detail').textContent=cpCorrect+' correct / '+(cpTotal-cpCorrect)+' missed';

  var nextBtn=document.getElementById('cp-next-level-btn');
  if(passed&&cpCurrentLevel<CHORD_LEVELS_DATA.length-1){
    nextBtn.style.display='block';
    nextBtn.style.background=CHORD_LEVELS_DATA[cpCurrentLevel+1].color;
    nextBtn.textContent='Next Level: '+CHORD_LEVELS_DATA[cpCurrentLevel+1].name+' →';
  } else {
    nextBtn.style.display='none';
  }

  if(passed) setTimeout(function(){launchConfetti(lvl.color);showBravoBanner(pct===100?'PERFECT!':'CLEARED!',lvl.color);},300);

  showScreen('chordresults');
}

document.getElementById('cp-retry-btn').addEventListener('click',function(){startChordPlay(cpCurrentLevel);});
document.getElementById('cp-next-level-btn').addEventListener('click',function(){startChordPlay(cpCurrentLevel+1);});
document.getElementById('cp-home-btn').addEventListener('click',function(){goHome();});

// ── STANDALONE METRONOME ─────────────────────────────────────────────────────
var smBpm=60,smBeats=4,smBeat=0,smPlaying=false,smInterval=null;
var tapTimes=[],smLastTap=0;

function smBuildBeats(){
  var display=document.getElementById('sm-beat-display');
  display.innerHTML='';
  for(var i=0;i<smBeats;i++){
    var d=document.createElement('div');
    d.className='metro-beat-circle '+(i===0?'beat1':'beat-other');
    d.id='sm-circle-'+i;
    display.appendChild(d);
  }
}

function smUpdateBpm(val){
  smBpm=parseInt(val);
  document.getElementById('sm-bpm-display').textContent=smBpm;
  document.getElementById('sm-slider').value=smBpm;
  if(smPlaying){smStop();smStart();}
}

function smStart(){
  smPlaying=true;smBeat=0;
  document.getElementById('sm-start-btn').textContent='⏹ Stop';
  document.getElementById('sm-start-btn').className='metro-start-btn playing';
  smFireBeat();
  smInterval=setInterval(function(){
    smBeat=(smBeat+1)%smBeats;
    smFireBeat();
  },(60/smBpm)*1000);
}

function smStop(){
  smPlaying=false;
  if(smInterval){clearInterval(smInterval);smInterval=null;}
  document.getElementById('sm-start-btn').textContent='▶ Start';
  document.getElementById('sm-start-btn').className='metro-start-btn stopped';
  // Clear all circles
  for(var i=0;i<smBeats;i++){
    var c=document.getElementById('sm-circle-'+i);
    if(c)c.classList.remove('active');
  }
}

function smFireBeat(){
  console.log('[AUDIO] smFireBeat: standalone metronome click beat='+smBeat);
  // Play click
  var ctx=getCtx();
  var osc=ctx.createOscillator(),gain=ctx.createGain();
  osc.connect(gain);gain.connect(ctx.destination);
  osc.frequency.value=smBeat===0?1200:800;
  osc.type='sine';
  gain.gain.setValueAtTime(smBeat===0?0.5:0.3,ctx.currentTime);
  gain.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.06);
  osc.start(ctx.currentTime);osc.stop(ctx.currentTime+0.07);
  // Animate circles
  for(var i=0;i<smBeats;i++){
    var c=document.getElementById('sm-circle-'+i);
    if(!c)continue;
    if(i===smBeat){
      c.classList.add('active');
      setTimeout(function(el){el.classList.remove('active');},(60/smBpm)*800,c);
    } else {
      c.classList.remove('active');
    }
  }
}

// Time signature buttons
document.querySelectorAll('.metro-timesig-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    smBeats=parseInt(btn.dataset.beats);
    document.querySelectorAll('.metro-timesig-btn').forEach(function(b){b.classList.remove('selected');});
    btn.classList.add('selected');
    smBuildBeats();
    if(smPlaying){smStop();smStart();}
  });
});

// Slider
document.getElementById('sm-slider').addEventListener('input',function(e){
  smUpdateBpm(e.target.value);
});

// Presets
document.querySelectorAll('.metro-preset-big').forEach(function(btn){
  btn.addEventListener('click',function(){smUpdateBpm(btn.dataset.bpm);});
});

// Start/stop
document.getElementById('sm-start-btn').addEventListener('click',function(){
  if(smPlaying)smStop();else smStart();
});

// Tap tempo
document.getElementById('sm-tap-btn').addEventListener('click',function(){
  var now=Date.now();
  if(now-smLastTap>3000)tapTimes=[];
  smLastTap=now;
  tapTimes.push(now);
  if(tapTimes.length>8)tapTimes=tapTimes.slice(-8);
  if(tapTimes.length>=2){
    var intervals=[];
    for(var i=1;i<tapTimes.length;i++)intervals.push(tapTimes[i]-tapTimes[i-1]);
    var avg=intervals.reduce(function(a,b){return a+b;},0)/intervals.length;
    var bpm=Math.round(60000/avg);
    bpm=Math.max(30,Math.min(200,bpm));
    smUpdateBpm(bpm);
  }
  // Visual feedback
  this.style.background='rgba(199,125,255,0.35)';
  var self=this;
  setTimeout(function(){self.style.background='rgba(199,125,255,0.12)';},100);
});

// Tuner link from metronome
document.getElementById('sm-tuner-link').addEventListener('click',function(){
  if(smPlaying)smStop();
  document.getElementById('tuner-modal-title').textContent='Tune Your Violin';
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});

// Exit metronome
document.getElementById('sm-exit-btn').addEventListener('click',function(){
  if(smPlaying)smStop();
  goHome();
});

// Home button opens metronome
document.getElementById('btn-standalone-metro').addEventListener('click',function(){
  smBuildBeats();
  showScreen('metronome');
});

smBuildBeats();


// ── PRACTICE MODES LOGIC ─────────────────────────────────────────────────────

// Shared state
var practiceNotes=[];
var practiceIdx=0;
var practiceMode='flashcard'; // 'flashcard','flashplay','scaleplay'
var selectedStrings=['G','D','A','E'];
var includeAccidentals=true;
var selectedPreset=0;  // free tier defaults to beginner range
var selectedScale=null;
var scaleAscending=true;
var scaleDescending=true;
var fpAnimFrame=null;
var spAnimFrame=null;

// All notes by string
var NOTES_BY_STRING={
  G:['G3','A3','B3','C4','D4'],
  D:['D4','E4','F4','G4','A4'],
  A:['A4','B4','C5','D5','E5'],
  E:['E5','F5','G5','A5','B5']
};
var ACCIDENTALS_BY_STRING={
  G:['G#3','A#3','C#4','D#4'],
  D:['D#4','F#4','G#4'],
  A:['A#4','C#5','D#5'],
  E:['F#5','G#5','A#5']
};
var LEVEL_NOTES=[
  // Beginner: natural notes only, E4-E5 (first position D & A strings)
  ['E4','F4','G4','A4','B4','C5','D5','E5'],
  // Intermediate: all natural notes G3-G5, plus common sharps on D & A strings
  ['G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5',
   'F#4','G#4','C#5','D#5'],
  // Advanced: full chromatic range G3-B5, all accidentals
  ['G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5','A5','B5',
   'G#3','A#3','C#4','D#4','F#4','G#4','A#4','C#5','D#5','F#5','G#5','A#5'],
  // Elite: full range plus higher positions C6, D6, E6
  ['G3','A3','B3','C4','D4','E4','F4','G4','A4','B4','C5','D5','E5','F5','G5','A5','B5','C6','D6','E6',
   'G#3','A#3','C#4','D#4','F#4','G#4','A#4','C#5','D#5','F#5','G#5','A#5']
];
var ALL_SCALES=[
  {name:'G Major',    asc:['G3','A3','B3','C4','D4','E4','F#4','G4'],desc:['G4','F#4','E4','D4','C4','B3','A3','G3']},
  {name:'D Major',    asc:['D4','E4','F#4','G4','A4','B4','C#5','D5'],desc:['D5','C#5','B4','A4','G4','F#4','E4','D4']},
  {name:'A Major',    asc:['A3','B3','C#4','D4','E4','F#4','G#4','A4'],desc:['A4','G#4','F#4','E4','D4','C#4','B3','A3']},
  {name:'E Major',    asc:['E4','F#4','G#4','A4','B4','C#5','D#5','E5'],desc:['E5','D#5','C#5','B4','A4','G#4','F#4','E4']},
  {name:'G Mel. Min', asc:['G3','A3','A#3','C4','D4','E4','F#4','G4'],desc:['G4','F4','D#4','D4','C4','A#3','A3','G3']},
  {name:'D Mel. Min', asc:['D4','E4','F4','G4','A4','B4','C#5','D5'],desc:['D5','C5','A#4','A4','G4','F4','E4','D4']},
  {name:'A Mel. Min', asc:['A3','B3','C4','D4','E4','F#4','G#4','A4'],desc:['A4','G4','F4','E4','D4','C4','B3','A3']},
  {name:'E Mel. Min', asc:['E4','F#4','G4','A4','B4','C#5','D#5','E5'],desc:['E5','D5','C5','B4','A4','G4','F#4','E4']},
  // 2-octave scales
  {name:'G Maj 2 Oct', asc:['G3','A3','B3','C4','D4','E4','F#4','G4','A4','B4','C5','D5','E5','F#5','G5'],desc:['G5','F#5','E5','D5','C5','B4','A4','G4','F#4','E4','D4','C4','B3','A3','G3']},
  {name:'D Maj 2 Oct', asc:['D4','E4','F#4','G4','A4','B4','C#5','D5','E5','F#5','G5','A5','B5'],desc:['B5','A5','G5','F#5','E5','D5','C#5','B4','A4','G4','F#4','E4','D4']},
  {name:'A Maj 2 Oct', asc:['A3','B3','C#4','D4','E4','F#4','G#4','A4','B4','C#5','D5','E5'],desc:['E5','D5','C#5','B4','A4','G#4','F#4','E4','D4','C#4','B3','A3']},
  {name:'A Mel 2 Oct', asc:['A3','B3','C4','D4','E4','F#4','G#4','A4','B4','C5','D5','E5'],desc:['E5','D5','C5','B4','A4','G4','F4','E4','D4','C4','B3','A3']}
];

// ── RANGE MODAL ──────────────────────────────────────────────────────────────
var PRACTICE_INTERVALS=[
  ['G3','D4'],['A3','E4'],['B3','F#4'],['C4','G4'],['D4','A4'],
  ['E4','B4'],['F4','C5'],['G4','D5'],['A4','E5'],
  ['G3','B3'],['A3','C#4'],['C4','E4'],['D4','F#4'],
  ['E4','G#4'],['G4','B4'],['A4','C#5'],['D5','F#5']
];

function buildRangeNotes(){
  var notes=[];
  if(selectedPreset==='intervals'){
    // Flatten interval pairs into individual notes
    var pairs=PRACTICE_INTERVALS.slice().sort(function(){return Math.random()-0.5;});
    pairs.forEach(function(pair){
      notes.push(pair[0]);
      notes.push(pair[1]);
    });
    return notes;
  }
  if(selectedPreset>=0){
    notes=LEVEL_NOTES[selectedPreset].filter(function(n){
      var str=NOTE_TO_SLOT[n]?NOTE_TO_SLOT[n].string:null;
      if(!str||selectedStrings.indexOf(str)===-1)return false;
      if(!includeAccidentals&&n.indexOf('#')!==-1)return false;
      return true;
    });
  }
  // Shuffle
  for(var i=notes.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var t=notes[i];notes[i]=notes[j];notes[j]=t;}
  return notes.length>0?notes:['A4'];
}

document.querySelectorAll('.range-preset-btn[data-preset]').forEach(function(btn){
  btn.addEventListener('click',function(){
    var val=btn.dataset.preset;
    selectedPreset=(val==='intervals')?'intervals':parseInt(val,10);
    document.querySelectorAll('.range-preset-btn[data-preset]').forEach(function(b){b.classList.remove('selected');});
    btn.classList.add('selected');
  });
});

document.querySelectorAll('.string-toggle-btn').forEach(function(btn){
  btn.addEventListener('click',function(){
    var s=btn.dataset.string;
    btn.classList.toggle('selected');
    if(btn.classList.contains('selected')){
      if(selectedStrings.indexOf(s)===-1)selectedStrings.push(s);
    }else{
      selectedStrings=selectedStrings.filter(function(x){return x!==s;});
      if(selectedStrings.length===0){selectedStrings.push(s);btn.classList.add('selected');}
    }
  });
});

document.getElementById('acc-toggle').addEventListener('click',function(){
  includeAccidentals=!includeAccidentals;
  this.classList.toggle('on',includeAccidentals);
});

document.getElementById('range-cancel').addEventListener('click',function(){
  document.getElementById('range-modal').classList.remove('active');
});

document.getElementById('range-start-btn').addEventListener('click',function(){
  document.getElementById('range-modal').classList.remove('active');
  practiceNotes=buildRangeNotes();
  practiceIdx=0;
  if(practiceMode==='flashcard') startFlashcards();
  else startFlashPlay();
});

// ── HOME SCREEN BUTTONS ──────────────────────────────────────────────────────
document.getElementById('btn-flashcard').addEventListener('click',function(){
  practiceMode='flashcard';
  document.getElementById('range-modal-title').textContent='Flashcard Note Range';
  document.getElementById('range-start-btn').textContent='Start Flashcards →';
  document.getElementById('range-start-btn').style.color='#2dd4bf';
  document.getElementById('range-start-btn').style.borderColor='#2dd4bf';
  document.getElementById('range-modal').classList.add('active');
});


// ── SCALE SELECTOR ───────────────────────────────────────────────────────────
var selectedScaleIdx=0;
function buildScaleGrid(){
  var grid=document.getElementById('scale-grid');grid.innerHTML='';
  ALL_SCALES.forEach(function(sc,i){
    var btn=document.createElement('button');
    btn.className='scale-btn'+(i===selectedScaleIdx?' selected':'');
    btn.textContent=sc.name;
    btn.addEventListener('click',function(){
      selectedScaleIdx=i;
      document.querySelectorAll('.scale-btn').forEach(function(b){b.classList.remove('selected');});
      btn.classList.add('selected');
    });
    grid.appendChild(btn);
  });
}

document.getElementById('dir-asc').addEventListener('click',function(){
  scaleAscending=!scaleAscending;
  this.classList.toggle('selected',scaleAscending);
  if(!scaleAscending&&!scaleDescending){scaleDescending=true;document.getElementById('dir-desc').classList.add('selected');}
});
document.getElementById('dir-desc').addEventListener('click',function(){
  scaleDescending=!scaleDescending;
  this.classList.toggle('selected',scaleDescending);
  if(!scaleAscending&&!scaleDescending){scaleAscending=true;document.getElementById('dir-asc').classList.add('selected');}
});

document.getElementById('scale-cancel').addEventListener('click',function(){
  document.getElementById('scale-modal').classList.remove('active');
});

document.getElementById('scale-start-btn').addEventListener('click',function(){
  document.getElementById('scale-modal').classList.remove('active');
  startScalePlay();
});
document.getElementById('scale-preview-btn').addEventListener('click',function(){
  document.getElementById('scale-modal').classList.remove('active');
  var sc=ALL_SCALES[selectedScaleIdx];
  document.getElementById('scp-scale-name').textContent='🎼 '+sc.name;
  var dirLabel=scaleAscending&&scaleDescending?'ASCENDING ↑ THEN DESCENDING ↓':scaleAscending?'ASCENDING ↑':'DESCENDING ↓';
  document.getElementById('scp-dir-label').textContent=dirLabel;
  var notes=sc.asc.slice(0,8);
  renderScalePreviewStaff('scp-staff-svg',notes);
  showScreen('scalepreview');
});
document.getElementById('scp-start-btn').addEventListener('click',function(){
  startScalePlay();
});
document.getElementById('scp-back-btn').addEventListener('click',function(){
  showScreen('home');
  document.getElementById('scale-modal').classList.add('active');
});
function renderScalePreviewStaff(svgId,notes){
  var svg=document.getElementById(svgId);if(!svg)return;
  var svgW=350,LS=13,halfStep=LS/2,staffBottomY=120;
  var n=notes.length,startX=52,endX=svgW-14;
  var step=n>1?(endX-startX)/(n-1):0;
  var html='';
  for(var i=0;i<5;i++)html+='<line x1="10" y1="'+(staffBottomY-i*LS)+'" x2="'+(svgW-2)+'" y2="'+(staffBottomY-i*LS)+'" stroke="rgba(255,255,255,0.35)" stroke-width="1.3"/>';
  html+='<text x="8" y="'+(staffBottomY+22)+'" font-size="60" fill="rgba(255,255,255,0.65)" font-family="serif">\uD834\uDD1E</text>';
  notes.forEach(function(note,idx){
    var nx=Math.round(startX+idx*step);
    var rawSteps=STEPS_ABOVE_E4[note]!==undefined?STEPS_ABOVE_E4[note]:(NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined?NOTE_NATURAL_STEP[note]:0);
    var steps=Math.round(rawSteps);
    var ny=staffBottomY-steps*halfStep;
    var accSym=NOTE_ACCIDENTAL&&NOTE_ACCIDENTAL[note]?(NOTE_ACCIDENTAL[note]==='#'?'\u266F':'\u266D'):'';
    if(steps<0){for(var s=-2;s>=steps;s-=2)html+='<line x1="'+(nx-9)+'" y1="'+(staffBottomY-s*halfStep)+'" x2="'+(nx+9)+'" y2="'+(staffBottomY-s*halfStep)+'" stroke="rgba(255,255,255,0.6)" stroke-width="1.2"/>';}
    if(steps>8){for(var s2=10;s2<=steps;s2+=2)html+='<line x1="'+(nx-9)+'" y1="'+(staffBottomY-s2*halfStep)+'" x2="'+(nx+9)+'" y2="'+(staffBottomY-s2*halfStep)+'" stroke="rgba(255,255,255,0.6)" stroke-width="1.2"/>';}
    if(accSym)html+='<text x="'+(nx-15)+'" y="'+(ny+5)+'" font-size="12" fill="#ffd93d" font-family="serif">'+accSym+'</text>';
    html+='<ellipse cx="'+nx+'" cy="'+ny+'" rx="7" ry="4.8" fill="#fbbf24" transform="rotate(-15,'+nx+','+ny+')"/>';
    if(steps<=4)html+='<line x1="'+(nx+6)+'" y1="'+ny+'" x2="'+(nx+6)+'" y2="'+(ny-28)+'" stroke="#fbbf24" stroke-width="1.3"/>';
    else html+='<line x1="'+(nx-6)+'" y1="'+ny+'" x2="'+(nx-6)+'" y2="'+(ny+28)+'" stroke="#fbbf24" stroke-width="1.3"/>';
    if(idx<notes.length-1)html+='<text x="'+(nx+step/2-5)+'" y="'+(staffBottomY+32)+'" font-size="10" fill="rgba(255,255,255,0.3)" font-family="sans-serif">→</text>';
    var label=note.replace('#','\u266F').replace(/b([0-9])/,'\u266D$1');
    html+='<text x="'+nx+'" y="'+(staffBottomY+46)+'" font-size="9" fill="rgba(255,255,255,0.65)" font-family="sans-serif" text-anchor="middle">'+label+'</text>';
  });
  svg.innerHTML=html;
}

// ── FLASHCARD MODE ───────────────────────────────────────────────────────────
var fcRevealed=false;
function startFlashcards(){
  fcRevealed=false;
  showScreen('flashcard');
  renderFlashcard();
}
function renderFlashcard(){
  fcRevealed=false;
  var note=practiceNotes[practiceIdx];
  document.getElementById('fc-progress').textContent=(practiceIdx+1)+' / '+practiceNotes.length;
  document.getElementById('fc-note-name').textContent='?';
  document.getElementById('fc-note-name').style.color='rgba(255,255,255,0.2)';
  document.getElementById('fc-reveal-btn').textContent='👁 Reveal Finger Position';
  document.getElementById('fc-fingerboard-wrap').style.display='none';
  renderStaffOnSvg('fc-staff-svg',note,'neutral');
}
document.getElementById('fc-reveal-btn').addEventListener('click',function(){
  var note=practiceNotes[practiceIdx];
  fcRevealed=true;
  document.getElementById('fc-note-name').textContent=note;
  document.getElementById('fc-note-name').style.color='#2dd4bf';
  document.getElementById('fc-fingerboard-wrap').style.display='flex';
  renderFingerboardOnSvg('fc-fingerboard-svg',note,'neutral');
  this.textContent='✓ Got it!';
});
document.getElementById('fc-next-btn').addEventListener('click',function(){
  practiceIdx=(practiceIdx+1)%practiceNotes.length;
  renderFlashcard();
});
document.getElementById('fc-prev-btn').addEventListener('click',function(){
  practiceIdx=(practiceIdx-1+practiceNotes.length)%practiceNotes.length;
  renderFlashcard();
});
document.getElementById('fc-exit-btn').addEventListener('click',function(){
  goHome();
});
document.getElementById('fc-tune-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});
document.getElementById('fp-tune-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});
document.getElementById('sp-tune-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});
document.getElementById('cp-tune-btn').addEventListener('click',function(){
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
});

// ── FLASH PLAY MODE ──────────────────────────────────────────────────────────
var fpState='idle',fpSustainCount=0,fpSustainNote=null,fpSustainStr=null;
function startFlashPlay(){
  ambStop();
  fpState='idle';fpSustainCount=0;
  showScreen('flashplay');
  renderFlashPlay();
  if(!micGranted){
    startMic().then(function(){startFlashPlayLoop();});
  } else {
    startFlashPlayLoop();
  }
}
function renderFlashPlay(){
  var note=practiceNotes[practiceIdx];
  document.getElementById('fp-progress').textContent=(practiceIdx+1)+' / '+practiceNotes.length;
  document.getElementById('fp-note-name').textContent=note;
  document.getElementById('fp-note-name').style.color='#e0d4ff';
  document.getElementById('fp-feedback').textContent='Play the note on your violin';
  document.getElementById('fp-feedback').style.color='rgba(255,255,255,0.4)';
  document.getElementById('fp-card').className='fc-card';
  document.getElementById('fp-card').style.borderColor='rgba(167,139,250,0.2)';
  document.getElementById('fp-fingerboard-wrap').style.display='none';
  renderStaffOnSvg('fp-staff-svg',note,'neutral');
}
function startFlashPlayLoop(){
  if(fpAnimFrame)cancelAnimationFrame(fpAnimFrame);
  if(!analyser)return;
  var buf=new Float32Array(analyser.fftSize);
  function loop(){
    fpAnimFrame=requestAnimationFrame(loop);
    if(document.getElementById('screen-flashplay').className.indexOf('active')===-1){cancelAnimationFrame(fpAnimFrame);fpAnimFrame=null;return;}
    analyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var vp=Math.min(100,Math.round(rms*800));
    document.getElementById('fp-vol-fill').style.width=vp+'%';
    document.getElementById('fp-vol-fill').style.background=rms>=RMS_THRESHOLD?'#c4b5fd':'#60a5fa';
    document.getElementById('fp-vol-pct').textContent=vp+'%';
    if(fpState==='cooldown')return;
    if(freq<0||rms<RMS_THRESHOLD){fpSustainCount=0;fpState='idle';return;}
    var note=freqToNote(freq),str=detectString(freq);
    if(!note){fpSustainCount=0;fpState='idle';return;}
    if(fpState==='idle'){fpState='detecting';fpSustainNote=note;fpSustainStr=str;fpSustainCount=1;}
    else if(fpState==='detecting'){
      var nf=NOTE_FREQ[note]||0,sf=NOTE_FREQ[fpSustainNote]||0;
      if(Math.abs(nf-sf)<NOTE_TOL*2){fpSustainCount++;}else{fpSustainNote=note;fpSustainStr=str;fpSustainCount=1;}
      if(fpSustainCount>=SUSTAIN_FRAMES){
        fpState='cooldown';
        var target=practiceNotes[practiceIdx];
        if(fpSustainNote===target){
          document.getElementById('fp-card').style.borderColor='rgba(74,222,128,0.5)';
          document.getElementById('fp-feedback').textContent='✓ Perfect!';
          document.getElementById('fp-feedback').style.color='#4ade80';
          renderStaffOnSvg('fp-staff-svg',target,'correct');
          setTimeout(function(){
            practiceIdx=(practiceIdx+1)%practiceNotes.length;
            fpSustainCount=0;fpState='idle';
            renderFlashPlay();
          },700);
        } else {
          document.getElementById('fp-card').style.borderColor='rgba(248,113,113,0.5)';
          document.getElementById('fp-feedback').textContent='Try again — see position below';
          document.getElementById('fp-feedback').style.color='#f87171';
          renderStaffOnSvg('fp-staff-svg',target,'wrong');
          document.getElementById('fp-fingerboard-wrap').style.display='flex';
          renderFingerboardOnSvg('fp-fingerboard-svg',target,'wrong');
          setTimeout(function(){
            fpSustainCount=0;fpState='idle';
            document.getElementById('fp-card').style.borderColor='rgba(167,139,250,0.2)';
            document.getElementById('fp-feedback').textContent='Play the note on your violin';
            document.getElementById('fp-feedback').style.color='rgba(255,255,255,0.4)';
            renderStaffOnSvg('fp-staff-svg',target,'neutral');
          },1500);
        }
        setTimeout(function(){if(fpState==='cooldown')fpState='idle';},COOLDOWN_MS);
      }
    }
  }
  loop();
}
document.getElementById('fp-exit-btn').addEventListener('click',function(){
  if(fpAnimFrame){cancelAnimationFrame(fpAnimFrame);fpAnimFrame=null;}
  goHome();
});
document.getElementById('fp-demo-btn').addEventListener('click',function(){
  var target=practiceNotes[practiceIdx];
  var roll=Math.random();
  if(roll>0.5){
    document.getElementById('fp-card').style.borderColor='rgba(74,222,128,0.5)';
    document.getElementById('fp-feedback').textContent='✓ Perfect!';
    document.getElementById('fp-feedback').style.color='#4ade80';
    setTimeout(function(){practiceIdx=(practiceIdx+1)%practiceNotes.length;renderFlashPlay();},700);
  } else {
    document.getElementById('fp-feedback').textContent='Try again — see position below';
    document.getElementById('fp-feedback').style.color='#f87171';
    document.getElementById('fp-fingerboard-wrap').style.display='flex';
    renderFingerboardOnSvg('fp-fingerboard-svg',target,'wrong');
  }
});

// ── SCALE PLAY MODE ──────────────────────────────────────────────────────────
var scaleQueue=[];
var spState='idle',spSustainCount=0,spSustainNote=null;
function startScalePlay(){
  ambStop();
  var sc=ALL_SCALES[selectedScaleIdx];
  scaleQueue=[];
  if(scaleAscending) sc.asc.forEach(function(n){scaleQueue.push({note:n,dir:'asc'});});
  if(scaleDescending) sc.desc.forEach(function(n){scaleQueue.push({note:n,dir:'desc'});});
  practiceIdx=0;spState='idle';spSustainCount=0;
  showScreen('scaleplay');
  document.getElementById('sp-scale-name').textContent='🎼 '+sc.name;
  buildScaleDots();
  renderScalePlay();
  if(!micGranted){startMic().then(function(){startScalePlayLoop();});}
  else{startScalePlayLoop();}
}
function buildScaleDots(){
  var dots=document.getElementById('sp-dots');dots.innerHTML='';
  scaleQueue.forEach(function(_,i){
    var d=document.createElement('div');
    d.className='scale-dot'+(i===0?' current':'');
    d.id='sp-dot-'+i;
    dots.appendChild(d);
  });
}
function updateScaleDots(){
  scaleQueue.forEach(function(_,i){
    var d=document.getElementById('sp-dot-'+i);if(!d)return;
    d.className='scale-dot'+(i<practiceIdx?' done':i===practiceIdx?' current':'');
  });
  var dir=scaleQueue[practiceIdx]?scaleQueue[practiceIdx].dir:'asc';
  document.getElementById('sp-dir-label').textContent=dir==='asc'?'ASCENDING ↑':'DESCENDING ↓';
}
function renderScalePlay(){
  if(practiceIdx>=scaleQueue.length){
    // Scale complete!
    document.getElementById('sp-note-name').textContent='✓';
    document.getElementById('sp-note-name').style.color='#4ade80';
    document.getElementById('sp-feedback').textContent='Scale complete! Great job!';
    document.getElementById('sp-feedback').style.color='#4ade80';
    return;
  }
  var note=scaleQueue[practiceIdx].note;
  document.getElementById('sp-progress').textContent=(practiceIdx+1)+' / '+scaleQueue.length;
  document.getElementById('sp-note-name').textContent=note;
  document.getElementById('sp-note-name').style.color='#fbbf24';
  document.getElementById('sp-feedback').textContent='Play the note on your violin';
  document.getElementById('sp-feedback').style.color='rgba(255,255,255,0.4)';
  document.getElementById('sp-card').style.borderColor='rgba(251,191,36,0.2)';
  document.getElementById('sp-fingerboard-wrap').style.display='none';
  renderStaffOnSvg('sp-staff-svg',note,'neutral');
  updateScaleDots();
}
function startScalePlayLoop(){
  if(spAnimFrame)cancelAnimationFrame(spAnimFrame);
  if(!analyser)return;
  var buf=new Float32Array(analyser.fftSize);
  function loop(){
    spAnimFrame=requestAnimationFrame(loop);
    if(document.getElementById('screen-scaleplay').className.indexOf('active')===-1){cancelAnimationFrame(spAnimFrame);spAnimFrame=null;return;}
    analyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var vp=Math.min(100,Math.round(rms*800));
    document.getElementById('sp-vol-fill').style.width=vp+'%';
    document.getElementById('sp-vol-fill').style.background=rms>=RMS_THRESHOLD?'#fbbf24':'#60a5fa';
    document.getElementById('sp-vol-pct').textContent=vp+'%';
    if(spState==='cooldown'||practiceIdx>=scaleQueue.length)return;
    if(freq<0||rms<RMS_THRESHOLD){spSustainCount=0;spState='idle';return;}
    var note=freqToNote(freq);
    if(!note){spSustainCount=0;spState='idle';return;}
    if(spState==='idle'){spState='detecting';spSustainNote=note;spSustainCount=1;}
    else if(spState==='detecting'){
      var nf=NOTE_FREQ[note]||0,sf=NOTE_FREQ[spSustainNote]||0;
      if(Math.abs(nf-sf)<NOTE_TOL*2){spSustainCount++;}else{spSustainNote=note;spSustainCount=1;}
      if(spSustainCount>=SUSTAIN_FRAMES){
        spState='cooldown';
        var target=scaleQueue[practiceIdx].note;
        if(spSustainNote===target){
          document.getElementById('sp-card').style.borderColor='rgba(74,222,128,0.5)';
          document.getElementById('sp-feedback').textContent='✓ '+target+'!';
          document.getElementById('sp-feedback').style.color='#4ade80';
          renderStaffOnSvg('sp-staff-svg',target,'correct');
          setTimeout(function(){
            practiceIdx++;spSustainCount=0;spState='idle';
            renderScalePlay();
          },500);
        } else {
          document.getElementById('sp-card').style.borderColor='rgba(248,113,113,0.4)';
          document.getElementById('sp-feedback').textContent='That was '+spSustainNote+' — try '+target;
          document.getElementById('sp-feedback').style.color='#f87171';
          document.getElementById('sp-fingerboard-wrap').style.display='flex';
          renderFingerboardOnSvg('sp-fingerboard-svg',target,'wrong');
          setTimeout(function(){
            spSustainCount=0;spState='idle';
            document.getElementById('sp-card').style.borderColor='rgba(251,191,36,0.2)';
            document.getElementById('sp-feedback').textContent='Try again';
            document.getElementById('sp-feedback').style.color='rgba(255,255,255,0.4)';
          },1500);
        }
        setTimeout(function(){if(spState==='cooldown')spState='idle';},COOLDOWN_MS);
      }
    }
  }
  loop();
}
document.getElementById('sp-exit-btn').addEventListener('click',function(){
  if(spAnimFrame){cancelAnimationFrame(spAnimFrame);spAnimFrame=null;}
  goHome();
});
document.getElementById('sp-demo-btn').addEventListener('click',function(){
  if(practiceIdx>=scaleQueue.length)return;
  var target=scaleQueue[practiceIdx].note;
  document.getElementById('sp-card').style.borderColor='rgba(74,222,128,0.5)';
  document.getElementById('sp-feedback').textContent='✓ '+target+'!';
  document.getElementById('sp-feedback').style.color='#4ade80';
  setTimeout(function(){practiceIdx++;spSustainCount=0;spState='idle';renderScalePlay();},500);
});

// ── SHARED STAFF/FINGERBOARD RENDERERS FOR PRACTICE MODES ───────────────────
function renderStaffOnSvg(svgId,note,state){
  var svg=document.getElementById(svgId);if(!svg)return;
  var svgW=200,LS=12,halfStep=LS/2,staffBottomY=105,noteX=130,html='';
  for(var i=0;i<5;i++)html+='<line x1="10" y1="'+(staffBottomY-i*LS)+'" x2="'+(svgW-5)+'" y2="'+(staffBottomY-i*LS)+'" stroke="rgba(255,255,255,0.38)" stroke-width="1.4"/>';
  html+='<text x="10" y="'+(staffBottomY+22)+'" font-size="58" fill="rgba(255,255,255,0.72)" font-family="serif">\uD834\uDD1E</text>';
  if(note&&STEPS_ABOVE_E4[note]!==undefined||NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined){
    var rawSteps=STEPS_ABOVE_E4[note]!==undefined?STEPS_ABOVE_E4[note]:(NOTE_NATURAL_STEP&&NOTE_NATURAL_STEP[note]!==undefined?NOTE_NATURAL_STEP[note]:0);
    var steps=Math.round(rawSteps);
    var ny=staffBottomY-steps*halfStep;
    var col=state==='correct'?'#4ade80':state==='wrong'?'#f87171':'#fff';
    var accSym=NOTE_ACCIDENTAL&&NOTE_ACCIDENTAL[note]?(NOTE_ACCIDENTAL[note]==='#'?'\u266F':'\u266D'):'';
    if(steps<0){for(var s=-2;s>=steps;s-=2)html+='<line x1="'+(noteX-13)+'" y1="'+(staffBottomY-s*halfStep)+'" x2="'+(noteX+13)+'" y2="'+(staffBottomY-s*halfStep)+'" stroke="'+col+'" stroke-width="1.4" opacity="0.8"/>';}
    if(steps>8){for(var s2=10;s2<=steps;s2+=2)html+='<line x1="'+(noteX-13)+'" y1="'+(staffBottomY-s2*halfStep)+'" x2="'+(noteX+13)+'" y2="'+(staffBottomY-s2*halfStep)+'" stroke="'+col+'" stroke-width="1.4" opacity="0.8"/>';}
    html+='<ellipse cx="'+noteX+'" cy="'+ny+'" rx="8" ry="5.8" fill="'+col+'" transform="rotate(-15,'+noteX+','+ny+')"/>';
    html+=steps<=4?'<line x1="'+(noteX+7)+'" y1="'+ny+'" x2="'+(noteX+7)+'" y2="'+(ny-30)+'" stroke="'+col+'" stroke-width="1.4"/>':'<line x1="'+(noteX-7)+'" y1="'+ny+'" x2="'+(noteX-7)+'" y2="'+(ny+30)+'" stroke="'+col+'" stroke-width="1.4"/>';
    if(accSym)html+='<text x="'+(noteX-18)+'" y="'+(ny+6)+'" font-size="16" fill="'+col+'" font-family="serif">'+accSym+'</text>';
  }
  svg.innerHTML=html;
}

function renderFingerboardOnSvg(svgId,note,mode){
  var svg=document.getElementById(svgId);if(!svg)return;
  var lookup=NOTE_TO_SLOT[note];if(!lookup){svg.innerHTML='';return;}
  var targetStr=lookup.string,targetSlot=lookup.slot;
  var neckL=20,neckR=92,nutY=24,numSlots=7,slotH=22,neckH=numSlots*slotH;
  var strX=STRING_ORDER.map(function(_,i){return neckL+(neckR-neckL)*(i/3);});
  function slotCY(slot){return slot===0?nutY-15:nutY+(slot-1)*slotH+slotH/2;}
  var dotColor=mode==='correct'?'#4ade80':mode==='wrong'?'#fb923c':'#4ade80';
  var html='';
  html+='<rect x="'+neckL+'" y="'+nutY+'" width="'+(neckR-neckL)+'" height="'+neckH+'" rx="2" fill="rgba(90,55,25,0.35)" stroke="rgba(120,75,35,0.5)" stroke-width="1"/>';
  html+='<rect x="'+(neckL-2)+'" y="'+(nutY-5)+'" width="'+(neckR-neckL+4)+'" height="6" rx="2" fill="rgba(255,255,255,0.85)"/>';
  var chromStr=CHROMATIC_STRINGS[targetStr]||[];
  for(var s=1;s<=numSlots;s++){var cy=slotCY(s);html+='<line x1="'+neckL+'" y1="'+cy+'" x2="'+neckR+'" y2="'+cy+'" stroke="rgba(255,255,255,0.15)" stroke-width="1"/>';}
  var strThick=[2.8,2.1,1.5,1.0];
  STRING_ORDER.forEach(function(s,i){
    var sx=strX[i],isTarget=s===targetStr,sc=isTarget?VIOLIN_STRINGS[s].color:'rgba(200,185,150,0.2)',tw=isTarget?strThick[i]+0.9:strThick[i];
    html+='<line x1="'+sx+'" y1="'+nutY+'" x2="'+sx+'" y2="'+(nutY+neckH+8)+'" stroke="'+sc+'" stroke-width="'+tw+'"/>';
    html+='<text x="'+sx+'" y="'+(nutY+neckH+20)+'" font-size="9" fill="'+(isTarget?VIOLIN_STRINGS[s].color:'rgba(255,255,255,0.18)')+'" text-anchor="middle" font-weight="'+(isTarget?'bold':'normal')+'">'+s+'</text>';
  });
  var si=STRING_ORDER.indexOf(targetStr),sx=strX[si],dy=slotCY(targetSlot),fingerNum=NOTE_FINGER_NUM[note]||'?';
  var isPulseO=(mode==='wrong');
  if(targetSlot===0){
    html+='<circle cx="'+sx+'" cy="'+dy+'" r="9" fill="none" stroke="'+dotColor+'" stroke-width="2.5"></circle>';
    html+='<text x="'+sx+'" y="'+(dy+4)+'" font-size="11" fill="'+dotColor+'" text-anchor="middle" font-weight="bold">O</text>';
  }else{
    html+='<circle cx="'+sx+'" cy="'+dy+'" r="11" fill="'+dotColor+'"></circle>';
    html+='<text x="'+sx+'" y="'+(dy+4)+'" font-size="13" fill="#000" text-anchor="middle" font-weight="bold">'+fingerNum+'</text>';
  }
  svg.innerHTML=html;
  if(isPulseO){var circles=svg.querySelectorAll('circle');var lc=circles[circles.length-1];if(lc){lc.classList.remove('finger-pulse');void lc.offsetWidth;lc.classList.add('finger-pulse');}}
}


// iOS requires user gesture to unlock AudioContext
// We unlock it on the very first tap anywhere on the page
var audioUnlocked = false;
function unlockAudio(){
  if(audioUnlocked)return;
  audioUnlocked=true;
  violinSampler.resume();
  var ctx=getCtx();
  // Play silent buffer to unlock
  var buf=ctx.createBuffer(1,1,ctx.sampleRate);
  var src=ctx.createBufferSource();
  src.buffer=buf;src.connect(ctx.destination);src.start(0);
  document.removeEventListener('touchstart',unlockAudio);
  document.removeEventListener('touchend',unlockAudio);
}
document.addEventListener('touchstart',unlockAudio,{passive:true});
document.addEventListener('touchend',unlockAudio,{passive:true});

setTimeout(function(){
  document.getElementById('tuner-modal-title').textContent='Let us tune up first!';
  document.getElementById('tuner-modal').classList.add('active');
  if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}
},600);

// ── SONG LEARNING ─────────────────────────────────────────
function buildSongLibraryHome(){
  var row=document.getElementById('home-song-row');if(!row)return;
  row.innerHTML='';
  SONGS.forEach(function(song){
    var btn=document.createElement('button');
    btn.className='home-song-pill';
    btn.textContent=song.title.split(' ').slice(0,2).join(' ');
    btn.addEventListener('click',function(){startSongLearn(song);});
    row.appendChild(btn);
  });
}

function buildSongList(){
  var list=document.getElementById('song-list');if(!list)return;
  list.innerHTML='';
  SONGS.forEach(function(song){
    var div=document.createElement('div');
    div.className='song-card free';
    div.innerHTML='<div class="song-card-icon">🎵</div>'+
      '<div class="song-card-info"><div class="song-card-title">'+song.title+'</div>'+
      '<div class="song-card-sub">'+song.artist+' · '+song.genre+(song.notes.length?' · '+song.notes.length+' notes':'')+'</div></div>';
    div.addEventListener('click',function(){startSongLearn(song);});
    list.appendChild(div);
  });
  var teaser=document.createElement('div');
  teaser.style.cssText='text-align:center;padding:12px 16px;font-size:12px;color:rgba(255,255,255,0.4);line-height:1.5;border-top:1px solid rgba(255,255,255,0.08);margin-top:4px;';
  teaser.textContent='🎵 More songs coming soon — Vivaldi, Danny Boy, Scarborough Fair and more!';
  list.appendChild(teaser);
}

function startSongLearn(song){
  ambStop();stopMetronome();stopOdeToJoy();
  slBackingStop();slBackingAudioStop();
  currentSong=song;slNoteIdx=0;slMode='listen';slState='idle';slSustainCount=0;slSustainNote=null;slListenPlaying=false;
  if(song.bpm){
    slListenBpm=song.bpm;
    var bpmSlider=document.getElementById('sl-listen-bpm');
    var bpmDisplay=document.getElementById('sl-listen-bpm-display');
    if(bpmSlider)bpmSlider.value=song.bpm;
    if(bpmDisplay)bpmDisplay.textContent=song.bpm+' BPM';
  }
  violinSampler.preload([...new Set(song.notes)]); // warm cache before first note fires
  if(song.measures&&window.pianoSampler){ // preload all backing notes for this song
    var backingNotes=[];
    song.measures.forEach(function(m){if(m.backing)backingNotes=backingNotes.concat(m.backing);});
    window.pianoSampler.preload([...new Set(backingNotes)]);
  }
  if(song.backingTrack){ // fetch + decode backing track into AudioBuffer for zero-latency start
    slBackingAudioBuffer=null;
    slBackingAudioStop();
    var backingUrl=song.backingTrack;
    slBackingDecodePromise=fetch(backingUrl)
      .then(function(r){return r.arrayBuffer();})
      .then(function(buf){return getCtx().decodeAudioData(buf);})
      .then(function(decoded){
        slBackingAudioBuffer=decoded;
        slBackingDecodePromise=null;
        console.log('[AUDIO] backing track decoded: '+backingUrl);
      })
      .catch(function(e){
        slBackingDecodePromise=null;
        console.warn('[AUDIO] backing track decode failed:',e);
      });
  } else {
    slBackingAudioBuffer=null;
    slBackingDecodePromise=null;
  }
  document.getElementById('sl-song-title').textContent=song.title;
  ['sl-mode-listen','sl-mode-songlearn','sl-mode-songplay'].forEach(function(id){document.getElementById(id).classList.remove('active');});
  document.getElementById('sl-mode-listen').classList.add('active');
  document.getElementById('sl-complete-box').style.display='none';
  document.getElementById('sl-listen-controls').style.display='block';
  document.getElementById('sl-songplay-msg').style.display='none';
  document.getElementById('sl-vol-meter-wrap').style.display='none';
  document.getElementById('sl-controls-row').style.display='none';
  buildSlDots();renderSongLearnNote();
  showScreen('songlearn');
}

function buildSlDots(){
  var wrap=document.getElementById('sl-dots');if(!wrap||!currentSong)return;
  wrap.innerHTML='';
  currentSong.notes.forEach(function(_,i){
    var d=document.createElement('div');
    d.className='sl-dot'+(i<slNoteIdx?' done':i===slNoteIdx?' current':'');
    wrap.appendChild(d);
  });
}

function renderSongLearnNote(){
  if(!currentSong)return;
  var note=currentSong.notes[slNoteIdx];
  document.getElementById('sl-progress').textContent=(slNoteIdx+1)+' / '+currentSong.notes.length;
  document.getElementById('sl-note-name').textContent=note;
  document.getElementById('sl-note-name').style.color='#facc15';
  document.getElementById('sl-feedback').textContent='Play the note on your violin';
  document.getElementById('sl-feedback').style.color='rgba(255,255,255,0.4)';
  document.getElementById('sl-card').style.borderColor='rgba(250,204,21,0.2)';
  renderStaffOnSvg('sl-staff-svg',note,'neutral');
  buildSlDots();
}

function startSongLearnLoop(){
  ambStop();
  if(slAnimFrame)cancelAnimationFrame(slAnimFrame);
  if(!analyser)return;
  var buf=new Float32Array(analyser.fftSize);
  function loop(){
    slAnimFrame=requestAnimationFrame(loop);
    if(document.getElementById('screen-songlearn').className.indexOf('active')===-1){cancelAnimationFrame(slAnimFrame);slAnimFrame=null;return;}
    analyser.getFloatTimeDomainData(buf);
    var result=detectPitch(buf,getCtx().sampleRate),freq=result.freq,rms=result.rms;
    var vp=Math.min(100,Math.round(rms*800));
    document.getElementById('sl-vol-fill').style.width=vp+'%';
    document.getElementById('sl-vol-fill').style.background=rms>=RMS_THRESHOLD?'#facc15':'#60a5fa';
    document.getElementById('sl-vol-pct').textContent=vp+'%';
    if(slState==='cooldown')return;
    if(freq<0||rms<RMS_THRESHOLD){slSustainCount=0;slState='idle';return;}
    var note=freqToNote(freq);
    if(!note){slSustainCount=0;slState='idle';return;}
    if(slState==='idle'){slState='detecting';slSustainNote=note;slSustainCount=1;}
    else if(slState==='detecting'){
      var nf=NOTE_FREQ[note]||0,sf=NOTE_FREQ[slSustainNote]||0;
      if(Math.abs(nf-sf)<NOTE_TOL*2){slSustainCount++;}else{slSustainNote=note;slSustainCount=1;}
      if(slSustainCount>=SUSTAIN_FRAMES){
        slState='cooldown';
        var target=currentSong.notes[slNoteIdx];
        if(slSustainNote===target){
          document.getElementById('sl-card').style.borderColor='rgba(74,222,128,0.5)';
          document.getElementById('sl-feedback').textContent='✓ Correct!';
          document.getElementById('sl-feedback').style.color='#4ade80';
          renderStaffOnSvg('sl-staff-svg',target,'correct');
          showBowStroke('bow-stroke-sl','#facc15');
          slNoteIdx++;
          if(slNoteIdx>=currentSong.notes.length){
            setTimeout(function(){
              document.getElementById('sl-complete-box').style.display='block';
              document.getElementById('sl-complete-msg').textContent=slMode==='songplay'?'You played the whole song!':'You learned the whole song!';
            },700);
          } else {
            setTimeout(function(){slSustainCount=0;slState='idle';renderSongLearnNote();},700);
          }
        } else {
          document.getElementById('sl-card').style.borderColor='rgba(248,113,113,0.5)';
          document.getElementById('sl-feedback').textContent=slMode==='songlearn'?'Not quite — try again':'Wrong note';
          document.getElementById('sl-feedback').style.color='#f87171';
          renderStaffOnSvg('sl-staff-svg',target,'wrong');
          setTimeout(function(){
            slSustainCount=0;slState='idle';
            document.getElementById('sl-card').style.borderColor='rgba(250,204,21,0.2)';
            document.getElementById('sl-feedback').textContent='Play the note on your violin';
            document.getElementById('sl-feedback').style.color='rgba(255,255,255,0.4)';
            renderStaffOnSvg('sl-staff-svg',target,'neutral');
          },slMode==='songlearn'?1500:800);
        }
        setTimeout(function(){if(slState==='cooldown')slState='idle';},COOLDOWN_MS);
      }
    }
  }
  loop();
}

// V1.1 - restore this: Song Library / Song Learn navigation handlers
// document.getElementById('btn-songlearn').addEventListener('click',function(){ambStop();buildSongList();showScreen('songselect');});
// document.getElementById('btn-more-songs').addEventListener('click',function(){ambStop();buildSongList();showScreen('songselect');});
document.getElementById('sl-exit-btn').addEventListener('click',function(){
  slStopListen();
  if(slAnimFrame){cancelAnimationFrame(slAnimFrame);slAnimFrame=null;}
  ambStop();
  goHome();
});
document.getElementById('sl-back-btn').addEventListener('click',function(){
  slStopListen();
  if(slAnimFrame){cancelAnimationFrame(slAnimFrame);slAnimFrame=null;}
  buildSongList();showScreen('songselect');
});
function slStopListen(){
  console.trace('[AUDIO] slStopListen — slNoteIdx='+slNoteIdx+' slListenPlaying='+slListenPlaying);
  slListenPlaying=false;
  if(slListenTimer){clearTimeout(slListenTimer);slListenTimer=null;}
  slBackingStop();
  slBackingAudioStop();
  document.getElementById('sl-listen-play-btn').textContent='▶ Play Song';
}

function slBackingStop(){
  if(slBackingTimer){clearTimeout(slBackingTimer);slBackingTimer=null;}
  if(slBackingBeat3Timer){clearTimeout(slBackingBeat3Timer);slBackingBeat3Timer=null;}
  slBackingMeasureIdx=0;
}

// Plays piano chord for the measure that starts at noteIdx.
// Called directly from slPlayListenNote so chord and melody fire on the same tick — no drift.
// Only used for songs without a dedicated backingTrack audio file.
function slPlayBackingChord(noteIdx){
  if(!currentSong||!currentSong.measures||currentSong.backingTrack)return;
  var piano=window.pianoSampler;
  if(!piano)return;
  var measure=null;
  for(var i=0;i<currentSong.measures.length;i++){
    var m=currentSong.measures[i];
    if(m.noteIndices&&m.noteIndices[0]===noteIdx){measure=m;break;}
  }
  if(!measure||!measure.backing||!measure.backing.length)return;
  piano.resume();
  measure.backing.forEach(function(n){piano.playNote(n,{volume:0.18});});
  console.log('[AUDIO] chord noteIdx='+noteIdx+' ['+measure.backing.join(',')+']');
  // Beat 3 (4/4 only): root at lower volume, 2 beats later
  if(slBackingBeat3Timer){clearTimeout(slBackingBeat3Timer);slBackingBeat3Timer=null;}
  var timeSig=currentSong.timeSig||{beats:4};
  if(timeSig.beats===4){
    var root=measure.backing[0];
    slBackingBeat3Timer=setTimeout(function(){
      if(!slListenPlaying)return;
      piano.playNote(root,{volume:0.12});
    },Math.round(2*(60000/slListenBpm)));
  }
}

async function slBackingAudioStart(){
  slBackingAudioStop();
  // Wait for decode to finish if it's still in progress (e.g. tap came in fast)
  if(slBackingDecodePromise){
    console.log('[AUDIO] waiting for backing track decode…');
    await slBackingDecodePromise;
  }
  if(!slBackingAudioBuffer){console.warn('[AUDIO] backing buffer not ready');return;}
  var ctx=getCtx();
  var source=ctx.createBufferSource();
  source.buffer=slBackingAudioBuffer;
  source.loop=true;
  source.connect(ctx.destination);
  source.start(0);
  slBackingSource=source;
  console.log('[AUDIO] backing track start (Web Audio)');
}

function slBackingAudioStop(){
  if(slBackingSource){
    try{slBackingSource.stop();}catch(_){}
    slBackingSource=null;
    console.log('[AUDIO] backing track stop');
  }
}

function slPlayListenNote(){
  var total=currentSong?currentSong.notes.length:0;
  var half=total>0&&slNoteIdx>=Math.floor(total/2);
  console.log('[AUDIO] slPlayListenNote idx='+slNoteIdx+'/'+total+(half?' [SECOND HALF]':'')+' | playing='+slListenPlaying);
  if(!currentSong||!slListenPlaying)return;
  if(slNoteIdx>=currentSong.notes.length){
    slListenPlaying=false;
    slBackingStop();
    slBackingAudioStop();
    document.getElementById('sl-listen-play-btn').textContent='▶ Play Song';
    setTimeout(function(){
      document.getElementById('sl-complete-box').style.display='block';
      document.getElementById('sl-complete-msg').textContent='Finished listening!';
    },300);
    return;
  }
  var prevNote=slNoteIdx>0?currentSong.notes[slNoteIdx-1]:null;
  renderSongLearnNote();
  var note=currentSong.notes[slNoteIdx];
  renderStaffOnSvg('sl-staff-svg',note,'correct');
  if(prevNote===note){var nn=document.getElementById('sl-note-name');if(nn){nn.classList.remove('note-flash');void nn.offsetWidth;nn.classList.add('note-flash');}var slsvg=document.getElementById('sl-staff-svg');if(slsvg){var ell=slsvg.querySelector('ellipse');if(ell){ell.setAttribute('fill','#ffd93d');setTimeout(function(){ell.setAttribute('fill','#fff');},300);}}}
  var noteDur=(currentSong.durations&&currentSong.durations[slNoteIdx])||1;
  console.log('[AUDIO] slListen playing note: '+note+' dur='+noteDur+' bpm='+slListenBpm);
  slPlayBackingChord(slNoteIdx); // play piano chord if this note starts a new measure
  violinSampler.playNote(note,{volume:0.3});
  slNoteIdx++;
  buildSlDots();
  slListenTimer=setTimeout(slPlayListenNote,Math.round((60000/slListenBpm)*noteDur));
}

['sl-mode-listen','sl-mode-songlearn','sl-mode-songplay'].forEach(function(id){
  document.getElementById(id).addEventListener('click',function(){
    ambStop();
    slMode=this.dataset.mode;
    ['sl-mode-listen','sl-mode-songlearn','sl-mode-songplay'].forEach(function(bid){
      document.getElementById(bid).classList.toggle('active',bid===id);
    });
    slNoteIdx=0;slState='idle';slSustainCount=0;slListenPlaying=false;
    if(slListenTimer){clearTimeout(slListenTimer);slListenTimer=null;}
    slBackingStop();slBackingAudioStop();
    if(slAnimFrame){cancelAnimationFrame(slAnimFrame);slAnimFrame=null;}
    document.getElementById('sl-complete-box').style.display='none';
    var isListen=slMode==='listen';
    var isSongPlay=slMode==='songplay';
    document.getElementById('sl-listen-controls').style.display=isListen?'block':'none';
    document.getElementById('sl-songplay-msg').style.display=isSongPlay?'block':'none';
    document.getElementById('sl-vol-meter-wrap').style.display=isListen?'none':'';
    document.getElementById('sl-controls-row').style.display=isListen?'none':'';
    if(!isListen){
      renderSongLearnNote();
      if(!micGranted){startMic().then(function(){startSongLearnLoop();});}else{startSongLearnLoop();}
    } else {
      renderSongLearnNote();
    }
  });
});

document.getElementById('sl-listen-bpm').addEventListener('input',function(){
  slListenBpm=parseInt(this.value,10);
  document.getElementById('sl-listen-bpm-display').textContent=slListenBpm+' BPM';
});

var _listenPlayBtnLastTap=0;
document.getElementById('sl-listen-play-btn').addEventListener('click',async function(e){
  console.log('[AUDIO] play-btn click event — slListenPlaying='+slListenPlaying+' isTrusted='+e.isTrusted+' t='+Date.now());
  // Debounce: iOS WebView fires a ghost click 300-500ms after the real tap.
  // Guard with 600ms window so the ghost can never toggle state immediately after start/stop.
  var now=Date.now();
  if(now-_listenPlayBtnLastTap<600)return;
  _listenPlayBtnLastTap=now;

  if(slListenPlaying){
    slStopListen();
  } else {
    ambStop();
    slListenPlaying=true;
    slNoteIdx=0;
    document.getElementById('sl-complete-box').style.display='none';
    this.textContent='⏹ Stop';
    if(currentSong&&currentSong.backingTrack){
      // Await decode so backing track and melody start at exactly t=0
      await slBackingAudioStart();
    }
    // Piano chords (for songs without a backingTrack file) are now triggered
    // directly inside slPlayListenNote via slPlayBackingChord() — no separate timer.
    slPlayListenNote();
  }
});
document.getElementById('sl-replay-btn').addEventListener('click',function(){
  slNoteIdx=0;slState='idle';slSustainCount=0;
  document.getElementById('sl-complete-box').style.display='none';
  renderSongLearnNote();
});
document.getElementById('sl-songs-btn').addEventListener('click',function(){slStopListen();if(slAnimFrame){cancelAnimationFrame(slAnimFrame);slAnimFrame=null;}buildSongList();showScreen('songselect');});
document.getElementById('sl-tune-btn').addEventListener('click',function(){document.getElementById('tuner-modal').classList.add('active');if(micGranted){startTunerLoop();}else{startMic().then(function(){startTunerLoop();});}});
document.getElementById('sl-demo-btn').addEventListener('click',function(){
  if(!currentSong)return;
  var note=currentSong.notes[slNoteIdx];if(!note||!NOTE_FREQ[note])return;
  violinSampler.playNote(note,{volume:0.25});
});
document.getElementById('sl-mic-dot').addEventListener('click',function(){
  if(!micGranted){startMic().then(function(){document.getElementById('sl-mic-dot').style.background='#4ade80';document.getElementById('sl-mic-label').textContent='Mic active';startSongLearnLoop();});}
});


})();
`;

export default function App() {
  useEffect(() => {
    const style = document.createElement('style');
    style.textContent = CSS;
    document.head.appendChild(style);
    const root = document.getElementById('oa-root');
    if (root) root.innerHTML = HTML;
    window.violinSampler = violinSampler; // expose to GAME_SCRIPT global scope
    window.pianoSampler  = pianoSampler;  // expose piano sampler for backing tracks
    const script = document.createElement('script');
    script.textContent = GAME_SCRIPT;
    document.body.appendChild(script);
    return () => { style.remove(); script.remove(); if (root) root.innerHTML = ''; };
  }, []);
  return <div id="oa-root" />;
}